export const tr = {
  mcs: {
  "title": "MCS hazırlığı",
  "context": "ICF Mentor Koç Uzmanlığı için kendi hazırlığınız — mentilerinizin unvan ilerlemesinden ayrıdır",
  "disclaimer": "MCAi yalnızca hazırlık ve belgelendirmeye yardımcı olur. Buradaki hiçbir şey ICF onayı, unvan, geçerli eğitim veya mentorun profesyonel incelemesinin yerine geçmez.",
  "linkCard": "Kendiniz MCS’ye mi hazırlanıyorsunuz? → MCS hazırlığı",
  "routeLevels": "Başvuru yolu ve seviyeler",
  "routes": {
    "standard": "Standart",
    "prior_learning": "Önceki öğrenmenin tanınması"
  },
  "standardDescription": "Standart: mentor koçluk eğitiminizi ve seviyeye özel eğitimleri kaydedin.",
  "priorDescription": "Önceki öğrenme: ilgili eğitim ve mentorluk deneyimini kaydedin; değerlendirme eğitimi sayılan saatlere dahil değildir.",
  "targetLevels": "Hedef seviyeler",
  "credentialType": "Unvan türü",
  "credentialStatus": "Unvan durumu",
  "accRenewed": "ACC yenilendi",
  "checklist": "Kontrol listesi",
  "checklistSaved": "Kontrol listesi son kaydı gösterir. Yeniden hesaplamak için kaydedin.",
  "progress": "{{done}} tamamlandı · {{todo}} yapılacak · {{needsAttention}} dikkat gerekiyor · {{notApplicable}} uygulanamaz",
  "hoursSummary": "Toplam {{total}} sa · Canlı {{synchronous}} sa · Asenkron {{asynchronous}} sa · Değerlendirme eğitimi {{evaluation_training_hours}} sa · Sayılan {{counted_for_route}} sa",
  "general": "Genel",
  "officialGuidance": "Resmi rehber",
  "education_entries": "Eğitim kayıtları",
  "evaluation_trainings": "Seviyeye göre değerlendirme eğitimi",
  "experience_entries": "Mentorluk deneyimi",
  "reflections": "Mentorluk görüşmeleriniz üzerine yansımalar",
  "reflectionNote": "MCAi mentor koçluk yetkinliklerini otomatik değerlendirmez. Bu alan yapılandırılmış yansıma ve insan incelemesi içindir.",
  "providerLetter": "Eğitim sağlayıcısının mektubu mevcut",
  "ambiguities": "ICF’nin henüz netleştirmedikleri",
  "unsaved": "Kaydedilmemiş değişiklikler",
  "upToDate": "Tüm değişiklikler kaydedildi",
  "save": "Kaydet",
  "saving": "Kaydediliyor…",
  "saved": "Hazırlık kaydedildi.",
  "saveError": "Hazırlık kaydedilemedi. Değişiklikleriniz duruyor. Tekrar deneyin.",
  "retry": "Hazırlık yüklenemedi. Tekrar dene",
  "linkError": "Rehber bağlantısı açılamadı.",
  "add": "Ekle",
  "edit": "Düzenle",
  "remove": "Kaldır",
  "apply": "Kaydı uygula",
  "cancel": "Vazgeç",
  "hours": "saat",
  "validation": "Gerekli başlık/kurs veya yansımayı, negatif olmayan saati ve geçerli tarihleri (YYYY-MM-DD) girin.",
  "summary": "MCS hazırlık özeti",
  "summaryError": "Özet yüklenemedi.",
  "emptySummary": "Henüz kohort üyesi yok.",
  "statuses": {
    "active": "Aktif",
    "renewed": "Yenilenmiş",
    "lapsed": "Süresi dolmuş",
    "done": "Tamamlandı",
    "todo": "Yapılacak",
    "needs_attention": "Dikkat gerekiyor",
    "not_applicable": "Uygulanamaz"
  },
  "items": {
    "eligible_credential": "Uygun unvan",
    "education_hours": "Eğitim saatleri",
    "evaluation_training": "Değerlendirme eğitimi",
    "experience_five_mentees": "Beş menti",
    "application": "Başvuru",
    "renewal_plan": "Yenileme planı",
    "other": "Gereklilik"
  },
  "fields": {
    "title": "Başlık",
    "provider": "Eğitim sağlayıcısı",
    "hours": "Saat",
    "synchronous": "Senkron (canlı)",
    "is_icf_evaluation_training": "ICF değerlendirme eğitimi",
    "completed_on": "Tamamlanma tarihi (YYYY-MM-DD, isteğe bağlı)",
    "evidence_note": "Kanıt notu",
    "level": "Seviye",
    "course": "Kurs",
    "kind": "Deneyim türü",
    "label": "Ad / etiket",
    "credential_earned_on": "Unvan tarihi (YYYY-MM-DD, isteğe bağlı)",
    "note": "Not",
    "text": "Yansıma",
    "created_at": "Tarih (YYYY-MM-DD)"
  },
  "kinds": {
    "credentialed_client": "Unvan kazanmış danışan",
    "program_student": "Program öğrencisi"
  },
  "notes": {
    "transition_dates": "Geçiş tarihleri",
    "level_1_2_scope": "Seviye 1/2 kapsamı",
    "jan_apr_overlap": "Ocak–Nisan örtüşmesi",
    "mcc_crf_submission": "MCC CRF teslimi",
    "renewal": "Yenileme",
    "disclaimer": "Bilgilendirme"
  }
},
  billingRecovery: {
    paymentTitle: 'Ödemenizle ilgilenmeniz gerekiyor',
    paymentMessage: 'Planınız ve verileriniz duruyor. İkinci bir abonelik başlatmadan erişimi geri almak için ödeme yönteminizi güncelleyin.',
    unavailableTitle: 'Faturalamayı şu anda doğrulayamadık',
    unavailableMessage: 'Bu geçici bir bağlantı sorunu. Planınızı yeniden satın almanızı istemeyeceğiz.',
    updatePayment: 'Ödeme yöntemini güncelle',
    retry: 'Tekrar dene',
    signOut: 'Çıkış yap',
    portalError: 'Faturalama yönetimini açamadık. Lütfen bir dakika sonra tekrar deneyin.',
  },
  invitePerson: {
    tabs: {
      student: 'Öğrenci',
      mentor: 'Mentör',
      admin: 'Yönetici',
      billing: 'Fatura yetkilisi'
    },
    student: {
      capabilityTitle: 'Bu kişi ne yapabilir?',
      cap1: 'Oturumlarını yükler',
      cap2: 'Mentörle paylaşabilir',
      cap3: 'Kendi ilerlemesini görür',
      hintTitle: 'Rol hakkında',
      hintBody: 'Öğrenciler kendi oturumlarını yönetir ve mentörleriyle paylaşımlar yapabilir.',
      submit: 'Davet gönder',
      submitting: 'Gönderiliyor…',
      successTitle: 'Davet gönderildi',
      successMessage: 'Öğrenci davet edildi. Davet e-postası kuyruğa alındı.',
      errorMessage: 'Öğrenci davet edilirken bir hata oluştu.',
      footerHint: 'Davet gönderilmeden önce bilgiler kontrol edilir.'
    },
    errorTitle: 'Davet gönderilemedi',
    activePersonalSubscriptionWarning: 'Bu kişinin aktif bir bireysel aboneliği olan bir hesabı var. Okulunuza katılması bu aboneliği iptal etmez; isterse fatura ayarlarından kendisi iptal edebilir.',
    mentor: {
      capabilityTitle: 'Bu kişi ne yapabilir?',
      cap1: 'Paylaşılan oturumları inceler',
      cap2: 'Yapılandırılmış geri bildirim verir',
      cap3: 'Kohort ilerleyişini takip eder',
      hintTitle: 'Rol hakkında',
      hintBody: 'Mentörler yalnızca öğrencilerin paylaştığı oturumları görür.',
      submit: 'Davet gönder',
      submitting: 'Gönderiliyor…',
      successTitle: 'Mentör daveti gönderildi',
      successMessage: 'Mentör daveti e-posta ile gönderildi.',
      errorMessage: 'Mentör davet edilirken bir hata oluştu.',
      footerHint: 'Mentör tek kullanımlık davet bağlantısı alır.'
    },
    admin: {
      capabilityTitle: 'Bu kişi ne yapabilir?',
      cap1: 'Öğrenci ve mentör davet eder',
      cap2: 'Çerçeve ve kohortları yönetir',
      cap3: 'Okul raporlarına erişir',
      hintTitle: 'Rol hakkında',
      hintBody: 'Yöneticiler okul ayarlarına tam erişim alır. Dikkatli ekleyin.',
      submit: 'Yönetici oluştur',
      submitting: 'Oluşturuluyor…',
      successTitle: 'Yönetici eklendi',
      successMessage: 'Yönetici hesabı oluşturuldu.',
      errorMessage: 'Yönetici eklenirken bir hata oluştu.',
      footerHint: 'Yönetici oluşturulduğu anda tam okul erişimi alır.'
    },
    billing: {
      capabilityTitle: 'Bu kişi ne yapabilir?',
      cap1: 'Stripe checkout tamamlar',
      cap2: 'Faturaları ve ödemeleri yönetir',
      cap3: 'Koltuk sayılarını ayarlar',
      hintTitle: 'Rol hakkında',
      hintBody: 'Fatura yetkilileri yalnızca finansal işlemleri görür. Öğrenci ya da oturum verilerine erişmez.',
      submit: 'Fatura yetkilisi oluştur',
      submitting: 'Oluşturuluyor…',
      successTitle: 'Fatura yetkilisi eklendi',
      successMessage: 'Fatura yetkilisi oluşturuldu.',
      errorMessage: 'Fatura yetkilisi eklenirken bir hata oluştu.',
      footerHint: 'Stripe checkout bağlantısı gerekirse otomatik üretilir.',
      openCheckoutPrompt: 'Stripe checkout sayfasını şimdi aç?',
      openCheckout: 'Ödemeyi aç'
    },
    validation: {
      nameRequired: 'Ad soyad gerekli.',
      emailInvalid: 'Geçerli bir e-posta yaz.'
    },
    title: 'Kişi davet et',
    subtitle: 'Okul hesabına yeni kullanıcı ekle. Davet e-postası otomatik gönderilir.',
    fields: {
      name: 'Ad Soyad',
      namePlaceholder: 'Örn. Ayşe Yılmaz',
      email: 'E-posta',
      emailPlaceholder: 'ayse.yilmaz@ornek.com',
      password: 'Geçici şifre (opsiyonel)',
      passwordPlaceholder: 'En az 8 karakter',
      passwordHint: 'Boş bırakırsan davet bağlantısı gönderilir.'
    },
    cancel: 'Vazgeç'
  },
  cohortSettings: {
    title: 'Kohort ayarları',
    programLevel: 'Eğitim programı seviyesi',
    programLevelHint: 'ICF 2022\'de ACTP/ACSTH\'yi numaralı Seviye 1/2/3 sistemiyle değiştirdi. Eğitim programınızın hangi sertifikaya hazırladığını seçin.',
    noLevel: 'Belirtilmedi',
    features: 'Bu kohorta açık özellikler',
    featuresHint: 'Sadece burada açtığınız özellikler bu kohortun öğrencilerine kenar çubuğunda görünür.',
    noFeatures: 'Henüz açılabilir özellik yok.',
    cancel: 'Vazgeç',
    save: 'Kaydet'
  },
  voice: {
    fileTooLarge: 'Dosya çok büyük. Maksimum boyut {{max}} MB.'
  },
  // Language Selection

  // In-app upgrade paywall
  upgrade: {
    title: 'Bu özelliği aç',
    subtitle: 'Tam erişim için planını yükselt.',
    unlocks: 'Şunu açar',
    packageLabel: 'Şu pakette',
    cta: 'Şimdi yükselt',
    maybeLater: 'Belki sonra',
    perMonth: '/ay',
    cyclePicker: 'Ödeme dönemini seç',
    save: '%{{pct}} tasarruf',
    cycle: {
      '1mo': 'Aylık',
      '3mo': '3 ay',
      '6mo': '6 ay',
    },
    feature: {
      levelSelect: 'ICF seviye seçimi',
      markerTable: 'gösterge kanıt tablosu',
      customMode: 'özel analiz modu',
      observationPdf: 'ICF gözlem formu dışa aktarımı',
      icfProgress: 'ICF ilerleme takibi',
      generic: 'bu özellik',
    },
    benefit: {
      tier2_1: 'Her analiz için hedef ICF seviyesini seç',
      tier2_2: 'Göstergeye dayalı ayrıntılı kanıt tablosu',
      tier2_3: 'ICF ilerlemeni zaman içinde takip et',
      tier3_1: 'Chasing Credentials paketindeki tüm özellikler',
      tier3_2: 'Özel analiz talimatları',
      tier3_3: 'ICF gözlem formu PDF dışa aktarımı',
    },
  },

  billing: {
    conflicts: {
      alreadySubscribedTitle: 'Abonelik zaten aktif',
      alreadySubscribedMessage: 'Zaten aktif bir aboneliğiniz var. Yeni ödeme başlatmak yerine mevcut planınızı güncelleyin.',
      resumeAvailableTitle: 'Aboneliğini devam ettir',
      resumeAvailableMessage: 'Bu abonelik dönem sonunda iptal edilecek şekilde ayarlanmış. Yeni abonelik oluşturmadan erişimini korumak için devam ettir.',
      pendingCancellationTitle: 'Mevcut aboneliğini kullan',
      pendingCancellationMessage: 'Aboneliğin dönem sonunda iptal edilecek. İkinci bir abonelik başlatmak yerine mevcut planı değiştir.',
      resumeAction: 'Devam ettir',
      changePlanAction: 'Plan değiştir',
      dismissAction: 'Şimdi değil',
      resumeSuccessTitle: 'Abonelik devam ettirildi',
      resumeSuccessMessage: 'Aboneliğin mevcut dönem sonunda devam edecek.',
      changePlanSuccessTitle: 'Abonelik güncellendi',
      changePlanSuccessMessage: 'Mevcut aboneliğin güncellendi.',
      subscriptionGoneTitle: 'Aboneliğiniz sona ermiş',
      subscriptionGoneMessage: 'Önceki aboneliğiniz sona erdi. Yeni bir abonelik başlatmak için bir plan seçin.',
      introOfferUnavailableTitle: 'Tanışma denemesi kullanılamıyor',
      introOfferUnavailableMessage: 'Bu hesabın önceki abonelik veya deneme geçmişi var. Fiyatı inceleyip hemen ödemeyle başlamak için Devam düğmesine tekrar dokunun.',
      introCheckoutInProgressTitle: 'Deneme ödemesi zaten açık',
      introCheckoutInProgressMessage: 'Deneme ödeme ekranın zaten açık veya hâlâ hazırlanıyor. Tamamla, kapat ya da kısa bir süre sonra tekrar dene.',
    },
    checkout: {
      startTrialTitle: '{{days}} Günlük Denemeni Başlat',
      completeTitle: 'Aboneliğini Tamamla',
      preparing: 'Ödeme hazırlanıyor...',
      initFailed: 'Ödeme başlatılamadı',
      actionRequired: 'Devam etmek için Devam ettir veya Plan değiştir seçeneğini kullan.',
      retry: 'Tekrar Dene',
      loadingPaymentForm: 'Ödeme formu yükleniyor...',
      loadFailed: 'Güvenli ödeme formu yüklenemedi. Lütfen tekrar deneyin.',
      noCheckoutUrl: 'Ödeme bağlantısı alınamadı',
      failureTitle: 'Ödeme başlatılamadı',
      failureMessage: 'Güvenli ödeme ekranını açamadık. Tekrar deneyin.',
      failureEscalated: 'Ödeme birkaç kez başarısız oldu. Başka bir ödeme yöntemi deneyin veya sorun sürerse destekle iletişime geçin.',
    },
    comebackOffer: {
      title: 'Tekrar hoş geldin',
      subtitle: 'Planlarımıza baktığından bir süre geçti — ilk fatura döneminde %30 indirim bizden.',
      cta: '%30 indirimimi al',
      dismissA11y: 'Teklifi kapat',
      appliedBadge: 'Ödeme sırasında %30 indirim uygulanacak',
    },
    finalOffer: {
      title: 'Bu son teklifimiz',
      subtitle: "Students veya Chasing Credentials planında ilk ay {{price}} — hemen öde, deneme yok.",
      cta: 'İlk ayı {{price}} karşılığında al',
      dismissA11y: 'Teklifi kapat',
      renewalNotice: 'İlk aydan sonra {{price}}/ay olarak yenilenir. İstediğin zaman iptal edebilirsin.',
      appliedBadge: 'Ödeme sırasında ilk ay için {{price}} uygulanacak',
    },
  },

  // PDF export tool
  pdfExport: {
    title: 'PDF Dışa Aktarma Aracı',
    subtitle: 'Koçluk raporlarını PDF olarak oluştur ve dışa aktar',
    titleLabel: 'Rapor başlığı',
    titlePlaceholder: 'Rapor başlığını gir...',
    titleDefault: 'Koçluk Raporu',
    headerName: 'Ad',
    headerCategory: 'Kategori',
    headerNotes: 'Notlar',
    tableData: 'Tablo Verisi',
    loadSample: 'Örnek Yükle',
    columnHeaders: 'Sütun Başlıkları',
    dataRows: 'Veri Satırları',
    rowLabel: 'Satır {{n}}',
    headerPlaceholder: 'Başlık {{n}}',
    cellPlaceholder: 'Hücre {{n}}',
    addColumn: 'Sütun ekle',
    addRow: 'Satır ekle',
    exporting: 'Dışa aktarılıyor...',
    exportButton: 'PDF olarak dışa aktar',
    dialogTitle: 'PDF Raporunu Dışa Aktar',
    errorTitle: 'Hata',
    successTitle: 'Başarılı',
    errorMinColumn: 'Tabloda en az bir sütun olmalı',
    errorMinRow: 'Tabloda en az bir satır olmalı',
    errorNeedTitle: 'Lütfen rapor için bir başlık girin',
    saveSuccess: 'PDF kaydedildi: {{path}}',
    saveFailed: 'PDF dosyası kaydedilemedi',
    exportFailed: 'PDF dışa aktarılamadı',
  },

  // Common
  common: {
    unknown: 'Bilinmiyor',
    continue: 'Devam et',
    minutesShort: 'dk',
    remaining: 'kaldı',
    downloadFailed: 'İndirme başarısız oldu',
    failed: 'Başarısız',
    ok: 'Tamam',
    create: 'Oluştur',
    noResults: 'Sonuç bulunamadı',
    secure: 'Güvenli',
    loading: 'Yükleniyor...',
    saving: 'Kaydediliyor...',
    error: 'Hata',
    success: 'Başarılı',
    cancel: 'İptal',
    confirm: 'Onayla',
    save: 'Kaydet',
    delete: 'Sil',
    edit: 'Düzenle',
    search: 'Ara',
    filter: 'Filtrele',
    refresh: 'Yenile',
    retry: 'Tekrar Dene',
    back: 'Geri',
    next: 'İleri',
    done: 'Tamam',
    close: 'Kapat',
    yes: 'Evet',
    no: 'Hayır',
    info: 'Bilgi',
    and: 've',
    accessDenied: 'Erişim engellendi',
    noData: 'Veri bulunamadı',
    loadError: 'Veriler yüklenemedi',
    optional: 'Opsiyonel',
    view: 'Görüntüle',
    remove: 'Kaldır',
    send: 'Gönder',
    invite: 'Davet Et',
    share: 'Paylaş',
    open: 'Aç',
  },

  // Navigation
  navigation: {
    dashboard: 'Ana sayfa',
    chat: 'Sohbet',
    sessions: 'Oturumlar',
    progress: 'İlerleme',
    documents: 'Belgeler',
    platformAdmin: 'Platform yönetimi',
    schoolManagement: 'Okul yönetimi',
    schoolAdmin: 'Okul yöneticisi',
    transcripts: 'Transkriptler',
    myDocuments: 'Belgelerim',
    students: 'Üyeler',
    profile: 'Profil',
    mentorTraining: 'Mentor Koç Eğitimi',
    mentorEngagements: 'Mentiler',
    settings: 'Ayarlar',
    adminSection: 'Yönetim',
    logout: 'Çıkış',
    more: 'Daha fazla',
    help: 'Yardım',
    // Yeni 5-sekme yapısı
    home: 'Ana sayfa',
    library: 'Kütüphane',
    aiChat: 'Mentor Coaching AI',
  },

  shell: {
    recentSessions: 'Son oturumlar',
    noSessions: 'Henüz oturum yok',
    trustTitle: 'Koçluk verilerin senin kontrolünde.',
    trustCopy: 'Güvenli, gizli ve ICF etik kurallarına uygun.',
  },

  invitations: {
    title: 'Öğrenci Davetleri',
    pendingSection: 'Bekleyen Davetler ({{count}})',
    legacySection: 'Eski Bekleyen ({{count}})',
    noPending: 'Bekleyen davet bulunamadı.',
    noLegacy: 'Eski tip bekleyen davet yok.',
    expires: 'Son kullanma: {{date}}',
    awaiting: 'Kabul bekleniyor',
    invited: 'Davet Edildi',
    invitedStatus: 'Davet gönderildi',
    actions: {
      resend: 'Yeniden Gönder',
      resendInvitation: 'Daveti Yeniden Gönder',
      cancel: 'İptal Et',
      recount: 'Öğrenci Sayısını Yenile',
      resentTitle: 'Davet Yenilendi',
      resentBody: 'Davet bağlantısı güncellendi.',
      recountDone: 'Yeniden Sayım Tamamlandı',
      recountFromTo: 'Güncellendi: {{prev}} → {{next}}',
      cancelConfirm: 'Bu daveti iptal etmek istediğinize emin misiniz?',
    }
  },

  // Feedback
  feedback: {
    button: 'Geri Bildirim',
    modalTitle: 'Geri Bildirim Gönder',
    modalDescription: 'Bir şeyler tuhaf mı görünüyor? Her notu okuyoruz. Lütfen ne olduğunu anlatın.',
    categories: {
      bug: 'Hata bildir',
      suggestion: 'İyileştirme öner',
      praise: 'Tebrik gönder',
      question: 'Soru sor',
      other: 'Diğer',
    },
    messagePlaceholder: 'Detayları paylaş…',
    autoContextNote: 'Bulunduğunuz ekranı ve cihaz bilgilerini otomatik olarak ekliyoruz.',
    cancel: 'Vazgeç',
    submit: 'Gönder',
    submitting: 'Gönderiliyor…',
    successTitle: 'Teşekkürler!',
    successMessage: 'Geri bildiriminiz gelişmemize yardımcı oluyor.',
    errorTitle: 'Hata',
    errorMessage: 'Geri bildirimi gönderirken bir sorun oluştu. Lütfen tekrar deneyin.',
    errorTooShort: 'Size yardımcı olabilmemiz için birkaç cümle paylaşın lütfen.',

    // Yönetici Paneli
    management: {
      title: 'Kullanıcı Geri Bildirimleri',
      subtitle: 'toplam gönderim',
      searchPlaceholder: 'Mesaj veya e-posta ile ara...',
      filterByCategory: 'Kategoriye Göre Filtrele',
      filterByPlatform: 'Platforma Göre Filtrele',
      all: 'Tümü',
      deleteTitle: 'Geri Bildirimi Sil',
      deleteMessage: 'Bu geri bildirimi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
      deleteSuccess: 'Geri bildirim başarıyla silindi',
      deleteError: 'Geri bildirim silinemedi',
      noFeedback: 'Henüz geri bildirim yok',
      noFeedbackFiltered: 'Filtrelerinize uygun geri bildirim bulunamadı',
      page: 'Sayfa',
      of: '/',
    },
  },

  // Terms Acceptance
  terms: {
    title: 'Şartlar ve Gizlilik',
    subtitle: 'Devam etmeden önce lütfen şartlarımızı inceleyin ve kabul edin',
    summary: 'Mentor Coaching AI kullanarak, platformun kullanımını düzenleyen Hizmet Şartlarımızı ve kişisel verilerinizi ve koçluk oturumu bilgilerinizi nasıl topladığımızı, kullandığımızı ve koruduğumuzu açıklayan Gizlilik Politikamızı kabul etmiş olursunuz.',
    agreeLabel: 'Hizmet Şartlarını ve Gizlilik Politikasını okudum ve kabul ediyorum',
    continue: 'Devam Et',
    acceptError: 'Şartlar kabul edilemedi. Lütfen tekrar deneyin.',
  },

  onboarding: {
    appName: 'Mentor Coaching AI',
    skipTour: 'Turu geç',
    back: 'Geri',
    next: 'İleri',
    continueToPlans: 'Planlara devam et',
    continueToIntake: 'Devam et — birkaç kısa soru',
    continueToDashboard: 'Panoya geç',
    proceedToPayment: 'Ödemeye Devam Et',
    securePayment: 'Güvenli ödeme • İstediğiniz zaman iptal • 14 gün içinde para iade garantisi',
    infoMessage: 'Bu turu istediğiniz zaman Ayarlar → Yardım & Destek bölümünden yeniden açabilirsiniz. Geri bildiriminize göre deneyimi geliştirmeye devam ediyoruz.',
    journey: {
      part1: 'MCAi’yi tanıma — 1 / 2',
      part2: 'Planını kişiselleştirme — 2 / 2',
    },
    completionErrorTitle: 'Onboarding tamamlanamadı',
    completionErrorMessage: 'İlerlemen duruyor. Devam etmek için tekrar dene.',
    slides: {
      welcome: {
        title: 'Hoş geldin',
        titleWithPlan: '{{plan}} planın hazır',
        description: 'Seni hazırlamadan önce diğer tarafta neler olduğuna kısaca bakalım.',
      },
      transcript: {
        title: 'Saatler değil, dakikalar içinde mentör seviyesi geri bildirim',
        description: 'Koçluk oturumları için özel olarak geliştirilmiş transkripsiyon akışına ses yükle; ardından ICF yetkinliklerine dayalı analiz, geri bildirim notları ve gelişim önerileri al. Mentör koçlar oturum başına 2–3 saat kazanır.',
      },
      demo: {
        title: 'İlk raporunun nasıl göründüğünü gör',
        description: 'Anonimleştirilmiş gerçek bir oturum ve ondan çıkan analiz — ilk yüklemeden ne çıkacağını net bil.',
        cta: 'Örnek raporu göster',
        skip: 'Atla',
        modalTitle: 'Örnek rapor',
        tabTranscript: 'Transkript',
        tabAnalysis: 'Analiz',
        close: 'Kapat',
      },
      featureMap: {
        title: 'Mentör seansları arasında ihtiyacın olan her şey',
        description: 'Üyeliğin her oturumu uygulanabilir geri bildirim, ilerleme ve sonraki adım araçlarıyla birleştirir.',
        trialConfirmation: 'Gerçek bir oturumla başla. Denemen güvenli ve özeldir; istediğin zaman iptal edebilirsin.',
        nextUp: 'Sırada: İlk analizini sana göre ayarlamak için 4 kısa soru.',
        items: {
          voice: { label: 'Koçluğa özel transkripsiyon', line: 'Koçluk oturumları için geliştirildi', detail: 'Koçluk konuşmaları için özel geliştirilen akış; konuşmacı ayrımı, koç/danışan etiketleri ve analize hazır çıktı sunar. Sesi yükle ve doğrudan geri bildirime geç.' },
          analysis: { label: 'ICF analizi', line: 'Yetkinlik ve işaretçi geri bildirimi', detail: 'Her ICF yetkinliği için güçlü yönleri, gelişim alanlarını ve transkripte dayalı kanıtları gör.' },
          progress: { label: 'İlerleme takibi', line: 'Oturumlar boyunca gelişim', detail: 'Dahil etmeyi seçtiğin oturumlarda hazırlık seviyeni ve tekrar eden örüntüleri takip et.' },
          development: { label: 'Gelişim planı', line: 'Odaklı pratik adımları', detail: 'Her raporu bir sonraki mentör seansından önce uygulayabileceğin kısa bir plana dönüştür.' },
          export: { label: 'PDF ve DOCX dışa aktarım', line: 'Saklayabileceğin raporlar', detail: 'Raporları ve kanıtları mentörünle kolayca inceleyebileceğin formatlarda dışa aktar.' },
          library: { label: 'Oturum kütüphanesi', line: 'Her şey tek yerde', detail: 'Akışı kaybetmeden transkriptlere, raporlara ve takip konuşmalarına geri dön.' },
          meeting: { label: 'Görüşme geri bildirimi', line: 'Yapılandırılmış gözlem notları', detail: 'Gerçek mentör koçluk görüşmeleri için kanıta dayalı gözlem notları ve gelişim soruları hazırla.' },
          chat: { label: 'AI mentör sohbeti', line: 'Her raporda takip soruları', detail: 'Oturumun, kanıtların veya gelişim planın hakkında rapor sohbetinde takip soruları sor.' },
        },
      },
      progress: {
        title: '3-5 değil, her oturumda geri bildirim',
        description: 'Çoğu koç ACC, PCC ya da MCC yolunda yalnızca birkaç oturum için değerlendirilir. Sen her oturumda gelişimini takip et, seviyeni neyin tuttuğunu gör ve mentör seansına daha keskin sorularla gel.',
      },
      methodology: {
        title: "Genel AI değil, ICF yetkinlik göstergelerine dayalı",
        description: "Geri bildirimin ICF'in kendi yetkinlik çerçevesine ve davranış göstergelerine dayanır; hedeflediğin seviyeye göre yapılandırılır — ACC, PCC ya da MCC. Kayıtların AES-256 ile şifreli, GDPR uyumlu kalır ve oturum içeriğini asla loglamayız.",
      },
      trial: {
        title: 'Gerçek bir oturumla risksiz dene',
        description: 'Tam erişimli ücretsiz denemeni başlat — yükle, puanla, sohbet et, takip et. İstediğin zaman iptal, 14 gün içinde para iade garantisi. Kayıtların AES-256 ile şifreli ve sana özel kalır.',
      },
      confirmation: {
        title: 'Birkaç hızlı soru, sonra ilk analizin',
        description: 'Hedef seviyeni (ACC/PCC/MCC), zorlandığın alanı ve koçluk sıklığını söyle. İlk analizini ilk andan sana göre ayarlayalım.',
      },
    },
  },

  sampleReport: {
    banner: 'Örnek rapor · MCAi tarafından analiz edilmiş kurgusal ve anonim demo oturumu',
    languageNotice: 'Bu örnek İngilizce ve Türkçe sunulur. Kendi raporların seçtiğin dilde oluşturulur.',
    close: 'Örnek raporu kapat',
    verdictEyebrow: 'SEVİYE KARARI',
    levelDecisionHeading: 'Seviye kararı',
    performingAt: 'Performans seviyesi',
    performingAtLevel: '{{level}} düzeyinde performans',
    sessionMeta: '{{minutes}} dk oturum · {{language}}',
    fictionalParticipants: 'Kurgusal katılımcılar: {{coach}} ve {{client}}',
    competencyHeading: 'ICF yetkinlik dökümü',
    competencySubheading: 'İşaretçi düzeyindeki kanıtı incelemek için bir yetkinliğe dokun.',
    evidenceHeading: 'Gözlemlenen kanıt',
    markerReferences: 'İşaretçi referansları',
    strengths: 'Gözlemlenen kanıt',
    developmentEdge: 'Gelişim alanı',
    noDevelopmentEvidence: 'Bu örnekte önemli bir gelişim örüntüsü tespit edilmedi.',
    confidence: '%{{percent}} güven',
    expandCompetency: '{{competency}} yetkinliğini aç',
    collapseCompetency: '{{competency}} yetkinliğini kapat',
    narrativeHeading: 'Anlatı geri bildirimi',
    sessionOverview: 'Oturum özeti',
    whatNext: 'Bir sonraki gelişim odağı',
    developmentPlanHeading: 'Gelişim planı önizlemesi',
    developmentPlanIntro: 'Bu oturumdan üretilen üç pratik',
    whyLabel: 'Neden',
    practiceLabel: 'Pratik',
    whyText: 'Neden: {{why}}',
    practiceText: 'Pratik: {{practice}}',
    transcriptHeading: 'İşaretçili transkript alıntısı',
    transcriptSubheading: 'Raporun geri bildirimi asıl konuşmaya nasıl bağladığını gör.',
    coachSpeaker: 'Koç',
    clientSpeaker: 'Müşteri',
    annotationLabel: 'Kanıt bağlantısı',
    transcriptSpeakerMeta: '{{timestamp}} · {{speaker}}',
    annotationText: 'Kanıt bağlantısı: {{marker}}',
    quotedEvidence: '“{{quote}}”',
    evidenceMeta: '{{timestamp}} · {{rationale}}',
    markerReferencesText: 'İşaretçi referansları: {{markers}}',
    includedHeading: 'Her analizde ayrıca şunları alırsın',
    includedExports: 'PDF/DOCX dışa aktarma',
    includedProgress: 'ICF ilerleme takibi',
    includedFollowup: 'AI mentor koçunla takip soruları',
    continueCta: 'Devam et',
    uploadCta: 'Oturumunu yükle',
    content: {
      competencies: {
        C1: {
          narrative: 'Etik sınırlar ve danışanın özerkliği oturum boyunca nettir.',
          positiveExamples: {
            0: {
              quote: 'Bu görüşmeyi bugün senin için faydalı kılacak şey ne olur?',
              rationale: 'Başlangıçtan itibaren danışanı sürecin sahibi olmaya davet eder.',
            },
          },
        },
        C2: {
          narrative: 'Koç, yansıtıcı öz yönetim sergiler.',
          positiveExamples: {
            0: {
              quote: 'Bunu senin için çözmek istediğimi fark ettim; bir an durayım.',
              rationale: 'Tavsiye verme dürtüsünü fark eder ve bırakır.',
            },
          },
        },
        C3: {
          narrative: 'Görüşme anlaşması somuttur ve danışanın istediği sonuçla bağlantısını korur.',
          positiveExamples: {
            0: {
              quote: 'Görüşmenin sonunda netliğe ulaşırsak senin için ne farklı olacak?',
              rationale: 'Oturum sonucunu gözlemlenebilir biçimde netleştirir.',
            },
          },
        },
        C4: {
          narrative: 'Danışana yargılanmadan sesli düşünme alanı verilir.',
          positiveExamples: {
            0: {
              quote: 'Acele etme. Burada doğru bir yanıt yok.',
              rationale: 'Psikolojik güvenliği ve düşünmeyi destekler.',
            },
          },
        },
        C5: {
          narrative: 'Koçun varlığı dengeli ve duyarlıdır; sonraki gelişim alanı güçlü sorulardan sonra sessizliği kullanmaktır.',
          positiveExamples: {
            0: {
              quote: 'Bununla otururken içinde neler oluyor?',
              rationale: 'Dikkati danışanın o andaki deneyimine getirir.',
            },
          },
          developmentExamples: {
            0: {
              quote: 'Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?',
              rationale: 'İki soruyu üst üste getirir ve bir yön ima eder.',
            },
          },
          inconsistentPatterns: {
            0: 'Zaman zaman üst üste sorulan sorular düşünme alanını daraltıyor.',
          },
        },
        C6: {
          narrative: 'Koç yalnızca içeriği değil; kimliği, enerjiyi ve anlam değişimlerini de dinler.',
          positiveExamples: {
            0: {
              quote: '“Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?',
              rationale: 'Danışanın dilini kullanarak anlamı araştırır.',
            },
            1: {
              quote: '“İzin” dediğinde hızın değişti. Şu an ne fark ediyorsun?',
              rationale: 'Ton değişimini danışan adına yorumlamadan görünür kılar.',
            },
          },
        },
        C7: {
          narrative: 'Farkındalık, danışanın kimliği ve seçimleriyle bağlantılı kısa sorularla ortaya çıkarılır.',
          positiveExamples: {
            0: {
              quote: 'Güvenilir olmak yardım istemeyi de içerirse neler mümkün olur?',
              rationale: 'Danışanın kendi temasına dayalı yeni bir çerçeve açar.',
            },
            1: {
              quote: 'Bu sınırın senin kendi sesindeki hâli nasıl duyulurdu?',
              rationale: 'Farkındalığı özgün bir ifadeye taşır.',
            },
          },
          developmentExamples: {
            0: {
              quote: 'Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?',
              rationale: 'Örtük bir çözüm içerir.',
            },
          },
        },
        C8: {
          narrative: 'Danışan ölçülebilir bir deneyi kendisi tasarlar ve uygulamak için gereken desteği adlandırır.',
          positiveExamples: {
            0: {
              quote: 'Bu hafta denemeye hazır olduğun küçük adım ne?',
              rationale: 'İçgörüyü danışanın sahiplendiği bir eyleme dönüştürür.',
            },
            1: {
              quote: 'Cuma günü bu deneyin işe yaradığını sana ne gösterecek?',
              rationale: 'Başarı kanıtını danışanın tanımlamasını sağlar.',
            },
          },
        },
      },
      session: {
        title: 'PCC demo oturumu — sürdürülebilir bir liderlik ritmi bulmak',
        coachName: 'Elena Hart (kurgusal)',
        clientName: 'Maya Reed (kurgusal)',
      },
      overallAssessment: '**PCC düzeyinde performans.** Koç danışanla tutarlı biçimde ortaklık kuruyor, sözcüklerin altındaki anlamı dinliyor ve oluşan farkındalığı danışanın sahiplendiği bir deneye dönüştürüyor. En net gelişim alanı, ikinci bir soru eklemeden önce daha fazla sessizliğe izin vermek.',
      recommendations: {
        0: 'Duygusal açıdan önemli danışan ifadelerinden sonra tek bir soru sor.',
        1: 'Danışan düşünürken yeni bir cümle eklemeden önce iki tam nefes bekle.',
        2: 'Eylem tasarımını danışanın adlandırdığı kimlik değişimine bağlamayı sürdür.',
      },
      narrative: {
        sessionOverview: 'Oturum, iş yüküyle ilgili pratik bir kaygıdan danışanın güvenilirliği nasıl tanımladığına dair daha derin bir keşfe ilerliyor. Koç üretkenlik çerçevesini dayatmak yerine danışanın dilini izliyor; böylece danışan yardım istemenin de sorumlu liderliğin bir parçası olabileceğini fark ediyor.',
        whatToWorkOnNext: 'En güçlü örüntün **sözcüklerin altındaki anlamı dinlemek**. Sıradaki gelişim alanı ölçülülük: bir soru görünür bir düşünme yarattığında ikinci soruyu eklemek yerine sessizlikte kal. Bu, güçlü farkındalık çalışmanı daha da ferah ve danışan liderliğinde kılacak.',
      },
      developmentPlan: {
        headline: 'En güçlü sorularından sonraki alanı koru',
        focusAreas: {
          C5: {
            title: 'Sessizliği bilinçli kullan',
            why: 'En iyi soruların zaten düşünme yaratıyor; ek sözcükler bazen bu süreci kesiyor.',
            practice: 'Anlamlı bir sorudan sonra yeniden konuşmadan önce içinden iki nefes say.',
          },
          C7: {
            title: 'Soruları tek ve net tut',
            why: 'Tek bir açık soru, danışana yönü seçmek için daha fazla özgürlük verir.',
            practice: 'Bir oturumu incele, üst üste sorulan her soruyu işaretle ve her birini tek cümle olarak yeniden yaz.',
          },
          C8: {
            title: 'Eylemi kimlikle bağla',
            why: 'Danışanın eylemi, keşfettiği değişimi ifade ettiğinde daha kalıcı olur.',
            practice: '“Bu eylem olmak istediğin kişiyi nasıl yansıtıyor?” sorusuyla kapat.',
          },
        },
        firstAction: 'Tek bir soru sormaya ve alan bırakmaya odaklanan 20 dakikalık bir pratik oturumu kaydet.',
        weeklyPractice: 'Üç sessizlik anını incele ve danışanın bu alanla ne yaptığını not et.',
        nextMilestone: 'Art arda iki oturumda tutarlı biçimde tek soruluk tempo göster.',
      },
      markers: {
        PCC_C6_01: {
          text: 'Koç, yalnızca sunulan soruna değil danışanın bütününe yanıt verir.',
          quote: '“Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?',
          explanation: 'Koç danışanın kimlik dilini izler ve daha derin anlamı davet eder.',
        },
        PCC_C7_03: {
          text: 'Danışanın mevcut düşüncesinin ötesini keşfetmesine yardımcı olan sorular sorar.',
          quote: 'Güvenilir olmak yardım istemeyi de içerirse neler mümkün olur?',
          explanation: 'Soru, bir çözüm dayatmadan yeni bir tanım alanı açar.',
        },
        PCC_C5_02: {
          text: 'Danışanın düşünmesi ve yanıt vermesi için yeterli alan bırakır.',
          quote: 'Peki bunu devretsen ne olurdu — ekibin sorumluluk alır mıydı?',
          explanation: 'Üst üste gelen soru danışanın düşünme alanını daraltır.',
        },
      },
      transcript: {
        0: { text: 'Yardım istersem bu rol için yeterince güvenilir olmadığımı düşüneceklerinden korkuyorum.' },
        1: {
          text: '“Güvenilir” dediğinde bu kelime senden neyi taşımayı istiyor?',
          annotation: 'PCC işaretçisi 6.1 · danışanın anlamını dinler',
        },
        2: { text: 'Her şeyi taşımamı istiyor. Güvenilirliğin ekibe güvenmeyi de içerebileceğini hiç düşünmemiştim.' },
        3: {
          text: 'Güvenilir olmak yardım istemeyi de içerirse neler mümkün olur?',
          annotation: 'PCC işaretçisi 7.1 · danışan liderliğinde yeni bir çerçeve oluşturur',
        },
      },
    },
  },

  // Rehberli ürün turu (QA F4). Adım kimlikleri tour/tourModel.ts ile aynı.
  // `where`, adımın öğesi ekranda yoksa (ortadaki kart) gösterilir.
  guidedTour: {
    dialogLabel: 'Rehberli tur',
    counter: 'Adım {{current}} / {{total}}',
    next: 'İleri',
    back: 'Geri',
    skip: 'Turu atla',
    finish: 'Bitir',
    whereLabel: 'Nerede bulursun',
    steps: {
      nav_overview: {
        title: 'Her şey bu menüden başlar',
        body: 'Ana sayfa, Sohbet, Oturumlar ve Profil arasında buradan geçersin; planında varsa Mentiler ve İlerleme de burada. Telefonda menü altta durur, geri kalanı "Daha fazla" altındadır.',
        where: 'Menü bilgisayarda solda, telefonda altta.',
      },
      upload_session: {
        title: 'Bir koçluk oturumu yükle',
        body: 'Oturumlar\'da bir kayıt (MP3, M4A, WAV) ya da transkript (PDF, DOCX, TXT) yükle. Kayıtlar önce yazıya dökülür, sonra analiz edilir.',
        where: 'Menü → Oturumlar, sayfanın üstündeki yükleme alanı.',
      },
      analysis_runs: {
        title: 'Analiz nerede çalışır',
        body: 'Analiz bizim tarafımızda çalışır ve genellikle birkaç dakika sürer; uzun bir kayıt önce yazıya döküldüğü için daha uzun sürer. Sayfadan çıkabilirsin: Oturumlar her oturumu ve durumunu gösterir.',
        where: 'Menü → Oturumlar.',
      },
      report_open: {
        title: 'Raporun burada açılır',
        body: 'Analiz edilen her oturumun kendi raporu vardır. En üstte oturumun gösterdiği ICF seviyesi, ardından özet ve sonraki adımların yer alır.',
        where: 'İlk analizinden sonra: Menü → Oturumlar → analiz edilen oturumu aç.',
      },
      report_read: {
        title: 'Rapor nasıl okunur',
        body: 'Her ICF yetkinliği seviyesini ve onu destekleyen, oturumundan alınmış alıntıları gösterir. Özet ve sonraki adımlarla başla, sonra üzerinde çalışmak istediğin yetkinlikleri aç.',
        where: 'Bir raporda aşağı kaydırıp yetkinliklere gel.',
      },
      chat_reassess: {
        title: 'Rapor hakkında sor ya da yeniden değerlendir',
        body: 'Sohbet\'te oturumların ve raporların hakkında takip soruları sorabilir ya da bir oturumu yeniden değerlendirmeyi isteyebilirsin, örneğin PCC işaretlerine göre. Yeniden değerlendirme 1 analiz kredisi kullanır.',
        where: 'Menü → Sohbet.',
      },
      progress_goal: {
        title: 'ICF hedefine doğru ilerlemen',
        body: 'İlerleme, yetkinliklerinin oturumlar boyunca nasıl geliştiğini ve hedef seviyene (ACC, PCC ya da MCC) ne kadar yaklaştığını gösterir.',
        where: 'Menü → İlerleme.',
      },
      profile_plan: {
        title: 'Planın ve kredilerin',
        body: 'Profil; planını, kaç analiz ve sohbet kullandığını ve kredi bakiyeni gösterir. Krediler planının ötesindeki ek analiz ve raporlar içindir; buradan kredi alabilir ya da planını değiştirebilirsin.',
        where: 'Menü → Profil (telefonda: üstteki kişi simgesi).',
      },
      profile_account: {
        title: 'Hesabın',
        body: 'Profil; hesap bilgilerini, dil ve veri ayarlarını içerir.',
        where: 'Menü → Profil (telefonda: üstteki kişi simgesi).',
      },
      mentees: {
        title: 'Mentilerin',
        body: 'Mentiler, mentorluk yaptığın herkesi listeler. Her mentinin oturumları, incelemeleri ve formlarıyla kendi çalışma alanı vardır.',
        where: 'Menü → Mentiler (telefonda: alt çubukta ya da "Daha fazla" altında).',
      },
      create_engagement: {
        title: 'Menti ekle',
        body: '"Yeni menti" bir mentorluk sürecini başlatır: mentinin adı ve e-postası, hedeflediği ICF seviyesi ve form dili.',
        where: 'Mentiler → Yeni menti.',
      },
      engagement_add_session: {
        title: 'Bir mentiye oturum ekle',
        body: 'Mentinin Oturumlar sekmesinde koçluk oturumunun kaydını ya da transkriptini yükle veya oturumu elle ekle.',
        where: 'Mentiler → bir mentiyi aç → Oturumlar → Görüşme yükle.',
      },
      sof_review: {
        title: 'Bir oturumu incele (SOF)',
        body: '"İncele", o oturum için ICF Oturum Gözlem Formu\'nu açar. MCAi gözlemleri transkriptten kanıtlarla taslak olarak hazırlar; sen her birini onaylar ya da değiştirirsin.',
        where: 'Mentiler → bir mentiyi aç → Oturumlar → İncele.',
      },
      crf: {
        title: 'Yeterlilik İnceleme Formu (CRF)',
        body: 'İnceleme ve belgeler altında, incelenen oturumlardan Yeterlilik İnceleme Formu\'nu oluşturur, toplu geri bildirimini yazar ve formu tamamlarsın.',
        where: 'Mentiler → bir mentiyi aç → İnceleme ve belgeler.',
      },
      send_forms: {
        title: 'Formları gönder',
        body: 'Bir form tamamlandığında mentine e-postayla gönder ya da PDF olarak indir.',
        where: 'Mentiler → bir mentiyi aç → İnceleme ve belgeler → Danışana e-posta gönder.',
      },
      mcs_prep: {
        title: 'MCS hazırlığı',
        body: 'ICF Mentor Koç Uzmanlığı için kendi hazırlığını takip et: saatlerin, her gereklilik ve arkasındaki resmi rehberlik.',
        where: 'Menü → MCS hazırlığı (telefonda: "Daha fazla" altında).',
      },
      finish: {
        title: 'Hazırsın',
        body: 'Bu turu istediğin zaman Yardım menüsünden yeniden başlatabilirsin.',
        where: 'Yardım bilgisayarda menüde, telefonda üstte.',
      },
    },
  },

  // Uygulama içi Yardım menüsü: turu yeniden başlat, SSS, geri bildirim.
  helpMenu: {
    title: 'Yardım',
    tour: 'Rehberli turu başlat',
    tourDescription: 'Her şeyin nerede olduğunu gösteren kısa bir tur.',
    faq: 'Yardım merkezi ve SSS',
    faqDescription: 'Sık sorulan soruların yanıtları (web sitemizde açılır).',
    feedback: 'Geri bildirim gönder',
    feedbackDescription: 'Kafa karıştıran ya da bozuk olan şeyi bize anlat.',
  },

  // Bağlamsal "bu nedir?" ipuçları. Kimlikler GUIDANCE_HINT_IDS ile aynı.
  guidanceHints: {
    open: 'Bu nedir?',
    dismiss: 'Anladım',
    analysis_options: {
      title: 'Bu seçenekler ne işe yarar?',
      body: 'Analize bu oturumu nasıl okuyacağını söylerler, örneğin hangi ICF seviyesine göre değerlendireceğini. "Otomatik" seviyeyi oturumdan seçer. Emin değilsen varsayılanları bırak.',
    },
    credits_minutes: {
      title: 'Analizler, sohbetler ve krediler',
      body: 'Planın her ay belirli sayıda analiz ve günlük bir sohbet sınırı içerir (çubuklar). Krediler ektir: planının ötesindeki analiz ve raporlar için kullanılır; Sohbet\'teki bir yeniden değerlendirme 1 kredi kullanır.',
    },
    report_level: {
      title: 'Bu seviye ne anlama geliyor?',
      body: 'Bu, MCAi\'nin bu oturumun gösterdiği ICF seviyesine (ACC, PCC ya da MCC) dair, bu rapordaki kanıtlara dayanan tahminidir. Gelişimin için bir geri bildirimdir, bir ICF unvan kararı değildir.',
    },
    sof_review: {
      title: 'SOF incelemesi nedir?',
      body: 'ICF Oturum Gözlem Formu, tek bir oturumda gözlemlediklerini kaydeder. MCAi formu transkriptten taslak olarak hazırlar; her maddeyi sayılmadan önce sen onaylar ya da düzenlersin.',
    },
    crf_form: {
      title: 'CRF nedir?',
      body: 'ICF Yeterlilik İnceleme Formu, mentinin incelenen oturumlar boyunca gelişimini özetler. Geri bildirimin tamamlandığında formu tamamla, sonra mentine gönder.',
    },
  },

  // Contextual Tips (one-time tooltips at key moments)
  tips: {
    firstAttach: 'Harika! Koçluk görüşme kaydınızı veya transkriptinizi buradan yükleyin. PDF, Word ve ses dosyaları desteklenir.',
    firstAnalysisDone: 'Analiziniz hazır! Burada takip soruları sorabilirsiniz — örneğin "Aktif dinleme konusunda neleri geliştirebilirim?"',
    newTranscriptReminder: 'Farklı bir transkript mi var? Yeni bir sohbet başlatmak için + düğmesine tıklayın. Her transkriptin kendi sohbeti olmalı.',
    creditLow: '1 krediniz kaldı. Her transkript analizi 1 kredi kullanır.',
    pdfExport: 'Bunu akreditasyon dosyanda mı kullanacaksın? ICF uyumlu PDF veya DOCX olarak dışa aktar.',
    icfProgress: 'İki oturum tamamlandı — yetkinliklerinin gidişatını İlerleme sekmesinde gör.',
    practiceExam: 'ICF akreditasyon sınavına mı hazırlanıyorsun? Deneme soruları İlerleme bölümünde hazır.',
    voiceRecording: 'Oturumları doğrudan uygulamada kaydedebilirsin; ayrı bir kayıt aracına gerek yok.',
    documentsRag: 'AI mentorunun yanıtlarında kullanabilmesi için koçluk notlarını veya ICF çalışma belgelerini yükle.',
    meetingFeedback: 'Yapılandırılmış gözlem notları, yetkinlik kanıtları ve sonraki koçluk adımları için toplantı geri bildirimini kullan.',
    mentorTraining: 'Mentor koçlar: çoktan seçmeli alıştırmalar ve grup değerlendirmeleri Mentor Eğitimi altında.',
  },

  // Post-Payment Onboarding Intake Form
  intake: {
    mentorWorkspace: {"eyebrow": "Mentor çalışma alanın", "openMentees": "Mentileri aç", "empty": "Sonraki adımlarınızı düzenlemek için mentor çalışma alanınızı oluşturun.", "refresh": "Çalışma alanını yenile", "generate": "Çalışma alanı oluştur", "updated": "Mentor çalışma alanınız güncel."},
    revealCtaEngagements: "Mentorluk çalışmalarını aç",
    title: 'Mentor Coaching AI\'ya Hoş Geldiniz',
    revealCtaPlans: 'Planını seç',
    subtitle: 'Birkaç hızlı soru — sana özel bir gelişim planı hazırlayabilelim diye.',
    helperText: 'Yanıtların ilk analizini ve gelişim planını sana göre ayarlar. Daha sonra profilinden güncelleyebilirsin.',
    questions: {
      profileType: 'Sizi en iyi tanımlayan hangisi?',
      credentials: 'Akredite bir koçluk sertifikan var mı?',
      credential: 'Şu anda hangi koçluk unvanına sahipsin?',
      hours: 'Yaklaşık kaç koçluk saatin var?',
      education: 'Koçluk eğitimini nasıl aldın?',
      goal: 'Sırada hangi hedef için çalışıyorsun?',
      goalHelper: 'Geri bildirimini ve planını bu hedefe göre ayarlayacağız.',
      frequency: 'Şu an ne sıklıkta koçluk yapıyorsun?',
      challenge: 'Şu an en zorlandığın alan hangisi?',
      focusCompetency: 'Analizlerinde özellikle hangi alana ağırlık verelim?',
      focusCompetencyHelper: 'Bir üst akreditasyona hazırlandığın için odak yetkinliği seçebilirsin. AI tüm sekiz yetkinliği yine değerlendirir; bu seçim sadece ekstra vurgu yapar.',
      mentorUse: 'Mentor Coaching AI’ı en çok hangi amaçla kullanacaksın?',
      mentorVolume: 'Şu anda kaç koça mentörlük veya süpervizyon yapıyorsun?',
      mentorChallenge: 'Mentör koçluk çalışmalarında şu anda en zor olan ne?',
      menteeFocus: 'Mentörlük yaptığın koçlar en çok hangi yetkinlikte zorlanıyor?',
      menteeFocusHelper: 'Gözlem desteğine en çok ihtiyaç duyduğun tekrar eden örüntüyü seç. MCAi yine sekiz yetkinliğin tamamını değerlendirecek.',
    },
    next: 'Devam et',
    back: 'Geri',
    stepProgress: 'Adım {{current}} / {{total}}',
    skipQuestion: 'Bu soruyu geç',
    profileTypes: {
      student: 'Öğrenci',
      studentDescription: 'Koç olmayı öğreniyorum',
      coach: 'Profesyonel Koç',
      coachDescription: 'Aktif olarak koçluk yapıyorum',
      mentor: 'Mentor Koç',
      mentorDescription: 'Diğer koçlara mentorluk ve süpervizyon yapıyorum',
    },
    credentialOptions: {
      none: { title: 'Henüz sertifikam yok', description: 'Yolda — henüz akredite olmadım.' },
      acc: { title: 'ICF ACC', description: 'Associate Certified Coach' },
      pcc: { title: 'ICF PCC', description: 'Professional Certified Coach' },
      mcc: { title: 'ICF MCC', description: 'Master Certified Coach' },
      other: { title: 'Başka bir sertifika', description: 'EMCC, AC veya farklı bir kurum' },
    },
    hourBuckets: {
      under10: { title: '10 saatten az', description: 'Yeni başlıyorum.' },
      tens: { title: '10 – 50 saat', description: 'Erken pratik.' },
      fifties: { title: '50 – 100 saat', description: 'Tutarlılık kazanıyorum.' },
      hundreds: { title: '100 – 500 saat', description: 'Yerleşmiş bir pratik.' },
      master: { title: '500+ saat', description: 'Deneyimli koçum.' },
    },
    educationOptions: {
      icf_accredited: { title: 'ICF akrediteli program', description: 'Level 1, Level 2, ACTP, ACSTH veya muadili.' },
      coaching_school: { title: 'Koçluk okulu (ICF dışı)', description: 'Başka bir koçluk eğitimi aldım.' },
      self_taught: { title: 'Kendi kendime', description: 'Kitap, video, mentor — formal program yok.' },
      none: { title: 'Henüz formal eğitim almadım', description: 'Merak ediyorum veya yeni başlıyorum.' },
      other: { title: 'Diğer', description: 'Farklı bir yol.' },
    },
    mentorUseOptions: {
      mentee_sessions: { title: 'Mentörlük yaptığım koçların oturumlarını incelemek', description: 'Mentörlük yaptığım koçlara kanıta dayalı geri bildirim vermek.' },
      own_development: { title: 'Kendi koçluk gelişimim', description: 'Kendi danışan çalışmalarımda güncel ve keskin kalmak.' },
      feedback_prep: { title: 'Mentör geri bildirimi hazırlamak', description: 'Mentör görüşmeleri için yapılandırılmış, işaretçi düzeyinde notlar.' },
      program: { title: 'Bir eğitim programı yürütmek', description: 'Bir öğrenci kohortunda değerlendirme ve ilerleme takibi.' },
    },
    mentorVolumeOptions: {
      none_yet: { title: 'Henüz yok', description: 'Mentörlük veya süpervizyon yapmaya hazırlanıyorum.' },
      few: { title: '1–3 koç', description: 'Küçük bir mentörlük pratiği.' },
      several: { title: '4–10 koç', description: 'Birden fazla aktif menti veya süpervizyon danışanı.' },
      many: { title: '10+ koç', description: 'Daha büyük bir program veya süpervizyon yükü.' },
    },
    mentorChallengeOptions: {
      evidence: { title: 'Geri bildirimi transkript kanıtına dayandırmak', description: 'Gözlemleri belirli koçluk anlarıyla ilişkilendirmek.' },
      calibration: { title: 'ICF işaretçilerine tutarlı kalibrasyon', description: 'Koçlar ve oturumlar arasında değerlendirme standardını korumak.' },
      time: { title: 'Oturum incelemesine ayrılan süre', description: 'Nitelikli geri bildirimi daha verimli hazırlamak.' },
      difficult_feedback: { title: 'Zor geri bildirimi iyi vermek', description: 'Güveni ve öğrenmeyi korurken doğrudan olmak.' },
      other: { title: 'Başka bir konu', description: 'Sohbette daha fazla bağlam paylaşacağım.' },
    },
    goalLevels: {
      ACC: { title: 'ICF ACC', description: 'Associate Certified Coach sertifikası alacağım.' },
      PCC: { title: 'ICF PCC', description: 'Professional Certified Coach sertifikası alacağım.' },
      MCC: { title: 'ICF MCC', description: 'Master Certified Coach sertifikası alacağım.' },
      exploring: { title: 'Sadece kendimi geliştirmek', description: 'Belirli bir sınav yok — gerçek seanslarda daha iyi geri bildirim istiyorum.' },
    },
    challengeOptions: {
      listening: { title: 'Derin dinleme', description: 'Söylenenin altındakini duymak istiyorum.' },
      questions: { title: 'Güçlü sorular sormak', description: 'Tavsiye değil, içgörü açan sorular.' },
      presence: { title: 'Anda kalmak', description: 'Kendi düşüncelerimi yavaşlatmak.' },
      structure: { title: 'Seansı yapılandırmak', description: 'Anlaşma, keşif, eylem — etkili kapatmak.' },
      confidence: { title: 'Koç olarak kendime güvenmek', description: 'İçimdeki eleştirmeni susturmak.' },
      other: { title: 'Başka bir şey', description: 'Sohbette daha fazlasını paylaşacağım.' },
    },
    focusCompetencies: {
      C4: {
        title: 'Güven ve yakınlık geliştirme',
        description: 'Müşteriyle güvenli, açık bir alan kurma becerisi.',
      },
      C5: {
        title: 'Hazır bulunuşluk',
        description: 'Anda kalma, sakin ve odaklanmış varlık.',
      },
      C6: {
        title: 'Aktif dinleme',
        description: 'Söyleneni gerçekten duyma ve doğru yansıtma.',
      },
      C7: {
        title: 'Güçlü sorular ve farkındalık',
        description: 'Düşündüren, içgörü açan sorular sorma.',
      },
      C8: {
        title: 'Müşteri gelişimini destekleme',
        description: 'Eylem, sorumluluk ve kalıcı değişimi inşa etme.',
      },
      none: {
        title: 'Henüz emin değilim',
        description: 'AI tüm sekiz ICF yetkinliğini eşit olarak inceler.',
      },
    },
    placeholders: {
      credentials: 'örn. ICF ACC, PCC, MCC veya diğer sertifikalar',
      hours: 'örn. 100',
      education: 'örn. ICF akrediteli program, koçluk okulu, vb.',
      goal: 'Neler başarmayı umduğunuzu bize anlatın...',
    },
    submit: 'Gönder',
    skip: 'Şimdilik geç',
    errors: {
      profileTypeRequired: 'Lütfen profil tipinizi seçin.',
      invalidHours: 'Lütfen geçerli bir koçluk saati sayısı girin (0 veya daha fazla).',
      submitFailed: 'Yanıtlarınız kaydedilemedi. Lütfen tekrar deneyin.',
      skipFailed: 'Şu anda geçilemiyor. Lütfen tekrar deneyin.',
      loadFailed: 'Kaydedilmiş yanıtlarını geri yükleyemedik. Buradan devam edip yeniden kaydetmeyi deneyebilirsin.',
    },
    results: {
      title: 'Teşekkürler!',
      skipped: 'Profilinizi istediğiniz zaman Ayarlar → Profil bölümünden güncelleyebilirsiniz.',
      saved: 'Yanıtlarınız kaydedildi. Bu bilgileri deneyiminizi kişiselleştirmek için kullanacağız.',
      continue: 'Devam et',
    },
    loading: {
      title: 'Planını hazırlıyoruz',
      subtitle: 'Birkaç saniye sürer.',
      checkpoints: {
        readingProfile: 'Profilini okuyoruz',
        mappingFocus: 'Odak alanlarını seçiyoruz',
        draftingPlan: 'Planını yazıyoruz',
      },
      tip: 'Planın, yeni seans yükledikçe güncellenecek — yaşayan bir belge.',
    },
    plan: {
      eyebrow: 'Gelişim planın',
      focusHeading: 'Şu alanlara odaklanacağız',
      practiceLabel: 'Pratik',
      practiceText: 'Pratik: {{practice}}',
      nextMilestoneLabel: 'Sıradaki kilometre taşı',
      weeklyPracticeLabel: 'Haftalık pratik',
      firstActionLabel: 'Buradan başla',
      continueCta: 'Hadi başlayalım',
      sampleAnalysisCta: 'Örnek analizi gör',
      skippedTitle: 'Hazırsın',
      skippedBody: 'Kişisel planını istediğin zaman Ayarlar → Profil bölümünden oluşturabilirsin.',
      generationFailedTitle: 'Planını oluşturamadık',
      generationFailedBody: 'Yanıtların kaydedildi. Kişisel gelişim planını tamamlamak için tekrar dene.',
      retryCta: 'Planı yeniden oluşturmayı dene',
    },
  },

  b2bPlanSelection: {
    tier1: 'Temel Etkinleştirme',
    tier2: 'Büyüme Hızlandırıcı',
    tier3: 'Ortak Başarısı',
    title: 'Akademiniz için doğru planı oluşturun',
    subtitle: 'İhtiyaç duyduğunuz öğrenci ve mentor koltuğu sayısını seçin. Yönetici hesapları dahildir.',
    yourPlan: 'Plan özeti',
    seats: 'Öğrenci + mentor koltukları',
    seatHelper: 'Temel paket {{base}} ücretli koltuk içerir. Her ek paket {{bundle}} koltuk ekler. Yöneticiler sayılmaz.',
    tier: 'Hizmet katmanı',
    total: 'Tahmini aylık toplam',
    checkout: 'Güvenli ödemeye devam et',
    priceDisclaimer: 'Vergiler ve bölgesel düzenlemeler nihai faturayı etkileyebilir.',
    redirecting: 'Sizi doğru plan ekranına yönlendiriyoruz…',
    fallbackMissingScreenTitle: 'Faturalandırma ekranı yükleniyor…',
    fallbackMissingScreenBody: 'Okul faturalandırma deneyimini yükleyemedik. Lütfen sayfayı yenileyin veya sorun devam ederse destekle iletişime geçin.',
    errors: {
      fetchPlan: 'Plan ön izlemesi alınamadı. Lütfen yenileyin veya destekle iletişime geçin.',
      notConfigured: 'Okulunuzun faturalandırma planı henüz tanımlanmadı, bu yüzden buradan etkinleştirilemez. support@mentorcoaching.ai adresine yazın, okulunuzu etkinleştirelim.',
      checkout: 'Ödeme başlatılamadı. Lütfen tekrar deneyin.',
      activationPending: 'Ödeme başarılı, ancak Stripe okul aboneliğinizi hâlâ tamamlıyor. Devam etmek için birazdan yenileyin.',
      noSchool: 'Okul profilinizi bulamadık. Lütfen davetinizin doğrulanması için destek alın.',
      unauthorized: 'Bu faturalandırma ekranına yalnızca okul yöneticileri erişebilir.',
    },
    errorActions: {
      retry: 'Tekrar dene',
      contactSupport: 'Destekle iletişime geç',
      signOut: 'Çıkış yap',
    },
    tiers: {
      tier1: {
        label: 'Temel Etkinleştirme',
        description: 'Mentor Coaching AI ile başlayan küçük kohortlar için temel analizler, transkript geri bildirimi ve e-posta desteği.',
      },
      tier2: {
        label: 'Büyüme Hızlandırıcısı',
        description: 'Temel’e ek olarak onboarding danışmanlığı, kohort içgörüleri ve büyüyen akademiler için öncelikli destek.',
      },
      tier3: {
        label: 'Partner Başarısı',
        description: 'Geniş ölçekli programlar için özel başarı yöneticisi, beyaz etiket seçenekleri ve özel raporlama.',
      },
    },
  },

  plans: {
    sampleReportLink: 'Önce örnek raporu gör',
    cycle1mo: '1 ay',
    cycle3mo: '3 ay',
    cycle6mo: '6 ay',
    months: 'ay',
    title: 'Koçluk yolculuğuna en uygun planı seç',
    subtitle: 'Aylık ya da yıllık ödeme, istediğiniz zaman iptal edin. Pratiğiniz büyüdükçe planınızı yükseltin.',
    selectionTitle: 'Planını seç, 3 gün ücretsiz dene',
    selectionSubtitleLine1: 'İlk oturumunu yüklemeden önce hesabını hazırlayalım.',
    selectionSubtitleLine2: 'Kartla başlayan denemeyi başlat. Deneme bitmeden istediğin zaman iptal edebilirsin.',
    selectionTitlePaid: 'Devam etmek için bir plan seç',
    selectionSubtitlePaidLine1: 'Hesabın ve önceki çalışmaların geri döndüğünde hazır.',
    selectionSubtitlePaidLine2: 'Toplam tutarı güvenli ödeme ekranında görüp ödeyeceksin.',
    payMonthly: 'Aylık',
    payYearly: 'Yıllık',
    save20Short: '%20 tasarruf',
    save20: 'Yıllık fiyatta %20 indirim',
    yearlySavingBadge: '2 ay ücretsiz',
    perMonth: '/ ay',
    perYear: '/ yıl',
    month: 'ay',
    currency: 'TL',
    getStarted: 'Denemeyi başlat',
    startTrial: 'Denemeyi başlat',
    continueToCheckout: 'Ödemeye devam et',
    processing: 'Yönlendiriliyor…',
    mostPopular: 'Önerilen',
    mentorUpsell: {
      onlyInTitle: 'Yalnızca Mentor Coach paketinde',
      mentees: 'ICF SOF ve CRF formlarıyla Mentiler çalışma alanı',
      sendForms: 'İmzalı SOF ve CRF PDF dosyalarını mentilerine e-postayla gönderme',
      analyses: 'Ayda 10 yapay zekâ oturum analizi (Sertifika Hazırlığı paketinde 5)',
      menteesNotIncluded: 'Mentiler dahil değil',
    },
    yourSelectedPlan: 'Seçtiğiniz plan',
    preselectedBadge: 'Senin seçimin',
    alreadyCovered: {
      title: 'Zaten aktif bir planın var',
      cta: 'Uygulamaya devam et',
    },
    changePlan: 'Plan değiştir',
    resumeSubscription: 'Aboneliği devam ettir',
    moreFeatures: 'daha fazla özellik',
    selectPlan: 'Bir Plan Seçin',
    paywallCta: 'Mentor seviyesinde yapay zekâ geri bildirimiyle koçluk becerini hızlandır',
    footer: 'Tüm planlar güvenli depolama, KVKK uyumlu işlem ve e-posta desteğini içerir.',
    cardTrialNotice: 'Kart gerekir. Deneme bitene kadar ücret alınmaz.',
    moneyBackGuarantee: '14 gün içinde para iade garantisi',
    moneyBackDescription: 'Memnun kalmadınız mı? İlk ödemenizden itibaren 14 gün içinde bize ulaşın, soru sormadan tam iade yapıyoruz.',
    chips: {
      icfGoal: 'ICF hedefi: {{level}}',
      language: 'Dil: {{language}}',
      usage: 'Kullanım: Ses kaydı + transkript',
    },
    noPaymentBanner: {
      headline: 'Bugün ödeme yok.',
      subline: 'Güvenli ödeme ekranı 3 günlük denemeni bugün başlatır; ücret deneme bitince alınır.',
    },
    trialEndedBanner: {
      headline: 'Ücretsiz denemen sona erdi.',
      subline: 'Devam etmek için bir plan seç. İstediğin zaman iptal edebilirsin.',
    },
    ready: {
      title: 'Hesabın hazırlandı',
      goalSaved: 'Hedef seviyen kaydedildi',
      languageSet: 'Dil tercihin ayarlandı',
      slotOpened: 'İlk oturum için alan açıldı',
      hint: 'Planı seçtikten sonra doğrudan uygulamaya geçeceksin.',
    },
    trust: {
      secureTitle: 'Koçluk verilerin güvende',
      secureSub: 'Verilerin şifrelenir ve korunur.',
      icfTitle: 'ICF uyumlu değerlendirme',
      icfSub: 'ICF standartlarına göre analiz.',
      noChargeTitle: 'Bugün ücret yok',
      noChargeSub: '3 gün ücretsiz, sonra planın başlar.',
      payTodayTitle: 'Şeffaf ödeme toplamı',
      payTodaySub: 'Ödemeden önce tutarı kontrol et.',
    },
    autoContinue: 'Deneme bittiğinde plan otomatik devam eder. Hesap ayarlarından iptal edebilirsin.',
    paidCheckoutNotice: 'Seçtiğin plan başarılı ödemeden sonra başlar. Yenilemeyi hesap ayarlarından yönetebilirsin.',
    legalTerms: 'Kullanım şartları',
    legalPrivacy: 'Gizlilik',
    later: 'Belki sonra',
    notAvailableTitle: 'Plan seçimi bu rol için kullanılmıyor',
    notAvailableMessage: 'Erişiminiz kurumunuz tarafından yönetiliyor. Sorularınız için okul yöneticinize veya destek ekibine ulaşın.',
    errors: {
      authRequired: 'Ödeme adımına geçmek için lütfen giriş yapın.',
      paymentFailed: 'Ödeme başlatılırken bir sorun oluştu. Lütfen tekrar deneyin.',
    },
    individual: {
      name: 'Öğrenci',
      tagline: 'Gerçek oturumlarını düzenli incelemek isteyen öğrenciler için.',
      monthlyPrice: '1250',
      yearlyPrice: '15000',
      features: {
        transcripts: 'Ayda 3 AI oturum analizi',
        transcriptionMinutes: 'Ayda 120 ses transkripsiyon dakikası',
        chats: 'Günde 10 sohbet',
        analytics: 'Temel ICF geri bildirimi ve ilerleme sinyalleri',
        support: 'E-posta desteği',
      },
    },
    advanced: {
      name: 'Sertifika Hazırlığı',
      tagline: 'ACC/PCC/MCC başvurularına hazırlanan koçlar için.',
      monthlyPrice: '3750',
      yearlyPrice: '45000',
      features: {
        transcripts: 'Ayda 5 AI oturum analizi',
        transcriptionMinutes: 'Ayda 300 ses transkripsiyon dakikası',
        chats: 'Günde 25 sohbet',
        analytics: 'Gelişmiş analitik ve içgörüler',
        support: 'E-posta desteği',
        tracking: 'İlerleme takibi',
        coaching: 'ICF sınavına uygun DOCX transkript dışa aktarımı',
      },
    },
    professional: {
      name: 'Mentor Koç',
      tagline: 'Daha yüksek hacimde oturum değerlendiren mentor koçlar için.',
      monthlyPrice: '8750',
      yearlyPrice: '105000',
      features: {
        transcripts: 'Ayda 10 AI oturum analizi',
        transcriptionMinutes: 'Ayda 1.200 ses transkripsiyon dakikası',
        chats: 'Günde 50 sohbet',
        analytics: 'Gelişmiş analitik ve içgörüler',
        support: 'E-posta desteği',
        tracking: 'İlerleme takibi',
        coaching: 'ICF sınavına uygun DOCX transkript dışa aktarımı',
        mentoring: 'Özel analiz modu ve mentor seviyesinde değerlendirme akışı',
      },
    },
    schools: {
      title: 'Koçluk okulları & akademiler için',
      subtitle: 'Toplu lisanslama, beyaz etiket portallar ve kohort analizleri.',
      contact: 'Okul fiyatlaması için bize ulaşın',
      emailSubject: 'Mentor Coaching AI — Okul Lisanslama Talebi',
      emailBody: 'Merhaba Mentor Coaching AI ekibi,%0A%0AKoçluk okulumuz için toplu fiyatlandırmayı konuşmak isteriz.%0A%0ASaygılarımızla,',
    },
    schoolPaywall: {
      title: 'Okul aboneliğini tamamlayın',
      description: 'Öğrenci koltuklarını ve panelleri açmak için Mentor Coaching AI aboneliğinizi tamamlayın.',
      summaryTitle: 'Plan özeti',
      baseLabel: 'Temel paket',
      baseSummary: '{{price}} / ay — {{seats}} koltuk dahil',
      addonLabel: 'Ek paket',
      addonSummary: '{{price}} / ay başına {{seats}} koltuk',
      packageSingular: 'paket',
      packagePlural: 'paket',
      seatTargetLabel: 'Toplam koltuk ihtiyacı',
      seatTargetPlaceholder: 'örn. 25',
      seatTargetHelp: 'Ödeme öncesi ihtiyaç duyduğunuz öğrenci koltuğu sayısını ayarlayın.',
      monthlyTotal: 'Tahmini aylık toplam: {{price}}',
      loading: 'Plan yükleniyor…',
      notConfigured: 'Bu okul için henüz bir fiyatlandırma planı tanımlanmadı. Platform yöneticisinden fiyatı ayarlamasını isteyin.',
      errorLoading: 'Plan özeti alınamadı. Lütfen tekrar deneyin veya destekle iletişime geçin.',
      checkout: 'Ödemeye devam et',
      checkoutDescription: "Aboneliği tamamlamak için Stripe'a yönlendirileceksiniz.",
      checkoutError: 'Stripe ödeme oturumu başlatılamadı. Lütfen tekrar deneyin.',
      instructions: 'Ödemeyi tamamladıktan sonra buraya dönüp yenileyerek onboarding adımlarını açabilirsiniz.',
      refresh: 'Ödemeyi tamamladım',
      refreshError: 'Abonelik durumu yenilenemedi. Lütfen tekrar deneyin.',
    },
    // Düz seviye etiketleri (plans.tierX)
    tier1: 'Temel',
    tier2: 'Büyüme',
    tier3: 'Ortak Başarı',
  },

  // Auth
  auth: {
    accountLoadError: {
      title: 'Hesabınız yüklenemedi',
      body: 'Bu genellikle geçicidir. Oturumunuz açık. Lütfen birazdan tekrar deneyin.',
      retry: 'Tekrar dene',
    },
    login: {
      title: 'Tekrar hoş geldiniz',
      welcome: 'Tekrar hoş geldiniz',
      subtitle: 'Koçluk yolculuğunuza devam etmek için giriş yapın',
      email: 'E-posta',
      emailPlaceholder: 'E-postanızı girin',
      password: 'Şifre',
      passwordPlaceholder: 'Şifrenizi girin',
      loginButton: 'Giriş yap',
      forgotPassword: 'Şifremi unuttum?',
      noAccount: 'Hesabınız yok mu?',
      signUp: 'Kayıt ol',
      rememberMe: 'Beni hatırla',
      fillAllFields: 'Lütfen tüm alanları doldurun',
      serverError: 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.',
      invalidCredentials: 'Geçersiz e-posta veya şifre',
      loginFailed: 'Giriş başarısız. Lütfen tekrar deneyin.',
      showPassword: 'Şifreyi göster',
      hidePassword: 'Şifreyi gizle',
      or: 'veya',
      continueWithGoogle: 'Google ile devam et',
      googleNotConfigured: 'Google girişi bu platform için yapılandırılmamış.',
      googleInitializing: 'Google girişi hazırlanıyor. Lütfen tekrar deneyin.',
      continueWithApple: 'Apple ile devam et',
      appleSigninFailed: 'Apple girişi başarısız oldu. Lütfen tekrar deneyin.',
      terms: 'Giriş yaparak Hizmet Şartlarımızı ve Gizlilik Politikamızı kabul etmiş olursunuz',
      termsPrefix: 'Giriş yaparak',
      termsSuffix: '\'nı kabul etmiş olursunuz.',
    },
    passwordless: {
      migrationBanner: {
        title: 'Girişi sadeleştirdik',
        body: 'Artık şifre yok. Bundan sonra hesabına e-postana gelen tek kullanımlık kod veya sihirli bağlantı ile giriyorsun — aynı hesap, daha güvenli ve daha kolay.',
        gotIt: 'Anladım',
      },
      chrome: {
        appName: 'Mentor Coaching AI',
        help: 'Yardım',
        trust: {
          noPassword: {
            title: 'Şifre yok',
            subtitle: 'Daha hızlı ve güvenli giriş',
          },
          icf: {
            title: 'ICF uyumlu',
            subtitle: 'ICF yetkinlik modeline uygun',
          },
          audio: {
            title: 'Ses ve transkript destekli',
            subtitle: 'Konuşmaların analiz edilir',
          },
        },
      },
      login: {
        badge: 'Koçluk verilerin güvende',
        // Logotype above the H1 already carries the brand — H1 leads with action.
        title: 'Giriş yap',
        subtitle: 'E-postanı yaz, sana 6 haneli giriş kodu gönderelim. Şifre hatırlamana gerek yok.',
        email: 'E-posta',
        emailPlaceholder: 'ornek@eposta.com',
        sendCode: 'Kodu gönder',
        sending: 'Gönderiliyor…',
        codeSentTitle: 'Kodunu gir',
        codeSentSubtitle: '{{email}} adresine 6 haneli bir kod gönderdik.',
        codeExpiresIn: 'Kod 10 dakika geçerli',
        verify: 'Doğrula ve giriş yap',
        verifying: 'Doğrulanıyor…',
        resend: 'Kodu yeniden gönder',
        resendCooldown: '{{seconds}} sn sonra yeniden gönder',
        resendWait: 'Yeniden göndermeden önce lütfen {{seconds}} sn bekle.',
        changeEmail: 'Farklı e-posta kullan',
        wrongCode: 'Bu kodu doğrulayamadık. Tekrar dene ya da yeni bir kod iste.',
        invalidCodeFormat: 'E-postandaki 6 haneli kodu gir.',
        noActiveCode: 'Aktif kod bulunamadı. Yeni bir kod iste.',
        registrationDisabled: 'Yeni kayıtlar geçici olarak kapalı. Zaten bir hesabın varsa kayıt olduğun e-postayı kullan.',
        expiredCode: 'Bu kodun süresi dolmuş. Yeni bir kod iste.',
        tooManyAttempts: 'Çok fazla hatalı deneme yaptın. Yeni bir kod iste.',
        otpLocked: 'Çok fazla hatalı deneme yaptın. Bir saat sonra tekrar dene.',
        incorrectCode: 'Bu kod hatalı. Tekrar dene.',
        accountInactive: 'Bu hesap aktif değil. Bunun bir hata olduğunu düşünüyorsan destek ekibiyle iletişime geç.',
        sendCodeError: 'Kod gönderilemedi. Lütfen tekrar dene.',
        invalidEmail: 'Geçerli bir e-posta adresi gir.',
        or: 'veya',
        continueWithGoogle: 'Google ile devam et',
        continueWithApple: 'Apple ile devam et',
        newAccountHint: 'Yeni misin? E-postanı yukarı gir; doğrulamadan sonra hesabını oluşturacağız.',
        noAccount: 'Hesabın yok mu?',
        signUp: 'Hesap oluştur',
      },
      signup: {
        badge: 'Ücretsiz dene',
        // Logotype above the H1 already carries the brand — H1 leads with action.
        title: 'Hesap oluştur',
        subtitle: 'E-postanı yaz, sana kayıt bağlantısı gönderelim — şifre yok. Sonra birkaç kısa soruyu yanıtla ve ücretsiz denemeni başlat.',
        email: 'E-posta',
        emailPlaceholder: 'ornek@eposta.com',
        sendLink: 'Sihirli bağlantı gönder',
        sending: 'Gönderiliyor…',
        linkHint: 'Linki açtığında hesabın güvenli şekilde doğrulanır.',
        linkSentTitle: 'E-postanı kontrol et',
        linkSentBody: '{{email}} adresine bir giriş bağlantısı gönderdik. Açıp hesabını oluşturmayı tamamlayabilirsin.',
        linkSentTip: 'İpucu: e-postayı bu cihazda aç; bağlantı seni doğrudan buraya geri getirir.',
        sendAnother: 'Yeni bir bağlantı gönder',
        changeEmail: 'Farklı e-posta kullan',
        sendError: 'Bağlantı gönderilemedi. Lütfen tekrar dene.',
        invalidEmail: 'Geçerli bir e-posta adresi gir.',
        or: 'veya',
        signUpWithGoogle: 'Google ile kaydol',
        signUpWithApple: 'Apple ile kaydol',
        terms: 'Devam ederek Kullanım Şartları ve Gizlilik Politikası\'nı kabul etmiş olursun.',
      },
      consume: {
        verifying: 'Giriş yapılıyor…',
        verifyingHint: 'Bağlantı doğrulanıyor. Bir saniye.',
        success: 'Hoş geldin!',
        successHint: 'Çalışma alanına yönlendiriliyorsun…',
        invalid: 'Bu giriş bağlantısının süresi dolmuş ya da bağlantı zaten kullanılmış',
        invalidHint: 'Giriş bağlantıları yalnızca bir kez çalışır ve 15 dakika sonra sona erer. Giriş yapmak için yeni bir kod al.',
        invalidHintWithEmail: 'Giriş bağlantıları yalnızca bir kez çalışır ve 15 dakika sonra sona erer. {{email}} adresine yeni bir giriş kodu gönderebiliriz.',
        sendNewCode: 'Bana yeni bir kod gönder',
        sendingNewCode: 'Gönderiliyor…',
        newCodeFailed: 'Şu anda yeni kod gönderemedik. Kod almak için giriş sayfasında e-posta adresini gir.',
        backToSignIn: 'Girişe dön',
        checkFailed: 'Bu giriş bağlantısını kontrol edemedik',
        checkFailedHint: 'İnternet bağlantını kontrol edip tekrar dene.',
        tryAgain: 'Tekrar dene',
      },
    },
    invitation: {
      title: 'Hesabınızı Aktifleştirin',
      subtitle: 'Koçluk alanınıza erişmek için adınızı onaylayın. Şifre gerekmez.',
      school: 'Okul',
      email: 'E-posta',
      inviter: 'Davet eden',
      fullName: 'Ad Soyad',
      fullNamePlaceholder: 'Örn. Ayşe Koç',
      passwordlessTitle: 'Şifresiz giriş',
      passwordlessBody: 'Aktivasyondan sonra giriş yaparken e-posta adresinize gönderilen tek kullanımlık kodu kullanın.',
      password: 'Şifre',
      passwordPlaceholder: 'Güçlü bir şifre oluşturun',
      confirmPassword: 'Şifre Tekrarı',
      confirmPasswordPlaceholder: 'Şifrenizi tekrar girin',
      showPassword: 'Şifreyi göster',
      hidePassword: 'Şifreyi gizle',
      requirements: 'Şifre gereksinimleri',
      requirementLength: 'En az 8 karakter',
      requirementMix: 'Harf ve rakam içermelidir',
      createButton: 'Hesabı Aktifleştir',
      terms: 'Devam ederek platform kullanım kurallarını kabul etmiş olursunuz.',
      invalidLink: 'Bu davet bağlantısı geçersiz veya süresi dolmuş.',
      validationError: 'Davet doğrulanamadı. Lütfen yeni bir bağlantı isteyin.',
      fullNameRequired: 'Lütfen adınızı ve soyadınızı girin.',
      passwordRequired: 'Lütfen bir şifre belirleyin.',
      passwordTooShort: 'Şifre en az 8 karakter olmalıdır.',
      passwordMismatch: 'Şifreler uyuşmuyor.',
      acceptFailed: 'Davet tamamlanamadı. Lütfen tekrar deneyin.',
      acceptError: 'Davet aktive edilirken bir sorun oluştu.',
      success: 'Aramıza hoş geldin {{name}}! Hesabın hazır. E-postana gönderilen tek kullanımlık kodla giriş yapabilirsin.',
      personalSubscriptionWarning: 'Okuluna katılmak bireysel aboneliğini iptal etmez. Aboneliğini Faturalandırma bölümünden yönetebilir veya iptal edebilirsin.',
    },
    register: {
      title: 'Başlayın',
      createAccount: 'Başlayın',
      subtitle: 'Koçluk hesabınızı oluşturun',
      email: 'E-posta',
      emailPlaceholder: 'E-postanızı girin',
      password: 'Şifre',
      passwordPlaceholder: 'Bir şifre oluşturun',
      confirmPassword: 'Şifre Tekrarı',
      confirmPasswordPlaceholder: 'Şifrenizi onaylayın',
      fullName: 'Ad Soyad',
      fullNamePlaceholder: 'Adınızı ve soyadınızı girin',
      firstName: 'Ad',
      lastName: 'Soyad',
      registerButton: 'Hesap Oluştur',
      createButton: 'Hesap Oluştur',
      hasAccount: 'Zaten hesabınız var mı?',
      haveAccount: 'Zaten hesabınız var mı?',
      signIn: 'Giriş yap',
      agreeToTerms: 'Kullanım Şartları ve Gizlilik Politikasını kabul ediyorum',
      terms: 'Hesap oluşturarak Hizmet Şartlarımızı ve Gizlilik Politikamızı kabul etmiş olursunuz',
      termsPrefix: 'Hesap oluşturarak',
      termsSuffix: '\'nı kabul etmiş olursunuz.',
      // Validation errors
      fullNameRequired: 'Lütfen adınızı ve soyadınızı girin',
      emailRequired: 'Lütfen e-posta adresinizi girin',
      invalidEmail: 'Lütfen geçerli bir e-posta adresi girin',
      passwordRequired: 'Lütfen bir şifre girin',
      passwordTooShort: 'Şifre en az 8 karakter uzunluğunda olmalıdır',
      passwordNeedsUppercase: 'Şifre en az bir büyük harf içermelidir',
      passwordNeedsLowercase: 'Şifre en az bir küçük harf içermelidir',
      passwordNeedsNumber: 'Şifre en az bir rakam içermelidir',
      passwordMismatch: 'Şifreler eşleşmiyor',
      termsRequired: 'Kullanım Şartlarını kabul etmelisiniz',
      registrationFailed: 'Kayıt başarısız. Lütfen tekrar deneyin.',
      accountCreated: 'Hesap oluşturuldu! Lütfen hesabınızı doğrulamak için e-postanızı kontrol edin.',
      creatingAccount: 'Hesap oluşturuluyor...',
      showPassword: 'Şifreyi göster',
      hidePassword: 'Şifreyi gizle',
    },
    logout: {
      title: 'Çıkış',
      message: 'Çıkış yapmak istediğinizden emin misiniz?',
      confirm: 'Çıkış yap',
      cancel: 'İptal',
    },
  },

  // Dashboard
  dashboard: {
    unlimited: 'Sınırsız',
    plan: {
      eyebrow: 'Planın',
      dismiss: 'Plan kartını gizle',
      focusLabel: 'Odak alanları',
      weeklyLabel: 'Haftalık pratik',
      startLabel: 'Buradan başla'
    },
    transcriptionMinutes: 'transkripsiyon dakikası',
    noRecentSessions: 'Henüz oturum yok',
    webPrivacyNote: 'Koçluk verilerin senin kontrolünde.',
    recentSessionsTitle: 'Son oturumlar',
    title: 'Anasayfa',
    welcome: 'Tekrar hoş geldiniz',
    welcomeMessage: 'Koçluk ilerleme özetiniz',
    profileSettings: 'Profil ve Ayarlar',
    personalizedPlan: 'Kişiselleştirilmiş Plan',
    activeSessions: 'Aktif Oturumlar',
    icfProgress: 'ICF İlerleme',
    chatConversations: 'Sohbet konuşmaları',
    recentConversations: 'Son Konuşmalar',
    noConversationsYet: 'Henüz konuşma yok',
    startChatWithAI: 'Mentor Coaching AI ile ilk konuşmanızı başlatın',
    startChatting: 'Son oturumlarınızı burada görmek için sohbet etmeye başlayın.',
    sessionStarted: 'Başlatıldı',
    quickActions: 'Hızlı İşlemler',
    uploadDocument: 'Belge Yükle',
    addMaterials: 'Koçluk materyalleri ekle',
    startChat: 'Sohbet Başlat',
    newChat: 'Yeni Sohbet',
    beginConversation: 'AI ile konuşmaya başla',
    uploadAudio: 'Ses kaydı yükle',
    uploadAudioDesc: 'Transkripsiyon ve ICF analizi için koçluk görüşmesi kaydı yükleyin',
    refreshData: 'Yenile',
    updateData: 'Verileri güncelle',
    pullLatestStats: 'En son istatistikleri çek',
    loadingData: 'Anasayfa verileri yükleniyor...',
    failedToLoad: 'Anasayfa verileri yüklenemedi',
    webGreeting: 'Merhaba, {{name}}',
    webGreetingSubtitle: 'Bugün yeni bir oturum yükleyebilir veya son geri bildirime dönebilirsin.',
    webRecentSession: 'Oturum',
    webUploadTitle: 'Yeni oturum analizi',
    webUploadBody: 'Ses kaydı, PDF, DOCX veya TXT yükle. Geri bildirimin sohbette hazır olsun.',
    webUploadCta: 'Oturum yükle',
    webHowItWorks: 'Nasıl çalışır?',
    webSecure: 'Güvenli',
    webIcfAligned: 'ICF uyumlu',
    webTurkishSupported: 'Türkçe destekli',
    webLatestFeedback: 'Son geri bildirimin',
    webLatestAnalysisAvailable: 'Son analiz hazır',
    webTrialAnalysisPreview: 'Deneme analizi önizlemesi',
    webAnalysisScore: 'Genel {{score}}/100',
    webAnalysisLevel: '{{level}} seviyesi',
    webAnalysisReadyCopy: 'Analizin tamamlandı ve incelemeye hazır. Kanıtları ve sonraki adımları görmek için geri bildirimi aç.',
    webAnalysisHighlights: 'Öne çıkanlar',
    webNoAnalysisTitle: 'Henüz analiz yok',
    webNoAnalysisCopy: 'Burada gerçek geri bildirim oluşturmak için ilk oturumunu yükle.',
    webLatestFallback: 'Demo koçluk görüşmesi analizi',
    webCompleted: 'Tamamlandı',
    webOpenFeedback: 'Geri bildirimi aç',
    webSuggestedFollowup: 'Takip sorusu',
    webPccQuestion: 'PCC seviyesi için hazır mıyım?',
    webGeneralFollowupQuestion: 'Bu geri bildirimin en önemli aksiyonu ne?',
    webWeeklyFocus: 'Bu haftaki odak',
    webWeeklyFocusFallback: 'Sonraki oturum odağı',
    webActiveListening: 'Aktif dinleme',
    webFocusCopy: 'Son analizlerinden sonra önerilen küçük çalışmaları burada göreceksin.',
    webOpenExercise: 'Önerilen çalışmayı gör',
    webProgressLockedTitle: 'ICF ilerleme takibini aç',
    webProgressLockedCopy: 'Hazırlık seviyeni, güçlü alanlarını ve gelişim odağını otomatik takip etmek için Gelişmiş plan gerekir.',
    webProgressLockedCta: 'Planı yükselt',
    webProgressLockedSchoolTitle: 'ICF ilerleme bu okul planında açık değil',
    webProgressLockedSchoolCopy: 'Bu bölüm yalnızca ICF ilerleme takibi olan okul planlarında görünür. Oturum yüklemeye ve geri bildirimi sohbette kullanmaya devam edebilirsin.',
    webProgressLockedSchoolCta: 'Okul planını yönet',
    webSessionsAnalyzed: 'oturum analiz edildi',
    webNoProgressYet: 'Veri bekleniyor',
    webEstimatedLevel: 'Tahmini seviyen',
    webStrongArea: 'Güçlü alan',
    webFocus: 'Odak',
    webRecentFeedback: 'Son geri bildirimler',
    webNoRecentFeedback: 'Tamamlanan oturum analizlerin burada görünecek.',
    webDemoAnalysisOne: 'Demo koçluk görüşmesi analizi',
    webDemoAnalysisTwo: 'Güçlü soru analizi',
    webDemoAnalysisThree: 'Sessizlik kullanımı taslağı',
    webHowModalTitle: 'Oturum yükleme nasıl işler?',
    webHowModalBody: 'Ses kaydı veya transkript seç. Varsayılan ayarlar çoğu kullanıcı için yeterli.',
    webHowStepOne: 'Dosyanı seç',
    webHowStepTwo: 'Analiz otomatik hazırlanır',
    webHowStepThree: 'Sonucu sohbette incele',
    stats: {
      sessions: 'Oturumlar',
      progress: 'İlerleme',
      hours: 'Saatler',
      goals: 'Hedefler',
    },
    recentSessions: {
      title: 'Son Oturumlar',
      viewAll: 'Tümünü Gör',
      noSessions: 'Henüz oturum yok',
      startFirst: 'İlk koçluk oturumunuzu başlatın',
    },
    intakeSummary: {
      title: 'Koçluk Profiliniz',
      viewDetails: 'Detayları Gör',
      updateProfile: 'Profili Güncelle',
    },
    session: 'Oturum',

    // Credits
    credits: 'Krediler',
    lowCredits: 'Düşük',
    availableCredits: 'Kullanılabilir Kredi',
    subscriptionCredits: 'Abonelik',
    purchasedCredits: 'Satın Alınan',
    creditsResetOn: 'Yenilenme tarihi',
    buyMoreCredits: 'Daha Fazla Kredi Al',
    buyTranscriptionMinutes: 'Transkripsiyon Dakikası Satın Al',
    purchasedCreditsNeverExpire: 'Satın alınan kredilerin süresi dolmaz',
    // Credit warning banner
    runningLowOnCredits: 'Krediniz Azalıyor',
    creditsRemaining: 'Bu ay {{total}} kredinizden {{remaining}} adet kaldı.',
    creditsRemainingNoTotal: '{{remaining}} krediniz kaldı.',
    // Credit purchase modal
    buyCredits: 'Kredi Satın Al',
    getMoreAnalysisCredits: 'Daha fazla analiz kredisi al',
    addCreditsToSchool: 'Okul havuzunuza kredi ekleyin',
    loadingCreditPacks: 'Kredi paketleri yükleniyor...',
    failedToLoadPacks: 'Kredi paketleri yüklenemedi. Lütfen tekrar deneyin.',
    tryAgain: 'Tekrar Dene',
    comingSoon: 'Yakında',
    comingSoonMessage: 'Kredi paketi satın alma yakında kullanılabilir olacak. Bu süre zarfında abonelik kredilerinizi kullanabilirsiniz.',
    gotIt: 'Anladım',
    credit: 'Kredi',
    creditPlural: 'Kredi',
    perCredit: 'kredi başına',
    bestValue: 'En İyi Değer',
    creditsNeverExpireInfo: 'Satın alınan kredilerin süresi dolmaz ve istediğiniz zaman kullanabilirsiniz. Abonelik kredilerinizden önce kullanılırlar.',
    secureCheckout: 'Stripe ile güvenli ödeme',
    noPacksAvailable: 'Kredi Paketi Bulunamadı',
    noPacksAvailableMessage: 'Kredi paketleri yapılandırılıyor. Lütfen daha sonra tekrar kontrol edin.',
    packNotAvailableYet: 'Henüz mevcut değil',
    checkoutFailed: 'Ödeme Başarısız',
    checkoutFailedMessage: 'Ödeme başlatılamadı. Lütfen tekrar deneyin.',
    purchaseSuccess: 'Satın Alma Başarılı!',
    creditsAdded: 'kredi hesabınıza eklendi!',
    purchaseProcessing: 'Satın Alma İşleniyor',
    purchaseProcessingMessage: 'Ödemeniz işleniyor. Krediler kısa süre içinde görünecek.',
    ok: 'Tamam',
    // Zero credit blocker
    noCreditsAvailable: 'Kredi Yok',
    usedAllCredits: 'Bu ay aboneliğinize dahil {{total}} kredinin tamamını kullandınız.',
    noCreditsToAnalyze: 'Koçluk oturumlarını analiz etmek için krediniz yok.',
    planRequiredToAnalyze: 'Aktif bir plan gerekiyor. Devam etmek için bir plan seçin.',
    creditsWillRefresh: 'Kredileriniz bir sonraki fatura döneminde yenilenecek',
    getMoreCredits: 'Koçluk oturumlarınızı analiz etmeye devam etmek için daha fazla kredi alın.',
    buyMoreCreditsButton: 'Daha Fazla Kredi Al',
    upgradePlan: 'Planı Yükselt',
    cancel: 'İptal',
    // Paylaşım
    recentlyShared: 'Son Paylaşılanlar',
    viewAllShared: 'Tümünü Gör',
    sharedBy: 'Gönderen',
    noRecentShared: 'Henüz paylaşılan belge yok',
    unknown: 'Bilinmiyor',
    welcomePlanTitle: 'AI Karşılama Planın',
    welcomePlanSubtitle: 'Onboarding yanıtlarına göre hazırlanan kişiselleştirilmiş mesajla başla.',
    welcomePlanOpen: 'Karşılama planını aç',
    welcomePlanFallbackPreview: 'Kişiselleştirilmiş karşılama planın hazır. Mentor Coaching AI\'ın senin için hazırladığı sonraki adımları görmek için aç.',
    activationChecklistTitle: 'Aktivasyon Kontrol Listesi',
    uploadFirstSession: 'İlk oturumunu yükle',
    sampleSessionTitle: 'PCC demo oturumu',
    sampleSessionMeta: '38 dk · anonimleştirilmiş gerçek örnek analiz',
    sampleSessionOpen: 'PCC örnek oturum raporunu aç',
    sampleBadge: 'ÖRNEK',
    levelUpChecklistTitle: 'Seviyeni yükselt',
    activationChecklistProgress: '{{completed}}/{{total}} tamamlandı',
    levelUpChecklistComplete: 'MCAi\'ın sunduğu her şeyi keşfettin 🎓',
    activationItems: {
      profile: 'Koçluk profilini oluştur',
      upload: 'İlk oturumunu yükle',
      analysis: 'İlk analizini çalıştır',
      reply: 'AI koçuna yanıt ver',
      pdfExport: 'Analizini PDF olarak dışa aktar',
      icfProgress: 'ICF ilerlemeni kontrol et',
      developmentPlan: 'Gelişim planını incele',
      practiceExam: 'Bir deneme sınavı sorusu çöz',
      documents: 'Kütüphanene bir belge ekle',
    },
    activationGoalTitle: 'İlk oturumun seni {{goal}} hedefine yaklaştırabilir',
    activationGoalWithCredentialsBody: '{{credentials}} geçmişinle, gerçek bir oturum yüklemek {{goal}} hedefine ilerlemenin en hızlı yoludur.',
    activationGoalBody: 'Gerçek bir oturum yükle veya bir sohbet başlatarak planını {{goal}} hedefine dönüştür.',
    activationCredentialsBody: '{{credentials}} geçmişinle, ilk yüklemen mevcut pratiğine uygun geri bildirim sağlayacaktır.',
    activationScreenBadge: 'İlk analiz',
    activationScreenTitle: 'İlk Oturumunu Yükle',
    activationScreenSubtitle: 'Mentor Coaching AI\'ı çalışırken görmenin en hızlı yolu gerçek bir koçluk oturumu yüklemek ya da önce örnek analizi denemektir.',
    activationScreenGoal: 'Merhaba {{firstName}}, {{goal}} hedefine ilerlemenin en hızlı yolu bir gerçek koçluk oturumu yüklemek ya da akışı örnek analizle önizlemektir.',
    activationGreetingName: 'koç',
    activationScreenWhyTitle: 'Neden buradan başlamalısın',
    activationScreenWhyOne: 'Kendi oturumundan transkript, analiz ve somut ICF uyumlu koçluk geri bildirimi alırsın.',
    activationScreenWhyTwo: 'Karşılama planın, gerçek bir konuşmayla beslendiğinde çok daha faydalı hale gelir.',
    activationScreenWhyThree: 'Henüz yüklemeye hazır değilsen deneyimi örnek bir oturumla yine de önizleyebilirsin.',
    activationScreenPrimaryCta: 'Ses kaydını yükle',
    activationScreenSecondaryCta: 'Önce örnek analizi dene',
    activationScreenPracticeCta: 'Yapay zeka müşteriyle pratik yap',
    activationScreenContinueCta: 'Anasayfaya devam et',
    practiceSession: {
      eyebrow: 'Yapay zekâ destekli onboarding',
      title: 'Yapay zeka müşteriyle pratik yap',
      subtitle: 'ICF yetkinliklerini prova etmek için gerçekçi bir koçluk konuşması yürüt.',
      description: 'Bir senaryo seç ve yapay zeka müşteriyi istediğin kadar tur boyunca doğal biçimde koçla.',
      startCta: 'Pratik oturumunu başlat',
      starting: 'Pratik oturumu başlatılıyor...',
      sending: 'Gönderiliyor...',
      startPrompt: 'Pratik oturumunu başlatalım.',
      sessionPrefix: 'Pratik',
      sessionHint: 'Koç rolünde kal. Yapay zeka müşteri rolünde kalacak.',
      inputPlaceholder: 'Müşteriyi burada koçla...',
      startFailed: 'Pratik oturumu başlatılamadı. Lütfen tekrar dene.',
      replyFailed: 'Mesajın gönderilemedi. Lütfen tekrar dene.',
      scenarios: {
        overwhelmedLeader: {
          title: 'Bunalmış lider',
          description: 'Yeni terfi almış bir yönetici fazla yük altında, her şeyi üstleniyor ve tükenmeye yaklaşıyor.',
          context: 'Müşteri yeni terfi almış bir ekip lideri. Her şeye evet diyor, herkesin sorumluluğunu kendinde hissediyor ve hem işte hem evde enerjisi düşüyor.',
        },
        careerTransition: {
          title: 'Kariyer geçişi',
          description: 'Kıdemli bir profesyonel değişim istiyor ama adımı sürekli sorguluyor.',
          context: 'Müşteri daha anlamlı bir işe geçmek istiyor, fakat finansal korkular ve kimlik kaybı endişesi nedeniyle kararsız kalıyor.',
        },
        confidenceAfterFeedback: {
          title: 'Geri bildirim sonrası özgüven',
          description: 'Bir koç zor bir geri bildirimden sonra ivmesini kaybetti ve kendi yeterliliğinden şüphe duyuyor.',
          context: 'Müşteri aktif çalışan bir koç. Son oturumundan sonra aldığı sert geri bildirim nedeniyle tereddütlü, kendine karşı daha eleştirel ve içgüdülerine daha az güveniyor.',
        },
      },
    },
  },

  // Chat
  chat: {
    activationCelebrationTitle: 'İlk analizin hazır 🎉',
    activationCelebrationBody: 'Artık çoğu koçun tüm akreditasyon yolculuğunda yalnızca 3–5 kez alabildiği geri bildirimi alıyorsun.',
    activationCelebrationCta: 'Geri bildirimini oku',
    samplePreviewBadge: 'ÖRNEK — gerçek analizin burada görünecek',
    samplePreviewTitle: 'PCC demo oturumu analizi',
    samplePreviewSummary: 'Sekiz yetkinliğin tamamında işaretçi kanıtları ve odaklı bir gelişim planıyla PCC seviyesinde performans.',
    samplePreviewQuestionOne: 'Aktif dinlemede neyi geliştirebilirim?',
    samplePreviewAnswerOne: 'Yeniden çerçevelemeden önce müşterinin kendi dilinde biraz daha kal; ardından duyduğun gerilimi yansıt ve sonraki yönü müşterinin seçmesine alan aç.',
    samplePreviewOpen: 'Gerçek örnek raporu keşfet',
    fileFallback: 'Dosya',
    referenceTruncated: 'Dosya eklendi, ancak uzun olduğu için yalnızca ilk bölümü bağlam olarak tutuldu.',
    referenceAttachFailed: 'Bu dosya eklenemedi.',
    referenceRemoveFailed: 'Bu dosya kaldırılamadı.',
    webSuggestionStrength: 'En güçlü ICF davranışım neydi?',
    webSuggestionImprove: 'Bir sonraki oturumda neye odaklanayım?',
    webSuggestionPcc: 'PCC seviyesi için hazır mıyım?',
    webUsageChat: 'Sohbet',
    webUsageCountUnavailable: 'Kullanım sayısı yüklenemedi',
    webUsageDaily: 'Günlük limit',
    trialUsageLabel: 'Ücretsiz deneme',
    trialUsageSummary: 'Deneme: {{used}}/{{total}} sohbet · {{hours}} sa kaldı',
    trialChatsValue: '{{used}}/{{total}} sohbet',
    trialUsageRemaining: '{{remaining}} kaldı · {{hours}} sa kaldı',
    trialAnalysisLabel: 'Deneme analizi',
    trialAnalysisRemaining: 'Denemede {{total}} haktan {{remaining}} kaldı',
    trialVoiceLabel: 'Deneme ses dakikası',
    trialVoiceUsage: 'Denemede {{total}} dakikanın {{used}} dakikası kullanıldı',
    trialUsageTitle: 'Ücretsiz deneme hakkı',
    trialUsageExplanation: 'Deneme sürenizin sonuna kadar toplam {{total}} sohbet hakkınız var.',
    webUsageAnalysis: 'Analiz',
    webUsageUnlimitedAnalysis: 'Sınırsız analiz',
    webSchoolPlanIncluded: 'Kurum paketi',
    webUsageMonthly: 'aylık kullanım',
    webUsageCredits: 'Kredi bakiyesi',
    webUsageVoice: 'Ses süresi',
    webUsageUsed: 'kullanıldı',
    webUsageTotal: 'toplam hak',
    webUsageTranscription: 'Transkripsiyon dakikası',
    webTranscriptReady: 'Transkript hazır',
    webAnalysisDone: 'ICF analizi tamamlandı',
    removeReference: 'Referansı kaldır',
    attachAnalyzeOption: 'Analiz için transkript yükle',
    attachReferenceOption: 'Referans dosya ekle',
    attachMenu: 'Dosya ekle',
    dropToAttach: 'Bırak — referans dosyası olarak eklenecek',
    webComposerPlaceholder: 'Takip sorusu sor...',
    webFileSummary: 'Dosya özeti',
    webSecurelySaved: 'Güvenle saklandı',
    webAnalysisSummary: 'Analiz özeti',
    webType: 'Tür',
    webIcfAssessment: 'ICF değerlendirmesi',
    webLanguage: 'Dil',
    webLevel: 'Seviye',
    webMessages: 'Mesaj',
    webProgressNote: 'Her analiz ilerleme takibine eklenebilir ve güvenle saklanır.',
    title: 'Koç AI',
    subtitle: 'Yapay zeka koçluk asistanınız',
    placeholder: 'Mesajınızı yazın...',
    send: 'Gönder',
    thinking: 'AI düşünüyor...',
    error: 'Mesaj gönderilemedi',
    retry: 'Tekrar Dene',
    newConversation: 'Yeni Konuşma',
    conversations: 'Konuşmalar',
    noMessages: 'AI koçunuzla konuşmaya başlayın',
    welcomeMessage: 'Merhaba! Ben sizin AI koçluk asistanınızım. Bugün size nasıl yardımcı olabilirim?',

    // Enhanced Chat Screen
    session: 'Oturum',
    loading: 'Sohbet yükleniyor...',
    failedToLoadSessions: 'Sohbet oturumları yüklenemedi',
    failedToLoadMessages: 'Mesajlar yüklenemedi',
    viewSessions: 'Oturumları göster',
    attachDocument: 'Dosya ekle',
    newSession: 'Yeni oturum',
    messagesCount: '{{count}} mesaj',
    tapToSwitch: 'Oturum değiştirmek için dokunun',
    chats: 'Sohbetler',
    transcripts: 'Transkriptler',
    dailyChats: 'Günlük Sohbet',
    monthlyTranscripts: 'Aylık Transkript',
    extraCredits: 'Ekstra Kredi',
    webSchoolPlan: 'Okul paketi',
    webCredits: 'kredi',
    webCreditStatus: 'Kredi durumu',
    yourAllowances: 'Haklarınız',
    dailyChatsTitle: 'Günlük Sohbetler',
    monthlyTranscriptsTitle: 'Aylık Transkriptler',
    purchasedCreditsTitle: 'Satın Alınan Krediler',
    dailyChatsExplanation: 'Mevcut planınız günde {{limit}} sohbet mesajı içerir. Bu hak her gün gece yarısı sıfırlanır.',
    monthlyTranscriptsExplanation: 'Mevcut planınız ayda {{limit}} transkript analizi içerir. Yüklediğiniz ve analiz ettiğiniz her belge bir kredi kullanır. Bu hak her ayın başında sıfırlanır.',
    purchasedCreditsExplanation: 'Bunlar ayrıca satın aldığınız ekstra kredilerdir. Hiçbir zaman sona ermezler ve her zaman abonelik hakkınızdan önce kullanılırlar.',

    // Quota messages
    quotaExceeded: 'Günlük Limit Aşıldı',
    dailyLimitMessage: 'Günlük {{limit}} mesaj limitinize ulaştınız. Lütfen yarın tekrar deneyin veya planınızı yükseltin.',
    transcriptQuotaExceeded: 'Aylık Transkript Limiti Aşıldı',
    monthlyTranscriptLimitMessage: 'Aylık {{limit}} transkript analizi limitinize ulaştınız. Lütfen gelecek ay tekrar deneyin veya planınızı yükseltin.',
    sendingMessage: 'Mesaj gönderiliyor...',
    aiThinking: '🤔 AI düşünüyor... Bu biraz zaman alabilir.',
    processing: 'İşleniyor...',
    sendFailed: 'Mesaj gönderilemedi',

    // File analysis
    filePickError: 'Dosya seçme hatası',
    defaultAnalysisInstructions: 'Bu koçluk oturumu transkriptini ICF standartlarına göre analiz et ve değerlendirme yap. Koçun yetkinliklerini, güçlü yanlarını ve gelişim alanlarını belirt.',
    quickTemplates: 'Hızlı Şablonlar',
    pccSessionAnalysis: 'PCC Görüşme Analizi',
    fileUploaded: '📎 Dosya yüklendi: {{filename}}',
    analyzingDocument: 'Analiz ediliyor... Bu biraz sürebilir. Koçluk şakası ister misin? "Güçlü soruyu sordum; şimdi sessizliği koçluyorum." 😊',
    analysisError: 'Analiz Hatası',
    analysisFailed: 'Dosya analiz edilemedi',
    analysisInstructionsRequired: 'Lütfen analiz talimatlarını girin',
    uploadTranscriptPromptTitle: 'Transkript yükleyin',
    uploadTranscriptPromptMessage: 'Devam etmek için lütfen transkript dosyanızı yükleyin (.docx, .pdf, .txt).',
    uploadTranscriptPromptAction: 'Dosya yükle',

    // Modals
    analysisInstructions: 'Analiz Talimatları',
    analyze: 'Analiz Et',
    howToAnalyze: 'AI\'nın bu dosyayı nasıl analiz etmesini istiyorsunuz?',
    analysisPlaceholder: 'Örnek: Bu koçluk oturumu transkriptini ICF standartlarına göre analiz et...',
    icfProgressTracking: 'ICF İlerleme Takibi',
    icfProgressDescription: 'Bu analiz sonuçlarını ICF ilerleme takibine dahil et',
    examples: 'Örnekler',
    examplePCC: 'Bu koçluk oturumu transkriptini ICF standartlarına göre analiz et ve PCC seviyesinde değerlendir.',
    exampleStrengths: 'Bu transkriptteki koçun güçlü yanlarını ve gelişim alanlarını belirt. Özel örnekler ver.',
    exampleQuestions: 'Bu oturumda koçun kullandığı soruların kalitesini analiz et ve daha etkili soru önerileri sun.',
    examplePccMarkers: 'Her ICF PCC işaretçisini Gözlemlendi/Gözlemlenmedi olarak listeleyin; gözlemlenen işaretçiler için zaman damgası ve kısa alıntı ekleyin.',
    exampleNegativeReflection: 'Koçun müşterinin ifade ettiği olumsuz duygu ve ifadeleri duyup yansıtıp yansıtmadığını değerlendir; eksikse ilgili ICF yetkinliklerinde açıkça uyar.',
    pccEvaluation: 'PCC Değerlendirmesi',
    strengthsAndDevelopment: 'Güçlü Yanlar & Gelişim',
    questionAnalysis: 'Soru Analizi',

    // Transcript analyzed indicator
    transcriptAnalyzedBadge: 'Bu sohbette transkript analiz edildi',

    // Sessions list
    chatSessions: 'Sohbet Oturumları',
    newChat: 'Yeni Sohbet',
    noConversations: 'Henüz konuşma yok',
    startFirstChat: 'İlk sohbetinizi başlatın!',
    renameSession: 'Oturumu Yeniden Adlandır',
    sessionTitlePlaceholder: 'Oturum başlığını girin...',
    sessionRenamed: 'Oturum başarıyla yeniden adlandırıldı',
    renameFailed: 'Oturum yeniden adlandırılamadı',
    deleteConversation: 'Konuşmayı Sil',
    deleteConfirmTitle: 'Konuşma Silinsin mi?',
    deleteConfirmMessage: 'Bu konuşmayı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    delete: 'Sil',
    deleteSuccess: 'Konuşma silindi',
    deleteFailed: 'Konuşma silinemedi',

    // UI
    startConversation: 'Konuşmaya başla',
    conversationDescription: 'Koçluk materyalleriniz hakkında sorular sorun veya analiz için belge yükleyin',
    sources: 'Kaynaklar',
    downloadPdf: 'PDF indir',
    downloadStandardPdf: 'Analizi indir (PDF)',
    downloadObservationPdf: 'Gözlem formunu indir (PDF)',
    exportPdfFailed: 'PDF dışa aktarılamadı. Lütfen tekrar deneyin.',
    dailyLimitReached: 'Günlük sohbet limiti doldu ({{used}}/{{limit}}). Yarın tekrar deneyin veya planınızı yükseltin.',
    limitExceededPlaceholder: 'Sohbet limiti aşıldı',
    messagePlaceholder: 'Mentor Coaching AI\'ya sor...',
    analysisInProgress: 'Analiz devam ediyor, lütfen bekleyin...',
    tip: 'İpucu',
    waitingTips: {
      title: 'Kısa not',
      tip1: 'Transkript analizlerini her zaman yeni sohbet içinde yapmanızı öneriyoruz.',
      tip2: 'Analiz sonrasında sorularınızı aynı sohbet içinde sorabilirsiniz.',
      tip3: 'Transkriptlerinizde koç/müşteri ayrımı ve zaman damgalarının olmasına dikkat ediniz.',
      tip4: 'Yeni sohbet içinde transkript yüklemek için ataç ikonunu kullanabilirsiniz.',
      tip5: 'Yeni sohbet açmak için + ikonunu kullanabilirsiniz.',
      tip6: 'Transkriptlerinizi yüklerken ICF İlerleme butonunu aktif edip ICF Yetkinlik bazında gelişiminizi takip edebilirsiniz.',
      tip7: 'Analizlerin çalışma prensibi, sınırları ve sorumlu kullanım için Hizmet Şartları’nı okumanızı öneririz.',
      tip8: 'Sizin ve müşterinizin verilerinin güvenliği için Gizlilik Politikası’nı okuyunuz.',
      tip9: 'Hesap ayarlarınıza, fatura ve ödemelerinize Profil ve Ayarlar bölümünden ulaşabilirsiniz.',
      tip10: 'Satın aldığınız pakete göre, üyelik boyunca, transkript haklarınız her ay yenilenecektir.',
      tip11: 'Paketler arası geçiş yapabilirsiniz.',
    },
    enterNewTitle: 'Bu oturum için yeni bir başlık girin',
    aiDisclaimer: 'Yapay zeka hata yapabilir. Önemli bilgileri lütfen doğrulayın.',
  },

  // Alerts & Confirmations
  alerts: {
    connectionError: 'Bağlantı hatası. Lütfen internet bağlantınızı kontrol edin.',
    sessionExpired: 'Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın.',
    unsavedChanges: 'Kaydedilmemiş değişiklikleriniz var. Çıkmak istediğinizden emin misiniz?',
  },
  errors: {
    connectionUnavailable: 'Bağlantı kurulamadı. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.',
    serverUnavailable: 'Sunucuya şu anda erişilemiyor. Lütfen biraz sonra tekrar deneyin.',
    timeout: 'İşlem beklenenden uzun sürdü. Lütfen tekrar deneyin.',
    rateLimited: 'Kısa sürede çok fazla istek gönderildi. Lütfen biraz bekleyip tekrar deneyin.',
    voiceMinutesExceeded: 'Ses transkripsiyonu dakika limitine ulaşıldı. Planınız ayda {{limit}} dakika içeriyor; satın alınan paketler dahil yaklaşık {{remaining}} dakika kaldı.',
    voiceMinutesExceededTrial: 'Deneme ses transkripsiyonu limitine ulaşıldı. 3 günlük denemeniz {{limit}} dakika içeriyor; yaklaşık {{remaining}} dakika kaldı. Transkripsiyona devam etmek için bir plan seçin.',
    voiceMinutesExceededGeneric: 'Ses transkripsiyonu dakika limitine ulaşıldı. Transkripsiyon dakikası satın alın veya daha kısa bir kayıt yükleyin.',
    sessionExpired: 'Oturum süreniz dolmuş olabilir. Lütfen tekrar giriş yapın.',
    genericRetry: 'Bir sorun oluştu. Lütfen tekrar deneyin.',
  },

  // Settings
  settings: {
    title: 'Ayarlar',
    language: 'Dil',
    notifications: 'Bildirimler',
    privacy: 'Gizlilik',
    support: 'Destek',
    about: 'Hakkında',
    version: 'Sürüm',
  },

  // Profile & Subscription
  profile: {
    billingCycle1mo: '1 ay',
    billingCycle3mo: '3 ay',
    billingCycle6mo: '6 ay',
    developmentPlan: {
      title: 'Gelişim Planı',
      nextLabel: 'İleri',
      lastUpdated: 'Son güncelleme',
      empty: 'Henüz gelişim planı yok. Yapay zekanın her analizde ve sohbette başvuracağı kişiselleştirilmiş bir yol haritası oluşturmak için plan oluştur.',
      refreshSuccessTitle: 'Plan yenilendi',
      refreshSuccessMessage: 'Gelişim planın güncel.',
      refreshFailedTitle: 'Yenilenemedi',
      refreshFailedMessage: 'Lütfen biraz sonra tekrar dene.',
      refreshing: 'Yenileniyor…',
      refreshCta: 'Planı yenile',
      generateCta: 'Plan oluştur'
    },
    title: 'Profil ve Abonelik',
    loading: 'Profil yükleniyor...',
    failedToLoad: 'Profil yüklenemedi',
    retry: 'Tekrar Dene',
    webTitle: 'Profil',
    webSubtitle: 'Hesap ayarlarını, güvenliği ve kullanım bilgilerini tek yerden yönet.',
    webLogout: 'Çıkış yap',
    webEditProfile: 'Profili düzenle',
    webLanguagePreferences: 'Dil tercihleri',
    webLanguageMeta: 'Uygulama ve e-posta dili',
    webAccountSecurity: 'Hesap ve güvenlik',
    webPasswordTitle: 'Şifre',
    webPasswordSubtitle: 'Şifreni değiştir.',
    webBillingTitle: 'Abonelik ve fatura',
    webBillingSubtitle: 'Planını ve ödeme ayarlarını yönet.',
    webPlanTitle: 'Planın',
    webManagePlan: 'Planı yönet',
    webCancelSubscription: 'Aboneliği iptal et',
    webCancelSubscriptionSubtitle: 'Yenilemeyi bu hesaptan durdur.',
    cancelTrial: 'Denemeyi iptal et',
    cancelTrialSubtitle: 'Deneme ücretlendirilmeden önce yenilemeyi durdur.',
    cancelTrialMessage: 'Erişimi deneme bitişine kadar korumayı veya denemeyi şimdi sonlandırmayı seç. İptalden sonra ücret alınmaz.',
    cancelTrialAtEndButton: 'Deneme sonunda iptal et',
    cancelTrialAtEndDescription: 'Deneme bitene kadar erişimi koru ve ücret alınmadan önce durdur.',
    cancelTrialNowButton: 'Denemeyi bugün bitir',
    cancelTrialNowDescription: 'Deneme erişimini hemen sonlandır. Ücret alınmaz.',
    cancelTrialSuccessImmediate: 'Denemen sona erdi. Ücret alınmayacak.',
    cancelTrialSuccessScheduled: 'Denemen son tarihe kadar devam eder ve ardından ücret alınmadan sona erer.',
    resumeTrialRenewal: 'Yenilemeyi devam ettir',
    resumeTrialSuccess: 'Deneme yenilemesi yeniden açıldı. Tekrar iptal etmezsen deneme sonunda kartından ücret alınır.',
    trialSetToEnd: 'Deneme mevcut bitiş tarihinde ücret alınmadan sona erecek.',
    choosePlan: 'Plan seç',
    choosePlanBeforeTrialEnds: 'Erişimini korumak için deneme bitmeden abone ol.',
    choosePlanToRestoreAccess: 'Platformu kullanmaya devam etmek için bir plan seç.',
    trialCardLabel: 'Ücretsiz deneme · Kart kayıtlı',
    trialNoCardLabel: 'Ücretsiz deneme · Kart gerekmez',
    trialEndsOn: 'Bitiş',
    trialActive: 'Deneme aktif',
    trialCardNotice: 'Önceden iptal etmezsen deneme sona erdiğinde kayıtlı ödeme yönteminden ücret alınır.',
    trialNoCardNotice: 'Denemen mevcut bitiş tarihinde sona erer; otomatik yenilenmez ve ücret alınmaz.',
    priceAfterTrial: 'Deneme sonrası {{price}}',
    afterTrial: 'deneme sonrası',
    trialLessThanHour: '1 saatten az kaldı',
    trialHoursRemaining: '{{count}} saat kaldı',
    trialDaysRemaining: '{{count}} gün kaldı',
    trialAnalyses: 'Deneme analizleri',
    trialChats: 'Deneme sohbetleri',
    trialLifetimeLimit: 'Bu deneme için',
    webBillingPortalTitle: 'Ödeme yöntemi ve faturalar',
    webBillingPortalSubtitle: 'Stripe fatura detaylarını aç.',
    webMonthlyTranscripts: 'Bu ayki transkript',
    webDailyChat: 'Günlük sohbet',
    webCreditBalance: 'Kredi bakiyesi',
    webCreditHint: 'Ek analiz ve raporlar için kullanılır.',
    webBuyCredits: 'Kredi satın al',
    webPrivacyData: 'Gizlilik ve veriler',
    webExportDataTitle: 'Verilerini indir',
    webExportDataSubtitle: 'Hesabındaki verileri indir.',
    webPrivacyPolicyTitle: 'Gizlilik politikası',
    webPrivacyPolicySubtitle: 'Gizlilik politikamızı oku.',
    webDeleteAccountTitle: 'Hesabı kapat',
    webDeleteAccountSubtitle: 'Hesabını ve verilerini kalıcı olarak sil.',
    webCoachingProfileTitle: 'Koçluk profili',
    webCoachingProfileCopy: 'Başlangıç yanıtlarına göre kişisel önerilerini yeniden oluşturabilirsin.',
    webRegenerateProfile: 'Koçluk profilini yenile',
    webReplayTraining: 'Rehberli turu yeniden başlat',
    webReplayTrainingSubtitle: 'Her şeyin nerede olduğunu adım adım gör.',

    // Profile Information
    profileInformation: 'Profil Bilgileri',
    name: 'Ad Soyad',
    email: 'E-posta',
    memberSince: 'Üyelik tarihi',
    accountType: 'Hesap türü',
    notSet: 'Belirlenmedi',
    unverified: 'Doğrulanmadı',

    // Subscription Details
    subscriptionDetails: 'Abonelik Detayları',
    active: 'Aktif',
    inactive: 'Aktif değil',
    perMonth: '/ay',
    nextBillingDate: 'Sonraki fatura tarihi',
    cancelAtPeriodEnd: '⚠️ Abonelik dönem sonunda iptal edilecek',
    pendingPlanChange: 'Plan {{date}} tarihinde {{plan}} olacak.',

    // Plan Types
    planIndividual: 'Öğrenci',
    planAdvanced: 'Sertifika Hazırlığı',
    planProfessional: 'Mentor Koç',
    planUnknown: 'Bilinmeyen',
    planIndividualDescription: 'Ayda birkaç gerçek koçluk oturumunu inceleyen öğrenciler için.',
    planAdvancedDescription: 'Seviye seçimi, işaretçi tabloları ve ICF uyumlu dışa aktarım araçlarına ihtiyaç duyan unvan adayları için.',
    planProfessionalDescription: 'Daha çok oturum değerlendiren ve özel analiz akışları isteyen mentor koçlar için.',
    priceUnavailable: 'Fiyat mevcut değil',

    // Usage & Credits (unified section)
    planAndUsage: 'Plan ve Kullanım',
    usageStatistics: 'Kullanım İstatistikleri',
    dailyChats: 'Günlük Sohbetler',
    monthlyChats: 'Aylık Sohbetler',
    monthlyTranscripts: 'Aylık Transkriptler',
    documents: 'Dökümanlar',
    storage: 'Depolama (MB)',
    dailyChatsShort: 'Günlük Sohbet',
    monthlyTranscriptsShort: 'Aylık Transkript',
    extraCreditsShort: 'Ekstra Kredi',
    resetsDaily: 'Her gün yenilenir',
    resetsMonthly: 'Her ay yenilenir',
    neverExpires: 'Süresi dolmaz',
    usedOf: '{{used}} / {{limit}}',

    // Account Management
    accountManagement: 'Hesap Yönetimi',
    editProfile: 'Profili Düzenle',
    changeLanguage: 'Dili Değiştir',
    changePlan: 'Planı Değiştir',
    cancelSubscription: 'Aboneliği İptal Et',
    manageSubscription: 'Aboneliği Yönet',
    exportData: 'Verilerimi İndir',
    deleteAccount: 'Hesabı Sil',

    // Edit Profile Modal
    editProfileTitle: 'Profili Düzenle',
    fullName: 'Ad Soyad',
    save: 'Kaydet',
    cancel: 'İptal',
    profileUpdated: 'Profil başarıyla güncellendi',
    enterFullName: 'Lütfen adınızı ve soyadınızı girin',
    updateFailed: 'Profil güncellenemedi',

    // Change Plan Modal
    changePlanTitle: 'Aboneliği Güncelle',
    changePlanDescription: 'İstediğiniz plan ve faturalama dönemini seçin. Prorasyon otomatik yapılır.',
    planTierLabel: 'Plan seviyesi',
    billingCycleLabel: 'Faturalama dönemi',
    billingCycleMonthly: 'Aylık',
    billingCycleYearly: 'Yıllık',
    updatePlan: 'Planı güncelle',
    planChangedSuccess: 'Abonelik başarıyla güncellendi.',
    planChangeFailed: 'Abonelik güncellenemedi.',
    viewPlanDetails: 'Plan karşılaştırmasını görüntüle',
    planDetailsLinkFailed: 'Plan detayları açılamadı. Lütfen tekrar deneyin.',
    viewInvoice: 'Makbuzu görüntüle',
    loadingPricing: 'Güncel fiyatlar yükleniyor…',
    // Plan değişikliği onay metni (BIL-L05): Stripe önizlemesinden.
    planChangeSummaryTitle: 'Neler değişir',
    planChangePreviewLoading: '{{current}} planından {{target}} planına geçişin bugünkü tutarı hesaplanıyor…',
    planChangeFallbackTitle: 'Tutar faturanızda gösterilir',
    planChangeFallbackMessage: 'Bugünkü tutarı yükleyemedik. Yükseltmede fatura döneminizin kalanı için ücret hemen alınır ve kesin tutar faturanızda gösterilir. Düşürme, fatura döneminizin sonunda geçerli olur ve bugün ücret alınmaz.',
    planChangeFallbackDueToday: 'Faturada gösterilir',
    planChangeFallbackPauseNotice: 'Planlanmış bir duraklatmanız varsa, plan değişikliği onu iptal eder.',
    planChangeUpgradeTitle: 'Bugün tahsil edilir',
    planChangeUpgradeMessage: '{{current}} planından {{target}} planına şimdi geçiyorsunuz. Mevcut fatura döneminizin kalanı için bugün {{amount}} tahsil edilir.',
    planChangeUpgradeNewPeriodMessage: '{{current}} planından {{target}} planına şimdi geçiyorsunuz ve yeni fatura döneminiz bugün başlıyor. Mevcut planınızın kullanılmayan süresi düşüldükten sonra bugün {{amount}} tahsil edilir.',
    planChangeNoChargeTitle: 'Bugün ücret alınmaz',
    planChangeDowngradeMessage: 'Bugün ücret alınmaz. Planınız {{date}} tarihinde {{target}} olarak değişir; o tarihe kadar {{current}} planınız devam eder.',
    planChangeTrialMessage: 'Bugün ücret alınmaz. Deneme süreniz devam eder; {{target}} planı deneme {{date}} tarihinde bittiğinde {{price}} ile başlar.',
    planChangeSamePlanTitle: 'Mevcut plan',
    planChangeSamePlanMessage: '{{current}} mevcut planınız. Değiştirmek için başka bir plan veya fatura dönemi seçin.',
    planChangeKeepPlanMessage: 'Bugün ücret alınmaz. {{current}} planınız devam eder ve {{target}} planına planlanan geçiş iptal edilir.',
    planChangeKeepRenewingMessage: 'Bugün ücret alınmaz. {{current}} planınız devam eder ve aboneliğiniz sona ermek yerine {{date}} tarihinde yenilenir.',
    planChangeRenewalNote: 'Planınız ardından {{date}} tarihinde {{price}} ile yenilenir.',
    planChangeDueTodayLabel: 'Bugün ödenecek',
    planChangePauseNotice: 'Planınızı değiştirmek, bu fatura döneminin sonuna planlanan duraklatmayı iptal eder.',
    planChangePaymentPendingTitle: 'Ödeme gerekli',
    planChangePaymentPendingMessage: 'Bu plan değişikliğinin ödemesi gerçekleşmedi, bu yüzden planınız değişmedi. Değişikliği tamamlamak için faturayı ödeyin veya kartınızı güncelleyin.',
    planChangePayInvoice: 'Faturayı öde',
    currentPlanLabel: 'Mevcut plan',
    newPlanLabel: 'Yeni plan',
    planBillingNote: 'Gelecekteki faturalar her {{interval}} {{price}} tutarında olacaktır.',
    planAcknowledgeUpgradeLabel: 'Bugün ödeme yöntemimden {{amount}} tahsil edileceğini kabul ediyorum.',
    planAcknowledgeDowngradeLabel: 'Planımın mevcut fatura döneminin sonunda değişeceğini ve bugün ücret alınmayacağını kabul ediyorum.',
    planAcknowledgeKeepPlanLabel: 'Mevcut planımın devam edeceğini ve bugün ücret alınmayacağını kabul ediyorum.',
    planAcknowledgeFallbackLabel: 'Yükseltmede bugün ücret alınacağını ve kesin tutarın faturamda gösterileceğini kabul ediyorum.',
    planAcknowledgeTrialLabel: 'Bugün ücret alınmayacağını ve yeni planın deneme süresi bitince faturalanacağını kabul ediyorum.',
    planInvoiceLinkFailed: 'Fatura bağlantısı açılamadı. Lütfen bağlantınızı kontrol edin.',

    // Language Selection Modal
    selectLanguage: 'Dil Seç',
    selectLanguageDescription: 'Uygulama için tercih ettiğiniz dili seçin',
    languageChanged: 'Dil başarıyla değiştirildi',
    update: 'Güncelle',

    // Cancel subscription
    cancelSubscriptionMessage: 'Hesabınızı silmeden iptal edin. Mevcut fatura döneminin sonuna kadar erişiminiz sürer ve tekrar ücret alınmaz.',
    cancelAtPeriodEndButton: 'Mevcut dönem sonunda',
    cancelOptionScheduledDescription: 'Mevcut fatura dönemi bitene kadar erişimi koru.',
    cancelSuccessScheduled: 'Aboneliğiniz dönem sonuna kadar aktif kalacak.',
    pausedFromUntil: '{{from}} - {{until}} arası duraklatıldı',
    cancelPausedMessage: 'Aboneliğiniz duraklatılmış durumda. İptal ederseniz hemen sona erer ve tekrar ücret alınmaz.',
    cancelPausedButton: 'Şimdi sonlandır',
    cancelPausedDescription: 'Duraklatılmış abonelik bugün sona erer. Ücret alınmaz.',
    cancelPausedSuccess: 'Aboneliğiniz sona erdi. Tekrar ücret alınmayacak.',
    cancelFailed: 'Abonelik iptal edilemedi.',
    cancelReasonPrompt: 'İptal etmenizin temel nedeni nedir?',
    cancelReasonNotePlaceholder: 'Daha fazla bilgi verin (isteğe bağlı)',
    cancelReason: {
      too_expensive: 'Çok pahalı',
      done_with_credential: 'Unvan hedefimi tamamladım',
      not_useful: 'Benim için yeterince faydalı değil',
      technical: 'Teknik sorunlar',
      not_using: 'Yeterince kullanmıyorum',
      missing_features: 'İhtiyacım olan özellikler eksik',
      switching: 'Başka bir araca geçiyorum',
      temporary_break: 'Sadece geçici bir mola vermem gerekiyor',
      other: 'Diğer',
      eu_withdrawal: 'AB cayma hakkı (iade gerekli)',
    },
    withdrawal: {
      panelTitle: 'Cayma hakkı',
      action: 'Sözleşmeden cayma hakkını buradan kullan',
      availableUntil: 'Abonelik sözleşmenden {{date}} tarihine kadar cayabilirsin.',
      confirmTitle: 'Abonelik sözleşmenden caymak istiyor musun?',
      pointEndsNow: 'Aboneliğin hemen sona erer ve ücretli özellikler hemen kapanır.',
      pointRefund: 'Ödemeni 14 gün içinde kartına iade ederiz.',
      pointTrialNoCharge: 'Deneme sürecindesin; senden ücret alınmadı ve alınmayacak.',
      pointCredits: 'Satın aldığın kredi paketleri hesabında kalır.',
      pointEmail: 'Cayma talebini aldığımızı e-postayla onaylarız.',
      keep: 'Aboneliğimi koru',
      confirm: 'Caymayı onayla',
      success: 'Cayma talebin alındı. E-postana bir onay gönderdik.',
      notAvailable: 'Bu abonelik için cayma süresi sona erdi. Yardım için support@mentorcoaching.ai adresine yazabilirsin.',
      failed: 'Cayma talebini işleyemedik. Lütfen tekrar dene veya support@mentorcoaching.ai adresine yaz.',
    },
    retentionOfferTitle: 'Kalın ve %20 indirim kazanın',
    retentionOfferDescription: 'Aboneliğinizi sürdürün ve önünüzdeki 3 ay boyunca %20 tasarruf edin.',
    retentionOfferAccept: '%20 indirimi kabul et',
    retentionOfferDecline: 'Hayır, iptale devam et',
    retentionOfferSuccess: 'Önünüzdeki 3 ay için %20 indiriminiz uygulandı.',
    retentionOfferFailed: 'Teklif uygulanamadı. Lütfen tekrar deneyin.',
    retentionOffers: {
      firstMonthDiscount: {
        title: 'İlk ayınızda %50 indirime ne dersiniz?',
        description: 'Kalın ve bir sonraki faturanızda yarı fiyat ödeyin — hiçbir şart yok.',
        accept: '%50 indirim al',
        success: 'Bir sonraki faturanıza %50 indirim uygulandı.',
      },
      pause: {
        title: 'Bunun yerine bir mola vermeye ne dersiniz?',
        description: 'Aboneliğinizi mevcut fatura döneminin sonundan itibaren 1 ay duraklatın. O zamana kadar tam erişiminiz sürer. Duraklatma süresince ücret alınmaz ve ücretli özellikler kapalı olur; verileriniz saklanır. Bir ayın sonunda faturalandırma otomatik olarak yeniden başlar.',
        accept: '1 ay duraklat',
        success: 'Aboneliğiniz mevcut fatura döneminin sonunda duraklatılacak ve bir ay sonra otomatik olarak yeniden başlayacak.',
      },
      stay20: {
        title: 'Kalın ve %20 indirim kazanın',
        description: 'Aboneliğinizi sürdürün ve önünüzdeki 3 ay boyunca %20 tasarruf edin.',
        accept: '%20 indirimi kabul et',
        success: 'Önünüzdeki 3 ay için %20 indiriminiz uygulandı.',
      },
      stay20Pack: {
        title: 'Kalın ve %20 indirim kazanın',
        description: 'Aboneliğinizi sürdürün ve bir sonraki yenilemenizde %20 tasarruf edin.',
        accept: '%20 indirimi kabul et',
        success: '%20 indiriminiz bir sonraki yenilemenize uygulandı.',
      },
    },
    noActiveSubscription: 'Bu hesap için aktif abonelik bulunamadı.',
    billingActionTemporarilyUnavailable: 'Faturalama geçici olarak kullanılamıyor. Lütfen birazdan tekrar deneyin.',

    // Resume subscription
    resumeSubscription: 'Aboneliği Devam Ettir',
    resubscribe: 'Yeniden Abone Ol',
    resumeSuccess: 'Aboneliğiniz başarıyla devam ettirildi.',
    resumeFailed: 'Abonelik devam ettirilemedi.',
    cannotResumeSubscriptionStatus: 'Abonelik {{status}} durumundayken devam ettirilemez.',
    subscriptionNotScheduledForCancellation: 'Bu abonelik iptal için planlanmamış.',

    // Delete Account Modal
    deleteAccountTitle: 'Hesabı Sil',
    deleteWarning: 'Bu işlem kalıcıdır ve geri alınamaz. Tüm verileriniz silinecektir.',
    enterPassword: 'Şifrenizi girin',
    typeDeleteConfirm: 'Onaylamak için DELETE yazın',
    deletionReason: 'Silme nedeni (isteğe bağlı)',
    finalConfirmation: 'Son Onay',
    finalConfirmationMessage: 'Bu işlem kalıcıdır ve geri alınamaz. Tüm verileriniz silinecektir.',
    accountDeleted: 'Hesap Silindi',
    accountDeletedMessage: 'Hesabınız başarıyla silindi.',
    deleteConfirmError: 'Onaylamak için DELETE yazın',
    deleteFailed: 'Hesap silinemedi',
    deleteAccountFailedNotDeleted: 'Hesabınız silinemedi ve verileriniz silinmedi. Lütfen tekrar deneyin veya destek ekibiyle iletişime geçin.',
    deleteAccountOutcomeUnknown: 'Hesabınızın silinip silinmediğini doğrulayamadık. Lütfen sayfayı yenileyin; hâlâ giriş yapabiliyorsanız tekrar deneyin veya destek ekibiyle iletişime geçin.',
    deleteAccountBillingFailed: 'Aboneliğiniz iptal edilemediği için hesabınız silinmedi. Lütfen tekrar deneyin veya destek ekibiyle iletişime geçin.',
    deleteAccountRateLimited: 'Çok fazla silme denemesi yapıldı. Lütfen bir saat bekleyip tekrar deneyin.',

    // Export Data
    dataExportDownloaded: 'Verilerin {{filename}} olarak indirildi.',
    exportFailed: 'Veriler indirilemedi',

    // Billing Portal
    redirectToBilling: 'Yönlendirme',
    pleaseVisit: 'Lütfen ziyaret edin',
    billingPortalFailed: 'Fatura portalına erişilemedi',

    // Koçluk Profili
    coachingProfile: 'Koçluk Profili',
    coachingProfileRegenDesc: 'Intake cevaplarınızdan kişiselleştirilmiş koçluk önerilerinizi yeniden oluşturun. Mevcut öneriler değiştirilecek.',
    regenerateCoachingProfile: 'Koçluk Profilini Yenile',
    regenerating: 'Yenileniyor…',
    regenSuccessTitle: 'Profil güncellendi',
    regenSuccessMessage: 'Kişiselleştirilmiş önerileriniz yenilendi.',
    regenFailedTitle: 'Yenileme başarısız',
    regenFailedMessage: 'Yenilenemedi. Lütfen tekrar deneyin.',

    // Yasal & Gizlilik
    legalAndPrivacy: 'Yasal & Gizlilik',
    dataPrivacyNotice: 'Verileriniz size aittir. Bilgilerinizi veya belgelerinizi AI modellerimizi eğitmek veya platformumuzu geliştirmek için kullanmıyoruz.',
    termsOfService: 'Kullanım Şartları',
    privacyPolicy: 'Gizlilik Politikası',
    legalLinkFailed: 'Bağlantı açılamadı. Lütfen tekrar deneyin.',

    // Krediler
    credits: 'Krediler',
    lowCredits: 'Düşük',
    availableCredits: 'Kullanılabilir Krediler',
    subscriptionCredits: 'Abonelik',
    subscriptionCreditsRemaining: 'Planınızdaki aylık analiz kredileri',
    purchasedCredits: 'Satın Alınan',
    creditsResetOn: 'Yenilenme tarihi',
    remaining: '{{remaining}} / {{total}} kaldı',
    buyMoreCredits: 'Daha Fazla Kredi Al',
    buyTranscriptionMinutes: 'Transkripsiyon Dakikası Satın Al',
    purchasedCreditsNeverExpire: 'Satın alınan kredilerin süresi dolmaz',
  },

  // ICF Progress
  icfProgress: {
    recentAnalyses: 'Son Analizler',
    title: 'İlerleme Paneli',
    dashboardTitle: 'İlerleme Paneli',
    loading: 'İlerleme yükleniyor...',
    failedToLoad: 'Kontrol paneli yüklenemedi',
    retry: 'Tekrar Dene',
    lockedTitle: 'ICF ilerleme takibini aç',
    lockedCopy: 'Hazırlık seviyeni, güçlü alanlarını ve gelişim odağını takip etmek için Gelişmiş veya Profesyonel plana geç.',
    lockedCta: 'Planı yükselt',
    lockedSchoolTitle: 'ICF ilerleme bu okul planında açık değil',
    lockedSchoolCopy: 'Bu özellik okulunuzun planında yoksa gizli kalır. Oturum analizi ve sohbet özelliklerini kullanmaya devam edebilirsin.',
    lockedSchoolCta: 'Okul planını yönet',
    teaserEyebrow: 'Takip edilen gelişimin',
    teaserTitle: 'ICF ilerlemenden gerçek bir ön izleme',
    teaserTrackedSessions: 'Takip edilen oturum',
    teaserInsightFallbackTitle: 'En güçlü yetkinlik içgörüsü',
    teaserOneOfEight: 'Bu, 8 yetkinlik içgörüsünden 1 tanesi - ICF gelişim tablonun tamamını aç.',
    teaserPracticeUnlocked: 'İlk pratik odağı açık',
    teaserPracticeLocked: 'Tam gelişim planındaki {{count}} pratik odağı daha kilitli.',
    teaserLockedSectionsTitle: 'Gelişim tablonun tamamı hazır',
    teaserLockedSectionsCopy: 'Tüm yetkinlik şeritlerini, eğilimleri, eksiksiz pratik planını ve kanıt portföyünü aç.',
    teaserUnlockCta: 'Tam ICF ilerlemesini aç',
    targetDate: 'Hedef tarihi',
    targetDatePlaceholder: 'YYYY-AA-GG',
    saveTargetDate: 'Tarihi kaydet',
    clearTargetDate: 'Temizle',
    targetDateInvalid: 'Geçerli bir hedef tarihini YYYY-AA-GG biçiminde gir.',
    targetDateNeedsLevel: 'Tarih kaydetmeden önce ACC, PCC veya MCC hedefini seç.',
    targetCountdown: '{{target}} hedefine {{count}} gün kaldı',
    targetCountdownOverdue: '{{target}} hedef tarihinin üzerinden {{count}} gün geçti',
    exportPortfolio: 'Gelişim portföyünü dışa aktar (PDF)',
    exportPortfolioFailed: 'Gelişim portföyün dışa aktarılamadı. Lütfen tekrar dene.',
    levelUpTitle: 'Hazırlık seviyen yükseldi',
    levelUpCopy: 'Yakın dönem kanıtların {{previous}} seviyesinden {{next}} seviyesine ilerledi.',
    sparklineTitle: 'Yetkinlik geçmişi',
    sparklineSubtitle: 'ACC ve PCC referans bantlarıyla son analiz edilen oturumlar.',
    sparklineEmpty: 'Yeni analiz edilen oturumlar bu çizgiyi oluşturacak.',
    sparklineAccessibility: 'ACC ve PCC referans bantlarıyla {{competency}} geçmişi',
    backToProgress: 'İlerlemeye dön',
    practiceExam: {
      eyebrow: 'Sertifika hazırlığı',
      entryTitle: 'ICF pratik sınavı',
      entryBody: 'Temel yetkinlikleri kapsayan 10 soruluk odaklı bir setle kararlarını test et.',
      entryCta: 'Pratik sınavını başlat',
      title: 'ICF pratik sınavı',
      subtitle: 'ICF koçluk uygulamasını en iyi yansıtan yanıtı seç. Sınav sonunda açıklamaları ve yetkinlik dağılımını göreceksin.',
      loading: 'Soru setin yükleniyor…',
      loadError: 'Pratik soruları yüklenemedi. Lütfen tekrar dene.',
      submitError: 'Yanıtların puanlanamadı. Lütfen tekrar dene.',
      retry: 'Tekrar dene',
      progress: '{{total}} sorudan {{current}}.',
      previous: 'Önceki',
      next: 'Sonraki',
      finish: 'Sonuçları gör',
      submitting: 'Puanlanıyor…',
      resultsTitle: 'Pratik tamamlandı',
      resultSummary: '{{total}} sorudan {{correct}} doğru',
      restart: 'Yeniden çöz',
      competencyBreakdown: 'Yetkinlik dağılımı',
      reviewTitle: 'Yanıt incelemesi',
      correctAnswer: 'En uygun yanıt',
      unknownCompetency: 'Temel yetkinlik',
      questions: {
        q1: {
          prompt: 'Müşteri, kabul edeceği iş teklifini koçun seçmesini istiyor. Hangi yanıt koçluk rolüne en uygundur?',
          options: { a: 'Maaşı en yüksek teklifi önermek', b: 'Teklifleri karşılaştırıp müşteri adına seçmek', c: 'Müşteri için neyin önemli olduğunu keşfetmek ve kendi seçimini yapmasını desteklemek', d: 'Her kariyer kararında müşteriyi işe alım uzmanına yönlendirmek' },
          explanation: 'Etik koçluk, reçete sunan bir role geçmek yerine müşterinin kendi seçimlerini yapmasını destekler.',
        },
        q2: {
          prompt: 'Müşterinin ihtiyacı koçun yetkinlik sınırlarını aşıyor ve terapi desteği gerektiriyor. Koç ne yapmalıdır?',
          options: { a: 'İlişki kurulmuş olduğu için koçluğa devam etmek', b: 'Karar vermeden önce tanı koymak', c: 'Sınırı müşteriyle konuşup uygun bir uzmana yönlendirmek', d: 'Koçluğun sorunu mutlaka çözeceğini söylemek' },
          explanation: 'Koç, yetkinlik sınırlarını tanır; sınırı açıklar ve başka bir profesyonel hizmet daha uygunsa yönlendirme yapar.',
        },
        q3: {
          prompt: 'Hangisi koçluk zihniyetini benimsemiş bir uygulamayı en iyi yansıtır?',
          options: { a: 'Koçun ilk yorumunu gerçek kabul etmek', b: 'Sürekli öğrenmek, uygulama üzerine düşünmek ve kişisel önyargıları fark etmek', c: 'Özgüveni korumak için geri bildirimden kaçınmak', d: 'Her müşteriye aynı tavsiyeyi hazırlamak' },
          explanation: 'Koçluk zihniyeti; sürekli öğrenme, merak, düşünme ve koçun kendi önyargılarını fark etmesini içerir.',
        },
        q4: {
          prompt: 'Bir oturumun başında koç ile müşteri birlikte neyi belirlemelidir?',
          options: { a: 'Koçun tercih ettiği konuyu', b: 'İstenen sonucu ve müşterinin oturumun yararlı olduğunu nasıl anlayacağını', c: 'Garantili bir eylem planını', d: 'Müşterinin sorununa ilişkin bir tanıyı' },
          explanation: 'Koç; oturum sonucunu, bu sonucun anlamını ve başarı ölçülerini müşteriyle birlikte belirler.',
        },
        q5: {
          prompt: 'Müşteri, koçun paylaştığı bir gözleme katılmıyor. Koç ne yapmalıdır?',
          options: { a: 'Gözlemini savunmak', b: 'Müşterinin tepkisini davet edip bakış açısını kabul etmek', c: 'Gözlemi daha güçlü biçimde tekrarlamak', d: 'Tepkiyi ele almadan konuyu değiştirmek' },
          explanation: 'Koçun müşterinin tepkisini davet edip kabul etmesi, güveni ve gerçek ortaklığı destekler.',
        },
        q6: {
          prompt: 'Koç bir soru sorduktan sonra uzun bir sessizlik oluyor. Varlığını sürdürmenin en iyi göstergesi hangisidir?',
          options: { a: 'Hemen ikinci bir soru sormak', b: 'Sessizliği bir örnekle doldurmak', c: 'Dikkatini koruyup müşteriye düşünmesi veya hissetmesi için alan tanımak', d: 'Müşterinin soruyu anlamadığını varsaymak' },
          explanation: 'Koçluk konumunu sürdürmek, müşterinin düşünmesine veya hissetmesine alan veren sessizlikte rahat kalmayı içerir.',
        },
        q7: {
          prompt: 'Hangi yanıt etkin dinlemeye en iyi örnektir?',
          options: { a: 'Müşteri konuşurken sonraki soruyu hazırlamak', b: 'Müşterinin sözlerini, duygusunu ve fark edilen enerji değişimini kısaca yansıtmak', c: 'Yalnızca olayların sırasını özetlemek', d: 'Bir varsayımı düzeltmek için sözünü kesmek' },
          explanation: 'Etkin dinleme; sözlere, duygulara, enerjiye ve anlama dikkat eder, ardından netliği desteklemek için bunları özlü biçimde yansıtır.',
        },
        q8: {
          prompt: 'Müşteri sürekli “sıkışıp kaldım” ifadesini kullanıyor. Dinleme odaklı en uygun tepki hangisidir?',
          options: { a: 'Bu ifadeyi daha olumlu bir sözle değiştirmek', b: '“Sıkışıp kalmak” ifadesinin müşterinin deneyiminde ne anlama geldiğini keşfetmek', c: 'Bu ifadenin müşteriyi sınırladığını söylemek', d: 'Sözcükleri göz ardı edip son tarihleri sormak' },
          explanation: 'Dinleme odaklı koçluk, koçun kendi yorumunu yerleştirmek yerine müşterinin kullandığı özgün dili keşfeder.',
        },
        q9: {
          prompt: 'Hangi soru farkındalığı uyandırmaya daha uygundur?',
          options: { a: 'Bunu neden hâlâ çözemedin?', b: 'Bu seçeneğe bakışını hangi inanç şekillendiriyor?', c: 'Daha güvenli olan seçenek daha iyi değil mi?', d: 'Bende işe yarayan yöntemi anlatayım mı?' },
          explanation: 'İnançları ve bakış açısını araştıran sorular, müşteriyi koçun cevabına yöneltmeden yeni farkındalık açabilir.',
        },
        q10: {
          prompt: 'Müşteri yeni bir içgörü dile getirdikten sonra gelişimi en iyi ne kolaylaştırır?',
          options: { a: 'Diğer müşterilere verilen aynı ödevi vermek', b: 'Öğrenmenin nasıl kullanılacağını konuşup eylem ve hesap verebilirliği müşterinin tasarlamasına alan açmak', c: 'İçgörüyü bütünleştirmeden yeni bir konuya geçmek', d: 'Müşteri adına en hızlı eylemi seçmek' },
          explanation: 'Gelişim; öğrenmeyi bütünleştirmek ve müşterinin kendi eylemini, desteğini, engellerini ve hesap verebilirliğini tasarlamasına ortak olmakla desteklenir.',
        },
      },
    },

    // Session Transcripts
    sessionTranscripts: 'Oturum transkriptleri',
    noAnalyzedSessions: 'Henüz analiz edilmiş oturum yok',
    session: 'Oturum',
    webTitle: 'İlerleme',
    webSubtitle: 'ICF gelişimini ve son analizlerinden çıkan eğilimleri burada takip edebilirsin.',
    webUploadAnalysis: 'Yeni analiz yükle',
    webWaitingForData: 'Veri bekleniyor',
    webNoDataSummary: 'En az iki analizli oturum yüklediğinde ICF yeterlilik eğilimini ve öncelikli gelişim alanlarını burada göreceksin.',
    webEvidenceFallback: 'Bu alanın netleşmesi için birkaç analiz daha ekle.',
    webLevelPanelTitle: 'ICF yeterlilik seviyesi',
    webLevelNearPcc: 'PCC Hazırlık Bandı',
    webTarget: 'Hedef',
    webViewCompetencies: 'Yetkinlikleri gör',
    webSessionsAnalyzed: 'Analiz edilen oturum',
    webConsistency: 'Tutarlılık',
    webMomentum: 'İvme',
    webDetails: 'Detayları gör',
    webRecentAnalyses: 'Son analiz kayıtları',
    webRecentAnalysesSubtitle: 'Sonuçlar oturum kanıtlarına göre güncellenir.',
    webNoAnalysesYet: 'Henüz analiz yok',
    webNoAnalysesYetBody: 'İlk oturumu yüklediğinde bu tablo otomatik dolar.',
    webViewAnalysis: 'Analizi görüntüle',
    webNextFocus: 'Sonraki odak',
    webNextFocusSubtitle: 'Bir sonraki oturum için 1-2 davranış yeterli.',
    webCollectMoreEvidence: 'Birkaç analiz daha ekle',
    webCollectMoreEvidenceBody: 'İlk birkaç analizden sonra net odak önerileri burada görünür.',
    webPracticeTitleFallback: 'Sonraki oturum odağı',
    webPracticeFallback: 'Bir sonraki oturumda tek bir davranışı seçip onu bilinçli şekilde dene.',
    targetNotSet: 'Belirlenmedi',
    goalUpdateFailed: 'Hedef seviye güncellenemedi',
    goalSummaryFallback: 'Hedef sertifika seviyeni seç ve yolunu netleştirmek için analizli oturum ekle.',
    trendsLockedShort: '{{count}} daha',
    trendsSparseShort: 'Sınırlı veri',
    sinceLastSession: 'Son oturumdan beri',
    checkinMet: 'Karşılandı',
    checkinPartial: 'Kısmi',
    checkinMissed: 'Devam ediyor',
    checkinNotObserved: 'Gözlenmedi',
    checkinFallback: 'Bu pratik maddesini değerlendirmek için son oturumda yeterli doğrudan kanıt yok.',
    chartFoundation: 'Temel',
    chartListening: 'Dinleme',
    chartAwareness: 'Farkındalık',
    chartGrowth: 'Gelişim',
    progressLabel: 'İlerleme',
    remainingLabel: 'Kalan',
    scoreLabel: 'Puan',
    totalProgress: 'Genel ilerleme',
    lastAnalysis: 'Son analiz',
    noAnalysisYet: 'Henüz analiz yok',
    analyzedCount: 'Analiz edildi',
    trackingActive: 'Takip aktif',
    trackingPaused: 'Takip pasif',
    competencyDistribution: 'Yetkinlik dağılımı',

    // Growth & Progress Metrics
    growthRate: 'Büyüme oranı',
    consistency: 'Tutarlılık',
    momentum: 'İvme',
    currentLevel: 'Güncel seviye',
    noTimeline: 'Henüz zaman çizelgesi yok',

    // Momentum Directions
    momentumUp: 'Yükseliyor',
    momentumDown: 'Düşüyor',
    momentumFlat: 'Sabit',
    noMomentum: 'Veri yok',

    // Consistency
    consistencyScore: '%{{percentage}} tutarlı',
    noData: 'Veri yok',

    // ICF Competency
    icfCompetencyProgress: 'ICF yetkinlik ilerlemesi',
    current: 'Güncel',
    viewCompetencyDetail: 'Yetkinlik detaylarını görüntüle',
    competencyInsights: 'Yetkinlik tutarlılığı ve ivme',
    readinessTitle: 'ICF hazırlık ve gelişim',
    estimatedLevel: 'Tahmini seviye',
    targetLevel: 'Hedef seviye',
    confidence: 'Güven',
    confidenceLow: 'Düşük',
    confidenceMedium: 'Orta',
    confidenceHigh: 'Yüksek',
    readinessStatusTargetSupported: 'Hedef destekleniyor',
    readinessStatusNearTarget: 'Hedefe yakın',
    readinessStatusDeveloping: 'Gelişiyor',
    readinessStatusNeedsEvidence: 'Kanıt gerekli',
    readinessStatusNoData: 'Veri yok',
    nextPracticeTitle: 'Sonraki kayıt pratiği',
    successSignal: 'Başarı işareti',
    blockersTitle: 'Hedef seviye engelleri',
    patternsTitle: 'Tekrarlayan gelişim kalıpları',
    noCurrentBlockers: 'Mevcut kanıt penceresinde tekrar eden hedef seviye engeli görünmüyor.',
    noRecurringPatterns: 'Henüz tekrar eden gelişim kalıbı yok. Bu görünüm için daha fazla analiz edilmiş oturum yükleyin.',
    seenInSessions: 'Görüldüğü oturum sayısı',
    laneStableStrength: 'Tutarlı güçlü alan',
    laneEmergingStrength: 'Gelişen alan',
    laneInconsistent: 'Tutarsız',
    laneTargetBlocker: 'Hedef seviyenin altında',
    laneInsufficientEvidence: 'Yetersiz kanıt',
    laneNeedsReview: 'İnceleme gerekiyor',
    laneDemonstrated: 'Tutarlı biçimde gösteriliyor',
    laneEthicsConcern: 'Etik kaygı',
    laneEthicsConcernBody: 'Yakın tarihli bir görüşmede etik kaygı işaretlendi. Etik uygulama seviyelendirilmez; işaretlenen anı mentor koçunuzla değerlendirin.',

    // Metrics
    overallScore: 'Genel Puan',
    sessionsLabel: 'Oturumlar',

    // ICF Levels
    levelMCC: 'MCC Düzeyi',
    levelPCC: 'PCC Düzeyi',
    levelACC: 'ACC Düzeyi',
    levelBelowACC: 'ACC Altı',
    levelUpperPccMccAdjacent: 'PCC üstü / MCC’ye yaklaşan profil',

    // Competency Labels
    compEthics: 'Etik Kuralları Uygular',
    compMindset: 'Koçluk Zihin Yapısını İçselleştirir',
    compAgreements: 'Anlaşmaları Oluşturur ve Sürdürür',
    compTrust: 'İtimat ve Güven Oluşturur',
    compPresence: 'Koç Konumunu Sürdürür',
    compListening: 'Etkin Dinler',
    compAwareness: 'Farkındalık Yaratır',
    compGrowth: 'Müşterinin Gelişimini Kolaylaştırır',

    // Competency Full Names
    compEthicsFull: 'Etik Kuralları Uygular',
    compMindsetFull: 'Koçluk Zihin Yapısını İçselleştirir',
    compAgreementsFull: 'Anlaşmaları Oluşturur ve Sürdürür',
    compTrustFull: 'İtimat ve Güven Oluşturur',
    compPresenceFull: 'Koç Konumunu Sürdürür',
    compListeningFull: 'Etkin Dinler',
    compAwarenessFull: 'Farkındalık Yaratır',
    compGrowthFull: 'Müşterinin Gelişimini Kolaylaştırır',

    // Description
    levelDescription: 'Yetkinlik dağılımı ve yakın dönem analizlerine göre güncel seviyeniz.',

    // Competency Breakdown Screen
    competencyBreakdown: 'Yetkinlik Dağılımı',
    level: 'Seviye',
    competencyScores: 'Yetkinlik Skorları',
    loadError: 'İlerleme verileri yüklenemedi',

    // Detailed Competency Names
    competencies: {
      ethicalPractice: 'Etik Kuralları Uygular',
      coachingMindset: 'Koçluk Zihin Yapısını İçselleştirir',
      agreements: 'Anlaşmaları Oluşturur ve Sürdürür',
      trustSafety: 'İtimat ve Güven Oluşturur',
      presence: 'Koç Konumunu Sürdürür',
      activeListening: 'Etkin Dinler',
      awareness: 'Farkındalık Yaratır',
      clientGrowth: 'Müşterinin Gelişimini Kolaylaştırır',
    },
    detail: {
      title: 'Yetkinlik detayı',
      invalidCompetency: 'Bu yetkinlik bulunamadı.',
      loadError: 'Yetkinlik detayları yüklenemedi. Lütfen tekrar dene.',
      levelHistory: 'Seviye geçmişi',
      levelHistoryDescription: 'Analiz edilen oturumlarındaki kanıta dayalı seviye işaretleri.',
      historyPoint: '{{session}} oturumunda {{level}} işareti',
      evidenceTitle: 'Oturumlarından kanıtlar',
      emptyEvidence: 'Bu yetkinlik için henüz doğrudan kanıt alıntısı yok.',
      practiceNext: 'Sıradaki pratik',
      emptyPractice: 'Oturum kanıtların geliştikçe odaklı bir pratik önerisi burada görünecek.',
      levelCriteria: 'Her seviyenin gerektirdikleri',
      noCriteria: 'Bu yetkinlik için ek kriter bulunmuyor.',
      lockedTrend: 'Kanıta dayalı eğilimi açmak için daha fazla oturum analiz et.',
      levelHistoryAccessibility: 'ACC altından MCC seviyesine kronolojik yetkinlik geçmişi',
      levelBelowAccShort: '<ACC',
      levelAccShort: 'ACC',
      levelPccShort: 'PCC',
      levelMccShort: 'MCC',
      strength: 'Güçlü alan',
      development: 'Gelişim alanı',
      sessionFallback: 'Analiz edilen oturum',
      successSignal: 'Başarı işareti',
      showMoreEvidence: '{{count}} kanıt daha göster',
      showLessEvidence: 'Daha az göster',
    },
    sessions: {
      title: 'İlerlemendeki oturumlar',
      subtitle: 'Güncel kanıt pencerene hangi analizli oturumların dahil olacağını seç.',
      included: 'Dahil',
      excluded: 'Dahil değil',
      notTracked: 'Takip edilmiyor',
      notTrackedHint: 'Bu oturum ICF ilerleme takibi olmadan analiz edildi; kanıt penceresine eklenemez.',
      processing: 'İşleniyor',
      notAnalyzed: 'Henüz analiz edilmedi',
      sessionFallback: 'Oturum {{id}}',
      toggleLabel: '{{title}} oturumunu ICF ilerlemesine dahil et',
      empty: 'Analiz edilen oturumların burada görünecek.',
      loadError: 'Oturumlar yüklenemedi.',
      toggleError: 'Bu oturum güncellenemedi. Lütfen tekrar dene.',
    },
    sessionList: {
      title: 'Oturum analizleri',
      countLabel: '{{count}} oturum',
      lastAnalyzed: 'Son analiz: {{date}}',
      include: 'Dahil et',
      qualityScore: 'Kalite puanı',
      messageCount: 'Mesaj',
      analysisDuration: 'Analiz süresi',
      viewDetails: 'Detayları gör',
      emptyTitle: 'Henüz oturum bulunmuyor',
      emptyDescription: 'Analiz edilen koçluk oturumların burada görünecek.',
    },
    dataManagement: {
      title: 'Veri yönetimi',
      subtitle: 'İlerleme verilerinin saklama süresi ve gizlilik ayarları.',
      retentionLabel: 'Veri saklama (gün)',
      retentionInvalid: 'Veri saklama süresi 1-2555 gün arasında olmalıdır.',
      saveSuccess: 'Ayarlar güncellendi.',
      saveError: 'Ayarlar güncellenemedi.',
      loadError: 'Veriler yüklenemedi.',
      purgeTitle: 'Verileri sil',
      purgeSubtitle: 'Tüm ilerleme verilerini kalıcı olarak sil.',
      purgeAction: 'Tüm verileri sil',
      purgeConfirmTitle: 'Kalıcı silme',
      purgeConfirmBody: 'Tüm ilerleme verilerin kalıcı olarak silinecek. Emin misin?',
      purgeConfirmAction: 'Sil',
      purgeSuccess: 'Tüm ilerleme verilerin silindi.',
      purgeError: 'Silme işlemi başarısız oldu.',
    },
    plan: {
      title: 'Sırada neye çalışmalı',
      subtitle: 'Planın, analiz edilen her oturumdaki kanıtlara göre yenilenir.',
      version: 'Plan v{{version}}',
      successSignal: 'Başarı işareti',
      updated: '{{date}} tarihinde güncellendi',
      empty: 'Oturum kanıtların geliştikçe sıradaki pratik maddelerin burada görünecek.',
      lockedTeaser: 'İkinci pratik maddesini ve tüm odak alanlarını görmek için tam planı aç.',
      checkinSubtitle: 'Önceki planın son analiz edilen oturumunda nasıl göründüğü.',
    },
    crfReadiness: {
      title: 'ICF {{level}} hazırlığı (Yetkinlik Değerlendirme Formu kuralı)',
      subtitleShort: '{{level}} Yetkinlik Değerlendirme Formu için {{count}} ifade eksiğin var.',
      subtitleComplete: 'Analiz edilen oturumlarında tüm {{level}} yetkinlik eşikleri karşılanıyor.',
      verdictDemonstrated: 'Yeterlilik gösterildi',
      verdictNotYet: 'Henüz gösterilmedi',
      sessionsConsidered: '{{level}} enstrümanıyla değerlendirilen oturum sayısı: {{count}}.',
      gateCount: '{{demonstrated}} / {{required}} gösterildi',
      gateTotal: 'toplam {{total}} ifade',
      gateMet: 'eşik karşılandı',
      gateShort: '{{count}} eksik',
      chipHint: 'Resmî ifadeyi okumak için bir ifade numarasına dokun.',
      openDetail: 'Yetkinlik detayını aç',
      notAssessed: '{{level}} seviyesinde değerlendirilmemiş {{count}} oturum var.',
      reanalyzeCta: 'Bunları {{level}} seviyesinde yeniden analiz et',
      reanalyzeConfirm: '{{count}} oturum {{level}} enstrümanıyla yeniden analiz edilsin mi? Her biri için yeni bir analiz çalışır.',
      reanalyzeConfirmCta: 'Yeniden analizi başlat',
      reanalyzeCancel: 'Vazgeç',
      reanalyzeStarted: '{{count}} oturum için yeniden analiz başladı. Sonuçlar tamamlandıkça görünecek.',
      reanalyzePartial: '{{started}} oturum için yeniden analiz başladı; {{failed}} oturum başlatılamadı.',
      reanalyzeError: 'Yeniden analizi başlatamadık. Lütfen tekrar dene.',
      footnote: 'Bir ifade, analiz edilen tek bir oturumda bile karşılandıysa gösterilmiş sayılır (sonraki oturumlar bunu geri almaz), Geçerli Değil (GD) hiçbir zaman sayılmaz ve payda, ICF {{level}} formunun sabit ifade toplamıdır (rev. {{revision}}).',
      detailTitle: 'ICF {{level}} formu ifadeleri',
      demonstratedIn: 'Gösterildiği oturumlar: {{sessions}}',
      noOpportunity: 'Henüz gözlemlenecek bir fırsat oluşmadı.',
      planSubtitle: '{{level}} Yetkinlik Değerlendirme Formu için {{count}} ifade eksiğin var.',
      gapSuccessSignal: '{{count}} ifadeyi kapatır: {{statements}}',
    },
  },

  // Platform Admin
  platformAdmin: {
    cancellationInsightsTitle: 'İptal bilgileri',
    cancellationInsightsDescription: 'Son 90 günde kaydedilen abonelik iptal nedenleri.',
    cancellationInsightsTotal: 'Son 90 gündeki iptaller',
    redoOnboardingTitle: 'Tanıtımı yeniden başlat',
    redoOnboardingDescription: 'Kendi tanıtım akışınızı, giriş formu yanıtlarınızı ve gelişim planınızı sıfırlar; uygulama sizi yepyeni bir kullanıcı gibi görür. Yalnızca kendi hesabınızı etkiler, başka hiçbir kullanıcıya dokunmaz.',
    redoOnboardingAction: 'Tanıtımımı sıfırla',
    redoOnboardingConfirm: 'Bu işlem giriş formu yanıtlarınızı ve oluşturulan gelişim planınızı siler, ardından tanıtım turunu yeniden başlatır. Geri alınamaz. Devam edilsin mi?',
    redoOnboardingSuccess: 'Tanıtım sıfırlandı. Tur başlatılıyor…',
    redoOnboardingError: 'Tanıtım sıfırlanamadı.',
    lifecycleTitle: 'Yaşam Döngüsü E-postaları (Resend)',
    lifecycleDescription: 'Yaşam döngüsü otomasyon teslimatını yönetin ve kalıcı giden kutusunu izleyin.',
    lifecycleSaved: 'Yaşam döngüsü e-posta ayarları kaydedildi.',
    lifecycleError: 'Yaşam döngüsü e-posta ayarları güncellenemedi.',
    lifecycleTestQueued: 'Test yaşam döngüsü olayı kuyruğa alındı.',
    lifecycleTestRecipient: 'Test alıcısı e-posta adresi',
    lifecycleSendTest: 'Test olayı gönder',
    lifecycleCounts: 'Giden kutusu',
    lifecycleMode: { disabled: 'Devre dışı', test: 'Test', live: 'Canlı' },
    lifecycleSaveBeforeTest: 'Önce Test modunu kaydedin. Test olayı kayıtlı modla gönderilir.',
    lifecycleLastError: 'Son hata',
    lifecycleTestSkipped: {
      lifecycle_disabled: 'Test olayı gönderilmedi: kayıtlı mod Devre dışı. Önce Test modunu kaydedin.',
      recipient_ineligible: 'Test olayı gönderilmedi: yönetici hesabınız yaşam döngüsü e-postası alamıyor. Hesap doğrulanmış ve aktif olmalı, ürün e-postalarına abone olmalı ve e-postası geri dönmemiş ya da spam olarak işaretlenmemiş olmalı.',
      synthetic_account: 'Test olayı gönderilmedi: bu bir otomatik test hesabı. Kendi yönetici hesabınızı kullanın.',
      unknown: 'Test olayı gönderilmedi.',
    },
    deleteUser: 'Hesabı sil',
    deleteUserConfirm: '{{email}} hesabını sil? Bu işlem hesabı, belgeleri ve sohbet geçmişini kalıcı olarak siler. Bu işlem geri alınamaz.',
    deleteUserError: 'Hesap şu anda silinemiyor. Lütfen tekrar dene.',
    deleteUserSuccess: 'Kullanıcı hesabı silindi.',
    deletingUser: 'Siliniyor…',
    subtitle: 'Okullar, kullanıcılar, faturalandırma ve platform geneli ayarlar.',
    title: 'Platform Yönetimi',
    loading: 'Platform verileri yükleniyor...',
    failedToLoad: 'Platform bilgileri yüklenemedi',

    // Tabs
    overview: 'Genel Bakış',
    schools: 'Okullar',
    usersTab: 'Kullanıcılar',
    settings: 'Ayarlar',

    // Stats
    platformOverview: 'Platform Genel Bakış',
    totalSchools: 'Toplam Okul',
    activeSchools: 'Aktif Okul',
    b2b2cStudents: 'B2B2C Öğrenciler',
    b2cUsers: 'B2C Kullanıcılar',
    activeSubscriptions: 'Aktif Abonelikler',
    active: 'aktif',

    // Quick Actions
    quickActions: 'Hızlı İşlemler',
    createNewSchool: 'Yeni Okul Oluştur',
    addSchool: 'Platforma yeni okul ekle',
    manageB2CDocuments: 'B2C Dökümanları Yönet',
    uploadGeneral: 'Genel koçluk içeriği yükle ve yönet',
    createTestSchool: 'Test Okulu Oluştur',
    testB2B2C: 'B2B2C testi için test okulu ve yönetici oluştur',
    debugAuth: 'Kimlik Doğrulama Testi',
    testAuth: 'Kimlik doğrulama ve süper admin durumunu test et',
    testSentry: 'Sentry Testi',
    testErrorMonitoring: 'Sentry hata izleme sistemine test hataları gönder',

    // Schools List
    schoolsList: 'Okullar',
    create: 'Oluştur',
    noSchools: 'Henüz okul oluşturulmadı',
    createFirstSchool: 'Platformu yönetmeye başlamak için ilk okulunuzu oluşturun',
    createSchool: 'Okul Oluştur',
    students: 'öğrenci',
    billableSeats: 'öğrenci + mentor koltuğu',
    admins: 'Yöneticiler',
    noAdmins: 'Henüz yönetici yok',
    pendingInvitation: 'Beklemede',
    resend: 'Tekrar Gönder',
    addAdmin: 'Yönetici Ekle',
    viewStudents: 'Öğrenciler',
    schoolSettings: 'Ayarlar',
    schoolActionsTitle: 'Okul ayarları',
    schoolActionsSubtitle: '{{name}} için hangi işlemi yapmak istersiniz?',
    schoolActionEditPlanDesc: 'Fiyatlandırmayı, dahil edilen kontenjanı ve ek paketleri güncelleyin.',
    schoolActionBillInviteDesc: 'Stripe üzerinden ödeme alın ve faturalama yöneticisini davet edin.',
    schoolActionUpdateSeatsDesc: 'Toplam kontenjanı manuel olarak güncelleyin.',
    schoolActionSeatRequestsDesc: 'Bekleyen kontenjan artış taleplerini inceleyin ve onaylayın.',
    schoolActionSyncStripeDesc: 'Stripe abonelik durumunu yenileyin.',
    schoolActionDeactivateDesc: 'Okulu silmeden erişimi duraklatın.',
    schoolActionActivateDesc: 'Bu okul için erişimi yeniden etkinleştirin.',
    schoolActionOpenSettings: 'Detaylı ayarları aç',
    schoolActionOpenSettingsDesc: 'Bu okulun faturalandırma paneline atla.',
    schoolActionCancel: 'Kapat',
    focusedSchool: 'Seçili okul',
    createdOn: 'Oluşturuldu',

    // Users Tab
    usersRoster: 'Kullanıcı Dizini',
    usersSummary: 'Bireysel (B2C) ve okula bağlı hesapları yönetin.',
    userFilterAll: 'Tümü',
    userFilterB2C: 'B2C',
    userFilterB2B2C: 'Okul',
    userNameFallback: 'Kullanıcı',
    userJoined: 'Katılma',
    userSchool: 'Okul',
    userSchoolUnknown: 'Atanmış okul yok',
    userPackage: 'Paket',
    userPackageUnknown: 'Paket bilinmiyor',
    userStatus: 'Abonelik',
    userStatusUnknown: 'Durum bilinmiyor',
    userRenewal: 'Yenilenme',
    userRenewalUnknown: 'Yenileme tarihi mevcut değil',
    userSourceSchool: 'Okul aboneliği ile yönetiliyor',
    userSourceUser: 'Bireysel abonelik ile yönetiliyor',
    accountTypeB2C: 'B2C Hesabı',
    accountTypeB2B2C: 'Okul Hesabı',
    viewSchool: 'Okulu aç',
    resetUsage: 'Kullanımı sıfırla',
    resettingUsage: 'Sıfırlanıyor…',
    resetUsageConfirm: '{{name}} için kullanım limitleri sıfırlansın mı? Bu işlem mevcut dönem için sohbet ve analiz sayaçlarını temizler.',
    resetUsageSuccess: 'Kullanım limitleri başarıyla sıfırlandı.',
    resetUsageError: 'Kullanım limitleri sıfırlanamadı. Lütfen tekrar deneyin.',
    resetSchoolUsage: 'Okul kullanımını sıfırla',
    resettingSchoolUsage: 'Okul kullanımı sıfırlanıyor…',
    resetSchoolUsageConfirm: '{{name}} için okul kullanımı sıfırlansın mı? Bu işlem ortak okul kredi havuzu kullanımını geri yükler ve mevcut okul üyeleri için sohbet, transkript ve analiz sayaçlarını temizler. Kullanıcıları, davetleri, belgeleri veya satın alınmış kredileri silmez.',
    resetSchoolUsageSuccess: '{{users}} üye için okul kullanımı sıfırlandı. Kalan abonelik kredisi: {{credits}}.',
    resetSchoolUsageError: 'Okul kullanımı sıfırlanamadı. Lütfen tekrar deneyin.',
    schoolActionResetUsageDesc: 'Okul verilerini silmeden üye sayaçlarını sıfırla ve ortak kredi havuzunu geri yükle.',
    noUsers: 'Kullanıcı bulunamadı',
    addUsersHint: 'Burada görmek için kullanıcı davet edin veya okulları bağlayın.',
    manageSchoolsCta: 'Okulları yönet',

    // Kullanım istatistikleri
    transcriptsUsage: 'Transkript analizleri',
    transcriptionMinutesUsage: 'Transkripsiyon dk',
    chatMessagesUsage: 'Sohbet mesajları',

    // Settings / Billing
    llmSettingsTitle: 'LLM Ayarları',
    llmSettingsDescription: 'Ana üretim ve hızlı planlama modellerini gerçek zamanlı değiştirin.',
    llmSettingsNote: 'Değişiklikler yeni isteklerde geçerli olur; süren işlemler mevcut modelle tamamlanır.',
    mainModel: 'Ana Model',
    fastModel: 'Hızlı Model',
    saveLlmSettings: 'LLM Ayarlarını Kaydet',
    llmSettingsSaving: 'Kaydediliyor…',
    llmSettingsSaved: 'LLM ayarları kaydedildi.',
    llmSettingsError: 'LLM ayarları kaydedilemedi.',
    // Transkript işleme modeli ayarları
    transcriptModelTitle: 'Transkript Modeli',
    transcriptModelDescription: 'Ses transkripsiyonlarında konuşmacı etiketi düzeltme ve dilbilgisi düzeltme için model.',
    transcriptModel: 'Transkript İşleme Modeli',
    transcriptModelNote: 'Daha büyük bir model genellikle daha iyi konuşmacı tanımlama ve dilbilgisi düzeltme sonuçları verir.',
    saveTranscriptSettings: 'Transkript Ayarlarını Kaydet',
    transcriptSettingsSaving: 'Kaydediliyor…',
    transcriptSettingsSaved: 'Transkript modeli ayarları kaydedildi.',
    transcriptSettingsError: 'Transkript modeli ayarları kaydedilemedi.',
    // Ses modeli ayarları (ses tabanlı işleme için)
    audioModelTitle: 'Ses Modeli (Konuşmacı Doğrulama)',
    audioModelDescription: 'Gemini\'nin ses anlama özelliğiyle konuşmacı doğrulama ve düzeltme için model.',
    audioModel: 'Ses Anlama Modeli',
    audioModelNote: 'Bu model konuşmacı etiketlerini doğrulamak ve düzeltmek için sesi analiz eder. Büyük modeller daha iyi sonuçlar verebilir ama daha yavaştır.',
    saveAudioSettings: 'Ses Modelini Kaydet',
    audioSettingsSaving: 'Kaydediliyor…',
    audioSettingsSaved: 'Ses modeli ayarları kaydedildi.',
    audioSettingsError: 'Ses modeli ayarları kaydedilemedi.',
    llmProviderGoogle: 'Google Gemini',
    llmProviderOpenAI: 'OpenAI GPT',
    llmProviderGroq: 'Groq',
    llmProviderOpenRouter: 'OpenRouter',
    billingSettingsTitle: 'Okul Faturalandırması ve Planları',
    billingSettingsDescription: 'Okul abonelik planlarını, koltuk kotalarını ve Stripe senkronizasyonunu yönetin.',
    claudeGateway: {
      title: 'Claude API ağ geçidi',
      description: 'Bu ay Anthropic Claude API için yapılan harcama, aylık üst sınır ve tüm iş yüklerini OpenRouter yedeğine gönderen anahtar. Sınırın %80\'inde Telegram uyarısı gelir; %100\'de ay dönene kadar tüm iş yükleri OpenRouter üzerinde çalışır.',
      spent: 'Bu ayki harcama',
      cap: 'Aylık üst sınır (USD)',
      capPlaceholder: '100',
      saveCap: 'Sınırı kaydet',
      forceOpenRouter: 'Her şeyi OpenRouter\'a gönder',
      resumeClaude: 'Claude\'u yeniden aç',
      stateActive: 'Claude, kendisine atanan iş yüklerini çalıştırıyor.',
      stateNoKey: 'ANTHROPIC_API_KEY tanımlı değil: tüm iş yükleri OpenRouter yedeğinde çalışıyor.',
      stateForced: 'Acil anahtar açık: tüm iş yükleri OpenRouter yedeğinde çalışıyor.',
      stateExhausted: 'Aylık sınıra ulaşıldı: ay dönene kadar tüm iş yükleri OpenRouter yedeğinde çalışıyor.',
      byWorkload: 'İş yüküne göre harcama ve istem önbelleği isabet oranı',
      cacheHitRate: 'önbellek isabeti',
      calls: 'çağrı',
      noSpendYet: 'Bu ay henüz Claude çağrısı yok.',
      saved: 'Claude ağ geçidi ayarları kaydedildi.',
      invalidCap: 'Sınırı dolar olarak girin, örneğin 100 veya 150.50.',
      forbidden: 'Claude ağ geçidini yalnızca platform süper yöneticileri değiştirebilir.',
      error: 'Claude ağ geçidi ayarları yüklenemedi veya kaydedilemedi. Tekrar deneyin.',
    },
    otpLockout: {
      title: 'Giriş kilidini kaldır',
      description: 'Çok fazla hatalı kod girildiği için kilitlenen bir adresin e-posta koduyla girişini açar (tüm IP adresleri için). Adresin hesabı olsun ya da olmasın aynı şekilde çalışır.',
      emailPlaceholder: 'kullanici@ornek.com',
      action: 'Giriş kilidini kaldır',
      confirmTitle: 'Giriş kilidi kaldırılsın mı?',
      confirmMessage: '{{email}} için tüm hatalı kod kilitleri kaldırılacak; giriş kodları hemen yeniden girilebilecek.',
      success: '{{email}} için giriş kilidi kaldırıldı.',
      invalidEmail: 'Geçerli bir e-posta adresi gir.',
      forbidden: 'Giriş kilitlerini yalnızca platform süper yöneticileri kaldırabilir.',
      error: 'Giriş kilidi kaldırılamadı. Tekrar dene.',
    },
    creditAdjust: {
      title: 'Kredi düzelt',
      description: 'Bir kullanıcı ya da bir okul için analiz kredisi ekle veya düş. Her düzeltme notunla ve işlemi yapan olarak hesabınla kaydedilir.',
      target_user: 'Kullanıcı',
      target_school: 'Okul',
      idPlaceholder_user: 'Kullanıcı ID',
      idPlaceholder_school: 'Okul ID',
      type_purchased: 'Satın alınan kredi',
      type_subscription: 'Abonelik kredisi',
      deltaPlaceholder: 'Değişim, ör. 5 veya -2',
      notePlaceholder: 'Gerekçe (düzeltmeyle birlikte kaydedilir)',
      action: 'Krediyi düzelt',
      confirmTitle: 'Kredi düzeltilsin mi?',
      confirmMessage: '{{target}} #{{id}} için {{delta}} {{creditType}}.',
      success: '{{target}} #{{id}} için {{delta}} {{creditType}} uygulandı. Bakiye: {{subscription}} abonelik, {{purchased}} satın alınan.',
      invalidTarget: 'Geçerli bir kullanıcı ya da okul ID gir.',
      invalidDelta: '0 dışında bir tam sayı gir.',
      rejected: 'Düzeltme reddedildi. ID ve miktarı kontrol et.',
      forbidden: 'Kredileri yalnızca platform süper yöneticileri düzeltebilir.',
      error: 'Kredi düzeltilemedi. Bakiye sıfırın ya da kullanılmış kredinin altına düşemez.',
    },
    vectorStore: {
      title: 'Bilgi tabanı vektör deposu',
      description: 'pgvector kurulu mu kontrol eder ve kayıtlı parçaları sayar. Temizlik, belgesi silinmiş parçaları kaldırır.',
      checkAction: 'Durumu kontrol et',
      checkError: 'Vektör deposu kontrol edilemedi.',
      statusOk: 'Sağlıklı',
      statusError: 'Hazır değil',
      pgvectorVersion: 'pgvector sürümü',
      totalChunks: 'Parçalar',
      embeddedChunks: 'Gömülü parçalar',
      cleanupAction: 'Sahipsiz parçaları temizle',
      cleanupConfirmTitle: 'Sahipsiz parçalar temizlensin mi?',
      cleanupConfirmMessage: 'Silinmiş belgelere ait parçalar kalıcı olarak kaldırılacak.',
      cleanupSuccess: 'Sahipsiz parçalar temizlendi.',
      cleanupError: 'Sahipsiz parçalar temizlenemedi.',
    },
    workflowRuns: {
      title: 'İş akışı çalıştırmaları',
      recentAction: 'Son değerlendirme çalıştırmalarını göster',
      recentEmpty: 'Henüz değerlendirme çalıştırması yok.',
      userLabel: 'kullanıcı {{id}}',
      runIdPlaceholder: 'İş akışı çalıştırma UUID',
      inspectAction: 'Çalıştırmayı incele',
      errorTitle: 'Hata',
      statusLabel: 'Durum: {{status}}',
      typeLabel: 'Tür: {{type}}',
      nodesLabel: 'Düğümler ({{count}}):',
    },
    webhookInbox: {
      title: 'Stripe Webhook Gelen Kutusu',
      description: 'Son Stripe webhook olayları (yalnızca meta veriler). Takılan veya başarısız olayları yeniden deneyin ya da abonelik mutabakatı başlatın.',
      filterAttention: 'İlgi gerektirenler',
      filterAll: 'Tüm son olaylar',
      refresh: 'Yenile',
      loadError: 'Webhook olayları yüklenemedi.',
      emptyAttention: 'Bekleyen veya başarısız webhook olayı yok.',
      emptyAll: 'Henüz kayıtlı webhook olayı yok.',
      meta: 'Deneme: {{attempts}} · Alındı: {{received}} · Sonraki deneme: {{next}}',
      lastError: 'Son hata: {{error}}',
      retryAction: 'Yeniden dene',
      retryConfirmTitle: 'Bu webhook olayı yeniden denensin mi?',
      retryConfirmMessage: '{{eventType}} ({{eventId}}) beklemede durumuna alınacak ve yeniden işlenecek.',
      retrySuccess: 'Webhook olayı yeniden deneme için sıraya alındı.',
      retryError: 'Webhook olayı yeniden denenemedi.',
      reconcileAction: 'Mutabakatı çalıştır',
      reconcileConfirmTitle: 'Stripe mutabakatı çalıştırılsın mı?',
      reconcileConfirmMessage: 'Yerel abonelikleri Stripe ile yeniden eşitleyen bir arka plan işi sıraya alınır.',
      reconcileSuccess: 'Stripe mutabakatı sıraya alındı.',
      reconcileError: 'Stripe mutabakatı sıraya alınamadı.',
      statusPending: 'Beklemede',
      statusProcessing: 'İşleniyor',
      statusFailed: 'Başarısız',
      statusDeadLetter: 'Kalıcı hata',
      statusSucceeded: 'Başarılı',
      statusIgnored: 'Yok sayıldı',
    },
    planSummary: 'Temel plan için {{seats}} koltuk - {{price}}',
    addonSummary: 'Ek paket: {{seats}} koltuk başına {{price}}',
    seatCapacitySummary: 'Öğrenci + mentor kullanımı: {{current}} / {{max}} koltuk',
    noBillingConfigured: 'Henüz özel bir faturalandırma planı yapılandırılmadı.',
    editPlan: 'Planı düzenle',
    updateSeats: 'Koltukları güncelle',
    seatRequests: 'Koltuk talepleri',
    billAndInvite: 'Faturalandır & davet et',
    syncStripe: 'Stripe senkronize et',
    syncStripeSuccess: 'Stripe senkronizasyonu tamamlandı. Durum: {{status}}',
    syncStripeError: 'Stripe senkronizasyonu şu anda yapılamadı.',
    subscriptionStatusUpdated: 'Abonelik durumu {{status}} olarak güncellendi.',
    subscriptionStatusError: 'Abonelik durumu güncellenemedi.',
    deactivateSchoolTitle: 'Okul devre dışı bırakılsın mı?',
    deactivateSchoolConfirm: '{{school}} iptal edildi olarak işaretlenecek. Okulun {{students}} öğrencisi ve {{mentors}} mentoru okul yeniden etkinleştirilene kadar erişimini kaybedebilir. Stripe değiştirilmez: mevcut bir Stripe aboneliği faturalandırmaya devam eder ve sonraki bir Stripe senkronizasyonu bu durumun üzerine yazabilir.',
    deactivateSchoolAction: 'Devre dışı bırak',
    activateSchoolTitle: 'Okul etkinleştirilsin mi?',
    activateSchoolConfirm: '{{school}} yerel bir geçersiz kılma ile aktif olarak işaretlenecek. Stripe değiştirilmez. Stripe aboneliği olmayan bir okula kredi havuzu tanımlanır.',
    activateSchoolAction: 'Etkinleştir',
    seedOverwriteConfirmTitle: 'Çerçeve göstergelerinin üzerine yazılsın mı?',
    seedOverwriteConfirm: 'Üzerine yazma, {{frameworks}} için kayıtlı göstergeleri siler ve paketteki çerçeve dosyalarından yeniden oluşturur. Veritabanında yapılan gösterge düzenlemeleri kaybolur.',
    seedOverwriteAllFrameworks: 'tüm çerçeveler',
    seedOverwriteAction: 'Üzerine yaz',
    recoverUsageConfirmTitle: 'Kullanım sayaçları kurtarılsın mı?',
    recoverUsageConfirm: 'Bu işlem, Stripe dönemi olan her kullanıcı ve okul için fatura dönemi başlangıcından bu yana yapılan sohbet isteklerini yeniden sayar ve aylık kullanım sayaçlarını yeniden yazar. Birden fazla kez çalıştırmak güvenlidir.',
    recoverUsageAction: 'Kurtar',
    activateSchool: 'Aktifleştir',
    deactivateSchool: 'Pasifleştir',
    unknownStatus: 'bilinmiyor',

    // Legacy placeholders used in other screens
    comingSoon: 'Yakında',
    userManagementDesc: 'B2C kullanıcıları, okul yöneticileri ve platform yöneticileri dahil kapsamlı kullanıcı yönetimi.',
    platformSettingsDesc: 'LLM yapılandırması ve platform ayarları burada mevcut olacak.',

    // Mentors
    manageMentors: 'Mentörler',
    schoolActionManageMentorsDesc: 'Okul mentörlerini davet edin, görüntüleyin veya kaldırın',

    // Access Control
    accessRequired: 'Süper Admin Erişimi Gerekli',
    mustBeAdmin: 'Bu bölüme erişmek için platform yöneticisi olmalısınız.',
  },

  // Üyeler ekranı (öğrenci + mentör + yönetici birleşik görünüm)
  members: {
    title: 'Üyeler',
    summaryLine: 'Toplam {{total}} • Aktif {{active}} • Davetli {{invited}}',
    invite: 'Davet Et',
    inviteFirst: 'Birini davet et',
    invitePickerTitle: 'Okuluna davet et',
    invitePickerSubtitle: 'Bu davet için rolü seç.',
    inviteStudentDesc: 'Analiz için görüşme gönderen koçluk öğrencisi.',
    inviteMentorDesc: 'Öğrencileri gözden geçiren ve destekleyen deneyimli koç.',
    inviteAdminDesc: 'Okulu seninle birlikte yöneten ikinci yönetici.',
    inviteAdminTitle: 'Yönetici davet et',
    inviteAdminSubtitle: 'E-posta daveti alırlar ve aktivasyondan sonra tek kullanımlık kodla giriş yaparlar.',
    inviteAdminFailed: 'Yönetici daveti gönderilemedi',
    fullNameLabel: 'Ad Soyad',
    fullNamePlaceholder: 'Ayşe Yılmaz',
    emailLabel: 'E-posta',
    sendInvite: 'Davet gönder',
    searchPlaceholder: 'İsim veya e-posta ile ara',
    roleFilterAll: 'Herkes ({{count}})',
    roleFilterStudents: 'Öğrenciler ({{count}})',
    roleFilterMentors: 'Mentörler ({{count}})',
    roleFilterAdmins: 'Yöneticiler ({{count}})',
    statusFilterAll: 'Tüm durumlar',
    statusFilterActive: 'Aktif ({{count}})',
    statusFilterInvited: 'Davetli ({{count}})',
    statusFilterInactive: 'Pasif ({{count}})',
    loading: 'Üyeler yükleniyor…',
    loadFailed: 'Üyeler yüklenemedi',
    emptyTitle: 'Henüz üye yok',
    emptyDesc: 'Başlamak için öğrenci, mentör veya yönetici davet et.',
    emptyFiltered: 'Bu filtreye uyan üye yok.',
    statusActive: 'Aktif',
    statusInactive: 'Pasif',
    statusInvited: 'Davetli',
    role: {
      student: 'Öğrenci',
      mentor: 'Mentör',
      admin: 'Yönetici',
    },
    inviteExpires: '{{date}} tarihinde sona eriyor',
    lastActivity: 'Son aktivite {{date}}',
    mentorSince: '{{date}} tarihinden bu yana mentör',
    resend: 'Tekrar Gönder',
    resendSuccessTitle: 'Davet yeniden gönderildi',
    resendSuccessMessage: 'Yeni bir davet e-postası gönderildi.',
    resendFailed: 'Davet yeniden gönderilemedi',
    revoke: 'İptal',
    revokeTitle: 'Davet iptal edilsin mi?',
    revokeMessage: 'Davet bağlantısı hemen çalışmayı bırakacak.',
    revokeFailed: 'Davet iptal edilemedi',
    noSchoolAccess: 'Bu ekran yalnızca okul yöneticileri tarafından kullanılabilir.',
  },

  // Bağımsız /students ekranı (okul yöneticisi)
  students: {
    title: 'Öğrenciler',
    summaryLine: 'Toplam {{total}} • Aktif {{active}} • Davetli {{invited}}',
    invite: 'Davet Et',
    inviteFirst: 'İlk öğrenciyi davet et',
    searchPlaceholder: 'İsim veya e-posta ile ara',
    filterAll: 'Tümü ({{count}})',
    filterActive: 'Aktif ({{count}})',
    filterInvited: 'Davetli ({{count}})',
    filterInactive: 'Pasif ({{count}})',
    loading: 'Öğrenciler yükleniyor…',
    loadFailed: 'Öğrenciler yüklenemedi',
    emptyTitle: 'Henüz öğrenci yok',
    emptyDesc: 'Başlamak için ilk öğrencini davet et.',
    emptyFiltered: 'Bu filtreye uyan öğrenci yok.',
    statusActive: 'Aktif',
    statusInactive: 'Pasif',
    statusInvited: 'Davetli',
    transcriptsShort_one: '{{count}} transkript',
    transcriptsShort_other: '{{count}} transkript',
    transcriptsShort: '{{count}} transkript',
    chatsShort_one: '{{count}} sohbet',
    chatsShort_other: '{{count}} sohbet',
    chatsShort: '{{count}} sohbet',
    inviteExpires: '{{date}} tarihinde sona eriyor',
    noSchoolAccess: 'Öğrenci panelleri yalnızca okul yöneticileri için kullanılabilir.',
  },

  // Kohortlar (okula ait öğrenci grupları)
  cohorts: {
    title: 'Kohortlar',
    subtitle: 'Öğrencileri eğitim kohortlarında grupla. Bir öğrenci aynı anda yalnızca bir aktif kohortta olabilir.',
    create: 'Yeni kohort',
    createFirst: 'İlk kohortu oluştur',
    loading: 'Kohortlar yükleniyor…',
    emptyTitle: 'Henüz kohort yok',
    emptyDesc: 'Öğrencileri programa, başlangıç tarihine veya mentöre göre gruplamak için bir kohort oluşturun.',
    memberCount_one: '{{count}} üye',
    memberCount_other: '{{count}} üye',
    memberCount: '{{count}} üye',
    openEnded: 'açık uçlu',
    members: 'Üyeler',
    addStudents: 'Ekle',
    addStudentsTitle: 'Kohorta öğrenci ekle',
    csvInvite: 'CSV davet',
    csvInviteComplete: 'CSV içe aktarma tamamlandı',
    csvInviteSummary: '{{invited}} yeni öğrenci davet edildi ve {{added}} mevcut öğrenci eklendi.',
    csvInviteSkipped: '{{count}} öğrenci zaten bu kohortta.',
    csvInviteEmailFailures: '{{count}} davet e-postası gönderilemedi. Öğrenciler ekranından yeniden gönderin.',
    csvInvitePersonalSubscriptionWarning: '{{count}} davetlinin aktif bir bireysel aboneliği var. Okulunuza katılmaları bu abonelikleri iptal etmez; isterlerse fatura ayarlarından kendileri iptal edebilir.',
    csvInviteFailed: '{{count}} satır başarısız oldu.',
    csvInviteFailedGeneric: 'CSV içe aktarılamadı',
    noStudentsToAdd: 'Eklenebilecek öğrenci yok.',
    noMembers: 'Henüz üye yok.',
    archive: 'Arşivle',
    archiveTitle: 'Kohort arşivlensin mi?',
    archiveConfirm: 'Aktif üyeler kohorttan çıkarılacak.',
    transfer: 'Taşı',
    transferTitle: 'Öğrenci taşınsın mı?',
    transferPrompt: 'Bu öğrenci başka bir aktif kohortta. Buraya taşımak ister misin?',
    nameLabel: 'Ad',
    namePlaceholder: 'örn. Seviye 1 - Bahar 2026',
    descriptionLabel: 'Açıklama (isteğe bağlı)',
    descriptionPlaceholder: 'Kısa açıklama…',
  },

  // School Management
  schoolManagement: {
    title: 'Okul Yönetimi',
    loading: 'Okul verileri yükleniyor...',
    failedToLoad: 'Okul bilgileri yüklenemedi',
    exportStudentsSuccess: 'Öğrenci verileri başarıyla dışa aktarıldı.',
    exportStudentsError: 'Öğrenci verileri dışa aktarılamadı. Lütfen tekrar deneyin.',
    resendInvitationError: 'Davet yeniden gönderilemedi. Lütfen tekrar deneyin.',
    documentLinkSheet: {
      title: 'Çerçevelere bağla',
      description: 'İsterseniz bu belgeyi bir veya daha fazla çerçeveye bağlayın; yapay zekâ bu çerçeveler için belgeyi kullanır.',
      file: 'Dosya: {{filename}}',
      uploadWithoutLinking: 'Bağlamadan yükle',
      uploadLinked: 'Yükle ve bağla ({{count}})',
    },
    noSchool: 'Okul bulunamadı',
    loadingAnalytics: 'Analitikler yükleniyor...',
    dashboardAnalytics: 'Panel Analitiği',
    engagementsTab: 'Mentor süreçleri',
    engagementRoster: {
      title: 'Mentor süreç listesi',
      subtitle: 'Okulunuzdaki mentorların yürüttüğü mentor koçluğu süreçleri.',
      privacyTitle: 'Bazı satırlar neden "Gizli danışan" gösteriyor?',
      privacyBody: 'Danışan adı, e-postası ve formlar yalnızca mentor süreç içinde "Okulla paylaş" seçeneğini açtığında görünür. O zamana kadar yalnızca durum ve sayıları görürsünüz.',
      privateMentee: 'Gizli danışan',
      shared: 'Okulla paylaşıldı',
      notShared: 'Paylaşılmadı',
      mentor: 'Mentor #{{id}}',
      level: 'Seviye',
      status: 'Durum',
      sessions: '{{count}} seans',
      finalSofs: '{{count}} kesinleşmiş SGF',
      crfFinal: 'YİF kesinleşti',
      crfDraft: 'YİF taslak',
      crfNone: 'Henüz YİF yok',
      rulesOk: 'ICF kuralları tamam',
      rulesIncomplete: 'ICF kuralları eksik',
      open: 'Salt okunur aç',
      filterAll: 'Tümü',
      filterActive: 'Aktif',
      filterCompleted: 'Tamamlanan',
      filterArchived: 'Arşivlenen',
      countActive: '{{count}} aktif',
      countCompleted: '{{count}} tamamlanan',
      countCrfFinal: '{{count}} kesinleşmiş YİF',
      countShared: '{{count}} paylaşılan',
      empty: 'Henüz mentor süreci yok',
      emptyBody: 'Okulunuzdaki mentorlar süreç oluşturduğunda burada görünür.',
      emptyFiltered: 'Bu filtreye uyan süreç yok.',
      loadError: 'Süreç listesi yüklenemedi.',
      forbidden: 'Bu okul için mentor süreçleri etkin değil. Mentor planı için hesap sahibinize danışın.',
      retry: 'Tekrar dene',
    },
    cohortsTab: 'Kohortlar',
    sections: {
      students: 'Öğrenciler',
      thisMonth: 'Bu ay',
      allTime: 'Tüm zamanlar',
    },
    metrics: {
      transcriptsThisMonth: 'Bu ayki transkriptler',
      transcriptsTotal: 'Toplam transkript',
      active7Days: 'Aktif / toplam',
      activePercent: 'Bu hafta %{{pct}} aktif',
      avgIcfScore: 'Ortalama ICF skoru',
      avgIcfSubtext: 'Tamamlanan analizlere göre',
      chatsThisMonth: 'Bu ayki sohbet oturumları',
      chatsTotal: 'Toplam sohbet oturumu',
      documentsUploaded: 'Yüklenen dokümanlar',
    },
    recentAnalysesTitle: 'Son Transkript Analizleri',
    recentAnalysesEmpty: 'Henüz transkript analizi yok',
    inactiveStudentsTitle: 'Aktif Olmayan Öğrenciler ({{count}})',
    inactiveStudentsDescription: 'Bu öğrenciler son 7 günde hiçbir aktivite göstermedi:',
    inactiveStudentsMore: '+{{count}} adet daha aktif olmayan öğrenci',
    quickActionsHeading: 'Hızlı İşlemler',
    quickActionsButtons: {
      inviteStudent: 'Öğrenci Davet Et',
      uploadDocument: 'Doküman Yükle',
      viewStudents: 'Tüm Öğrencileri Gör',
    },
    studentsHeading: 'Öğrenciler ({{count}})',
    filters: {
      all: 'Tümü',
      active: 'Aktif',
      inactive: 'Pasif',
      invited: 'Davet Edildi',
    },
    sortBy: 'Sırala:',
    sortOptions: {
      name: 'İsim',
      activity: 'Aktivite',
      transcripts: 'Transkript',
      score: 'Skor',
    },
    loadingStudentAnalytics: 'Öğrenci analitikleri yükleniyor...',

    // Tabs
    overview: 'Genel Bakış',
    students: 'Öğrenciler',
    mentorsTab: 'Mentörler',
    documents: 'Dökümanlar',
    settings: 'Ayarlar',

    // Overview
    schoolOverview: 'Okul Genel Bakış',
    subscription: 'Abonelik',
    planType: 'Plan Türü',
    status: 'Durum',
    active: 'Aktif',
    inactive: 'Aktif Değil',
    seatsUsed: 'Kullanılan Koltuklar',
    of: '/',
    billingCycle: 'Fatura Dönemi',
    nextBilling: 'Sonraki Fatura',
    studentEnrollment: 'Öğrenci Kaydı',
    totalStudents: 'Toplam Öğrenci',
    activeStudents: 'Aktif Öğrenci',
    pendingInvites: 'Bekleyen Davetler',

    // Students
    studentsList: 'Öğrenci Listesi',
    inviteStudent: 'Öğrenci Davet Et',
    invite: 'Davet Et',
    exportCSV: 'CSV İndir',
    requestMoreSeats: 'Daha Fazla Koltuk Talep Et',
    noStudents: 'Henüz kayıtlı öğrenci yok',
    noStudentsFiltered: 'Bu filtreyle eşleşen öğrenci yok',
    noStudentsFilteredHint: 'Filtrelerinizi değiştirerek tekrar deneyin',
    inviteFirstStudent: 'Başlamak için ilk öğrencinizi davet edin',
    studentName: 'Öğrenci Adı',
    email: 'E-posta',
    enrolled: 'Kayıt Tarihi',
    removeStudent: 'Öğrenciyi Kaldır',
    packageLabel: 'Paket',
    subscriptionStatus: 'Abonelik Durumu',
    renewalDate: 'Yenileme Tarihi',
    renewalUnknown: 'Yenileme tarihi mevcut değil',
    statusUnknown: 'Durum bilinmiyor',
    unknownPackage: 'Bilinmeyen paket',
    resetUsage: 'Kullanımı sıfırla',
    resettingUsage: 'Sıfırlanıyor…',
    resetUsageConfirm: '{{name}} için kullanım limitleri sıfırlansın mı? Bu işlem mevcut dönem için sohbet ve analiz sayaçlarını temizler.',
    resetUsageSuccess: 'Kullanım limitleri başarıyla sıfırlandı.',
    resetUsageError: 'Kullanım limitleri sıfırlanamadı. Lütfen tekrar deneyin.',
    student: {
      statusActive: 'Aktif',
      statusInactive: 'Pasif',
      lastActivityLabel: 'Son:',
      never: 'Hiç',
      transcriptsCount: '{{completed}} / {{total}} transkript',
      messagesCount: '{{count}} mesaj',
      avgScore: 'Ort: {{score}}/100',
      enrolledAt: 'Kayıt: {{date}}',
      invitedAt: 'Davet: {{date}}',
      sending: 'Gönderiliyor...',
    },

    // Quick Actions
    quickActions: 'Hızlı İşlemler',
    manageStudents: 'Öğrencileri Yönet',
    inviteStudents: 'Okulunuza yeni öğrenciler davet edin',
    manageAdmins: 'Yöneticileri Yönet',
    addRemoveAdmins: 'Okul yöneticileri ekleyin veya kaldırın',
    viewDocuments: 'Dökümanları Görüntüle',
    accessMaterials: 'Okula özel koçluk materyallerine erişin',
    schoolSettings: 'Okul Ayarları',
    configureSchool: 'Okul tercihlerini ve faturalandırmayı yapılandırın',

    // Access Control
    accessRequired: 'Okul Yöneticisi Erişimi Gerekli',
    mustBeSchoolAdmin: 'Bu bölüme erişmek için okul yöneticisi olmalısınız.',

    // Super Admin View
    superAdminViewTitle: 'Süper Admin Görünümü',
    superAdminViewDesc1: 'Süper admin olarak sistemdeki tüm okullara erişiminiz vardır. Bu okul yönetimi arayüzü öncelikle okul yöneticileri içindir.',
    superAdminViewDesc2: 'Kapsamlı platform yönetimi için lütfen "Platform Yönetimi" sekmesini kullanın.',

    // Coming Soon Sections
    documentsComingSoon: 'Bu bölüm, okulunuza özel koçluk dökümanlarını yüklemenize ve yönetmenize olanak sağlayacak.',
    settingsComingSoon: 'Okulunuzun yapay zeka koçluk ayarlarını, sistem komutlarını ve tercihlerini yapılandırın.',

    documentsSection: {
      title: 'RAG Bilgi Bankası Dokümanları',
      subtitle: 'Koçluk kaynaklarını ve materyallerini yükleyin',
      aboutTitle: 'Okul Dokümanları Hakkında',
      aboutDescription: 'Bu dokümanlar okulunuzdaki tüm öğrenciler için yapay zekânın koçluk bilgisini zenginleştirir. Desteklenen formatlar: PDF, TXT, DOCX (maks 50MB).',
      loading: 'Dokümanlar yükleniyor...',
      emptyTitle: 'Henüz Doküman Yok',
      emptySubtitle: 'Yapay zekânın bilgisini artırmak için ilk kaynağınızı yükleyin',
      uploadFirst: 'İlk Dokümanını Yükle',
      methodLabel: 'Yöntem',
      methodGrowModel: 'GROW modeli',
      methodCustomFramework: 'Özel çerçeve',
      methodLinkedFramework: 'Bağlı çerçeve',
      methodSchoolDocument: 'Okul dokümanı',
      methodUnknown: 'Bilinmiyor',
      sizeLabel: 'Boyut',
      chunksLabel: '{{count}} parça',
      dateLabel: '{{date}}',
      processed: 'İşlendi',
      processing: 'İşleniyor',
      deleteTitle: 'Dokümanı Sil',
      deleteConfirm: '"{{filename}}" dokümanını silmek istediğinizden emin misiniz?',
      deleteSuccess: 'Doküman başarıyla silindi',
      deleteError: 'Doküman silinemedi. Lütfen tekrar deneyin.',
      uploadSuccess: 'Doküman başarıyla yüklendi',
      uploadError: 'Doküman yüklenemedi. Lütfen tekrar deneyin.',
      loadError: 'Dokümanlar yüklenemedi. Lütfen tekrar deneyin.',
      totalDocs: 'Toplam Doküman: {{count}}',
      totalChunks: 'Toplam Parça: {{count}}',
      totalSize: 'Toplam Boyut: {{size}}',
    },

    // Frameworks Tab
    frameworks: 'Çerçeveler',
    frameworksSection: {
      active: 'Aktif',
      inactive: 'Pasif',
      approved: 'Onaylandı',
      pendingApproval: 'Beklemede',
      stepsShort: 'adım',
      preview: 'Önizle',
      searchSteps: 'Adım ara…',
      noSteps: 'Henüz adım yok. İlk adımını ekle.',
      conceptsShort: 'kavram',
      frameworkMetaTitle: 'Çerçeve ayrıntıları',
      selectStepTitle: 'Bir adım seç',
      selectStepBody: 'Sol panelden bir adım seç ya da başlamak için yeni bir tane ekle.',
      controlPanel: 'Kontrol paneli',
      positiveShort: 'Olumlu',
      negativeShort: 'Gelişim',
      approvalReminder: 'Yayınlamadan önce bu çerçeveyi inceleyip onayla.',
      activeLabel: 'Aktif',
      activeHint: 'Tüm koçluk süreçlerinde kullanılabilir.',
      approvedLabel: 'Onaylandı',
      approvedHint: 'Bu çerçeveyi üretime hazır olarak işaretler.',
      lastSaved: 'Son kayıt: az önce',
      footerHint: 'Değişiklikler kaydedilmeden uygulanmaz.',
      title: 'Koçluk Çerçeveleri',
      subtitle: 'Okulunuzun koçluk metodolojisi çerçevelerini yönetin',
      loading: 'Çerçeveler yükleniyor...',
      emptyTitle: 'Henüz Çerçeve Yok',
      emptySubtitle: 'Koçluk metodolojisi dokümanı yükleyerek otomatik çerçeve oluşturun',
      uploadFramework: 'Çerçeve Dokümanı Yükle',
      uploadFirst: 'İlk Çerçevenizi Yükleyin',
      uploadFrameworkDesc: 'Koçluk metodolojinizi anlatan bir PDF, TXT veya DOCX yükleyin. Yapay zekâ çerçeve yapısını otomatik çıkaracaktır.',
      infoTitle: 'Koçluk Çerçeveleri Nedir?',
      infoDescription: 'Koçluk metodolojinizi anlatan bir doküman yükleyin, yapay zekâ adımları, göstergeleri ve yetkinlikleri otomatik olarak yapılandırılmış bir çerçeveye dönüştürecektir.',
      editFramework: 'Çerçeveyi Düzenle',
      stepCount: '{{count}} adım',
      typeStepModel: 'Adım Modeli',
      typeCompetencyModel: 'Yetkinlik Modeli',
      typeStepModelDescription: 'Adım Modeli, görüşmenin sırayla ilerleyen akışını tanımlar (örn. hazırlık → keşif → eylem). Adımlar genelde ardışık uygulanır.',
      typeCompetencyModelDescription: 'Yetkinlik Modeli, ölçülen beceri alanlarını tanımlar (örn. dinleme, varlık, güçlü soru). Alanlar sıra zorunluluğu olmadan değerlendirilir.',
      statusApproved: 'Onaylandı',
      statusDraft: 'Taslak',
      statusActive: 'Aktif',
      statusInactive: 'Pasif',
      createdAt: 'Oluşturulma: {{date}}',
      sourceDoc: 'Kaynak: {{filename}}',
      extractionDetailsTitle: 'Çıkarım Detay Özeti',
      extractionDetailsSummary: '{{subSteps}} alt adım/boyut • {{concepts}} kavram • {{positive}} pozitif • {{negative}} negatif • {{questions}} örnek soru',
      // Editor
      editorTitle: 'Çerçeveyi Düzenle',
      frameworkName: 'Çerçeve Adı',
      frameworkNameTr: 'Ad (Türkçe)',
      frameworkNameEn: 'Ad (İngilizce)',
      frameworkType: 'Çerçeve Türü',
      stepsHeading: 'Adımlar',
      addStep: 'Adım Ekle',
      stepName: 'Adım Adı',
      stepNameTr: 'Ad (Türkçe)',
      stepNameEn: 'Ad (İngilizce)',
      stepDescription: 'Açıklama',
      subSteps: 'Alt Adımlar',
      behaviorDimensions: 'Davranış Boyutları',
      concepts: 'Kavramlar',
      positiveMarkers: 'Pozitif Göstergeler',
      negativeMarkers: 'Negatif Göstergeler',
      sampleQuestions: 'Örnek Sorular',
      subStepsShort: 'alt adım',
      behaviorDimensionsShort: 'boyut',
      positiveMarkersShort: 'pozitif',
      negativeMarkersShort: 'negatif',
      sampleQuestionsShort: 'soru',
      icfMapping: 'ICF Yetkinlik Eşleştirmesi',
      icfMappingNone: 'Yok',
      approve: 'Onayla',
      activate: 'Aktifleştir',
      deactivate: 'Deaktifleştir',
      save: 'Değişiklikleri Kaydet',
      saving: 'Kaydediliyor...',
      saveSuccess: 'Çerçeve başarıyla kaydedildi',
      saveError: 'Çerçeve kaydedilemedi. Lütfen tekrar deneyin.',
      deleteStep: 'Adımı Sil',
      deleteStepConfirm: 'Bu adımı çerçeveden kaldırmak istediğinize emin misiniz?',
      moveUp: 'Yukarı Taşı',
      moveDown: 'Aşağı Taşı',
      expandStep: 'Genişlet',
      collapseStep: 'Daralt',
      addTag: 'Ekle',
      tagPlaceholder: 'Yazıp Ekle\'ye basın...',
      // Framework picker in upload
      linkToFramework: 'Çerçeveye Bağla (isteğe bağlı)',
      linkToFrameworkDesc: 'Bu dokümanı daha akıllı AI erişimi için bir veya daha fazla çerçeveyle ilişkilendirin',
      selectFrameworks: 'Çerçeve Seçin',
      noFrameworksAvailable: 'Kullanılabilir çerçeve yok',
      frameworkLanguage: 'Doküman Dili',
      languageTr: 'Türkçe',
      languageEn: 'İngilizce',
      uploadSuccess: 'Çerçeve dokümanı yüklendi. AI çıkarımı kısa süre içinde başlayacak.',
      extractionInProgress: 'Çerçeve yüklemesi tamamlandı. AI çıkarımı devam ediyor...',
      reviewReady: 'Çerçeve çıkarıldı. Düzenleyici açılıyor.',
      reviewTimeout: 'Yükleme başarılı, ancak çıkarım hâlâ sürüyor. Birazdan çerçeveleri yenileyin.',
      uploadError: 'Çerçeve dokümanı yüklenemedi.',
      deleteTitle: 'Çerçeveyi Sil',
      deleteConfirm: '"{{name}}" çerçevesini silmek istediğinizden emin misiniz?',
      deleteSuccess: 'Çerçeve başarıyla silindi.',
      deleteError: 'Çerçeve silinemedi. Lütfen tekrar deneyin.',
    },

    settingsSection: {
      title: 'Okul Ayarları',
      profileTitle: 'Okul Profili',
      schoolName: 'Okul Adı',
      schoolNameSupport: 'Okul adını değiştirmek için destekle iletişime geçin',
      schoolId: 'Okul ID',
      slug: 'Kısa Ad',
      subscriptionType: 'Abonelik Türü',
      subscriptionStatusFallback: 'pasif',
      studentCapacity: 'Öğrenci Kapasitesi',
      studentCapacityValue: '{{current}} / {{max}} öğrenci',
      helpTitle: 'Yardım mı lazım?',
      helpDescription: 'Okul ayarları, markalaşma veya yapılandırma desteği için lütfen destek ekibimizle iletişime geçin.',
      contactSupport: 'Destekle İletişime Geç',
      supportDialogTitle: 'Destek',
      supportDialogMessage: 'E-posta: support@mentorcoach.ai\nGenellikle 24 saat içinde yanıt veriyoruz.',
    },
  },

  // School Credits
  studentDetail: {
    title: 'Öğrenci ayrıntıları',
    studentPill: 'Öğrenci',
    icfAvgPill: 'ICF ort. {{score}}',
    loading: 'Öğrenci ayrıntıları yükleniyor…',
    loadErrorTitle: 'Öğrenci ayrıntıları yüklenemedi',
    loadErrorBody: 'Öğrenci ayrıntıları yüklenemedi.',
    noPermission: 'Öğrenci ayrıntılarını görüntüleme izniniz yok. Lütfen yöneticinize başvurun.',
    accessDenied: 'Erişim reddedildi. Öğrenci analizlerini görmek için okul yöneticisi yetkisi gerekir.',
    tryAgain: 'Tekrar dene',
    stats: {
      thisMonth: 'Bu ay',
      transcripts: 'Transkript',
      totalSessions: 'Toplam seans',
      chatMessages: 'Sohbet mesajı',
      documents: 'Belgeler',
      avgIcf: 'Ort. ICF',
    },
    recentAnalyses: 'Son analizler',
    itemCountOne: '{{count}} kayıt',
    itemCountOther: '{{count}} kayıt',
    noAnalyses: 'Henüz analiz yok',
    icfProgressTitle: 'ICF yetkinlik gelişimi',
    overallAverage: 'Genel ortalama',
    basedOnSessionsOne: '{{count}} seansa göre',
    basedOnSessionsOther: '{{count}} seansa göre',
    icfEmpty: 'ICF verileri en az bir seans analiz edildiğinde görünür.',
    lastActivityNote: 'Son etkinlik: {{date}}. Veriler yalnızca bu okul içinde görünür.',
    readOnly: 'Salt okunur görünüm',
    close: 'Kapat',
    closeDrawer: 'Paneli kapat',
    activity: {
      none: 'Henüz etkinlik yok',
      today: 'Bugün aktif',
      daysAgo: '{{days}} gün önce aktif',
      inactiveDays: '{{days}} gündür pasif',
      inactiveLong: '30+ gündür pasif',
    },
  },
  schoolAiPolicy: {
    behaviorTitle: 'Yapay Zekâ Davranış Ayarları',
    gradingHarshness: 'Değerlendirme Sertliği',
    gradingHarshnessPlaceholder: '0.0 – 1.0 (ör. 0.5)',
    narrativeStyle: 'Anlatım Tarzı',
    narrativeStyles: {
      balanced: 'dengeli',
      encouraging: 'cesaretlendirici',
      direct: 'doğrudan',
    },
    feedbackDetailLevel: 'Geri Bildirim Ayrıntı Düzeyi',
    detailLevels: {
      brief: 'kısa',
      standard: 'standart',
      detailed: 'ayrıntılı',
    },
    saving: 'Kaydediliyor...',
    saveBehavior: 'Davranış Ayarlarını Kaydet',
    behaviorSaved: 'Davranış ayarları kaydedildi',
    knowledgeTitle: 'Bilgi Bağlantıları',
    knowledgePackIds: 'Bilgi Paketi Kimlikleri',
    knowledgePackIdsPlaceholder: 'Virgülle ayrılmış paket kimlikleri',
    frameworkSourceIds: 'Çerçeve Kaynak Kimlikleri',
    frameworkSourceIdsPlaceholder: 'Virgülle ayrılmış çerçeve kimlikleri',
    saveKnowledge: 'Bilgi Bağlantılarını Kaydet',
    knowledgeSaved: 'Bilgi bağlantıları kaydedildi',
    knowledgeHint: 'Kimlikleri virgülle ayırın. Bunlar platform düzeyindeki bilgi paketlerine eklenir.',
    behaviorLoadError: 'Davranış politikası yüklenemedi',
    knowledgeLoadError: 'Bilgi politikası yüklenemedi',
    tryAgainLater: 'Lütfen sayfayı yenileyin veya daha sonra tekrar deneyin.',
    behaviorSaveError: 'Davranış ayarları kaydedilemedi. Lütfen tekrar deneyin.',
    knowledgeSaveError: 'Bilgi bağlantıları kaydedilemedi. Lütfen tekrar deneyin.',
  },
  schoolCredits: {
    title: 'Kredi Havuzu',
    overview: 'Kredi Genel Bakış',
    available: 'kredi mevcut',
    totalAvailable: 'Toplam Mevcut',
    subscriptionPool: 'Abonelik Havuzu',
    paidSeatCapacity: 'Ödenen Koltuk Kapasitesi',
    creditsPerSeat: 'Koltuk Başına Analiz Kredisi',
    subscriptionRemaining: 'Abonelik Kalan',
    purchasedCredits: 'Satın Alınan Krediler',
    billingPeriod: 'Fatura Dönemi',
    periodEnds: 'Dönem sonu',
    purchased: 'satın alınan',
    used: 'kullanılan',
    poolUsage: 'Havuz Kullanımı',
    buyMore: 'Kredi Al',
    low: 'Düşük',
    critical: 'Kritik',
    lowWarning: 'Düşük Kredi',
    poolNote: 'Krediler tüm öğrenciler arasında paylaşılır. Satın alınan kredilerin süresi dolmaz ve abonelik kredilerinden sonra kullanılır.',
    usageByStudent: 'Öğrenciye Göre Kullanım',
    student: 'Öğrenci',
    credits: 'Kredi',
    noUsageYet: 'Henüz kredi kullanımı kaydedilmedi',
    totalUsed: 'Toplam Kullanılan',
  },

  // Create School
  createSchool: {
    title: 'Yeni Okul Oluştur',
    subtitle: 'Abonelik için hazır varsayılanlarla yeni bir okul ekleyin',
    schoolName: 'Okul Adı',
    schoolNamePlaceholder: 'örn., Mentor Koçluk Akademisi',
    slug: 'Kısa Ad',
    slugPlaceholder: 'örn., mentor-koçluk',
    maxStudents: 'Maksimum Öğrenci',
    harshness: 'Sertlik',
    createButton: 'Okul Oluştur',
    creating: 'Oluşturuluyor...',
    validationMaxStudents: 'Maksimum öğrenci sayısı pozitif bir sayı olmalıdır',
    validationHarshness: 'Sertlik 0 ile 10 arasında olmalıdır',
    successMessage: 'Okul başarıyla oluşturuldu',
    name: 'Ad',
    id: 'ID',
    required: 'Zorunlu',
    slugHelp: '3–50 küçük harf, rakam, tire veya alt çizgi. Okulun bağlantılarında kullanılır.',
    maxStudentsHelp: 'Kapasite: okulun alabileceği öğrenci sayısı. Ücretli koltuklar faturalandırma bölümünde belirlenir.',
    harshnessHelp: '0–10. Yüksek değerler daha sıkı geri bildirim verir.',
    billingTitle: 'Faturalandırma',
    billingSubtitle: 'Aylık abonelik. Fiyatları para biriminin ana biriminde girin (örn. 49,00).',
    currency: 'Para birimi',
    basePrice: 'Aylık temel fiyat',
    baseSeats: 'Dahil koltuk sayısı',
    addonPrice: 'Aylık ek paket fiyatı',
    addonPackageSize: 'Ek paket başına koltuk',
    priceSummary: '{{baseSeats}} koltuk için aylık {{basePrice}}; her {{addonSeats}} ek koltuk için aylık +{{addonPrice}}',
    emailLanguage: 'E-posta dili',
    emailLanguageHelp: 'Dil seçmemiş üyelere gönderilen davetler ve e-postalar için kullanılır.',
    emailLanguageAuto: 'Otomatik (para biriminden)',
    emailLanguageEnglish: 'İngilizce',
    emailLanguageTurkish: 'Türkçe',
    fixErrors: 'Lütfen işaretli alanları düzeltin.',
    billingSaveFailedTitle: 'Okul oluşturuldu ancak faturalandırma planı kaydedilemedi',
    billingSaveFailedMessage: '"{{name}}" (ID {{id}}) faturalandırma planı olmadan oluşturuldu. Platform Yönetimi\'nde açıp Planı düzenle ile faturalandırmayı ayarlayın. Okulu tekrar oluşturmayın. Hata: {{error}}',
    errors: {
      nameRequired: 'Okul adını girin',
      slugRequired: 'Kısa ad girin',
      slugFormat: '3–50 küçük harf, rakam, tire veya alt çizgi kullanın',
      price: '49 veya 49,00 gibi bir tutar girin (en fazla 2 ondalık)',
      positiveWhole: 'En az 1 olan bir tam sayı girin',
    },
  },

  // Documents (RAG Knowledge Base)
  documents: {
    title: 'RAG Bilgi Tabanı',
    subtitle: 'Tüm kullanıcıların sohbetlerinin kullandığı merkezi bilgi tabanını yönetin',
    loading: 'Yükleniyor...',
    uploadButton: 'Bilgi Tabanına Ekle',
    uploading: 'Bilgi Tabanına Yükleniyor...',
    noDocuments: 'Henüz bilgi tabanı dökümanı yok',
    noDocumentsSubtext: 'Merkezi bilgi tabanını oluşturmak için koçluk materyalleri yükleyin',
    totalChunks: 'Toplam Parçalar',
    status: 'Durum',
    knowledgeBaseStats: 'Bilgi Tabanı İstatistikleri',
    chunks: 'parça',
    processed: 'İşlendi',
    processing: 'İşleniyor',
    confirmDelete: 'Silmek istediğinizden emin misiniz',
    deleteSuccess: 'RAG bilgi dökümanı başarıyla silindi',
    deleteFailed: 'Döküman silinemedi',
    uploadSuccess: 'RAG bilgi dökümanı başarıyla yüklendi',
    uploadFailed: 'Döküman yüklenemedi',
    chunksCreated: 'Oluşturulan parçalar',
    loadFailed: 'RAG bilgi tabanı dökümanları yüklenemedi',
    accessDeniedTitle: 'Yönetici Erişimi Gerekli',
    accessDeniedText: 'Bu bölüm, tüm kullanıcıların sohbetlerinin kullandığı merkezi RAG bilgi tabanını yönetmek içindir.',
    accessDeniedSubtext: 'Yalnızca yöneticiler bilgi tabanı dökümanlarını yükleyebilir ve yönetebilir.',
    accessDeniedInfo: 'Normal bir kullanıcı olarak, analiz için dökümanları doğrudan sohbet arayüzünde yükleyebilirsiniz.',
  },

  // Admin Invite Modal

  // Student Invite Modal

  // School Plan Modal
  schoolPlan: {
    errors: {
      loadRequests: 'Talepler yüklenemedi.'
    },
    invalidValues: 'Lütfen geçerli fiyat ve koltuk değerleri gir.',
    savePlanError: 'Plan kaydedilemedi.',
    seats: {
      tooLowHint: 'Koltuk sayısı en az mevcut kullanım kadar olmalı.',
      currentStatus: 'Mevcut durum',
      currentPlan: 'Mevcut plan',
      currentPackage: 'Kurum paketi',
      activeSeats: 'Aktif koltuk',
      currency: 'Para birimi',
      newTarget: 'Yeni koltuk hedefi',
      minHint: 'Minimum: {{n}}',
      prorate: 'Farkı şimdi faturalandır',
      prorateHint: 'Kapalıysa değişiklik sonraki dönem uygulanır.',
      diffSummary: 'Değişiklik özeti',
      seatLabel: 'Koltuk',
      monthlyFee: 'Aylık ücret',
      diffPackage: 'Ek paket',
      notifyHint: 'Bu değişiklik okul yöneticisine bildirilir.',
      pendingRequests: 'Bekleyen talepler',
      viewAllRequests: 'Tüm talepleri gör →'
    },
    saveSeatsError: 'Koltuk güncellenemedi.',
    requests: {
      approveSuccess: 'Talep onaylandı.',
      rejectSuccess: 'Talep reddedildi.',
      actionError: 'İşlem tamamlanamadı.',
      refresh: 'Yenile',
      subtle: 'Bekleyen taleplerini incele ve karara bağla.',
      loading: 'Talepler yükleniyor…',
      empty: 'Bekleyen talep yok',
      emptyBody: 'Yeni talepler buraya düşünce inceleyebilirsin.',
      pending: 'Beklemede',
      requestedSeats: 'İstenen koltuk',
      requestedTier: 'İstenen plan',
      note: 'Not',
      reject: 'Reddet',
      approve: 'Onayla'
    },
    tabs: {
      plan: 'Plan',
      seats: 'Koltuklar',
      requests: 'Talepler'
    },
    savePlan: 'Planı kaydet',
    applyHint: 'Değişiklikler kaydedilmeden uygulanmaz.',
    saveSeats: 'Değişikliği kaydet',
    notifyHint: 'Bu değişiklik okul yöneticisine bildirilir.',
    subtitle: 'Koltuk sayısı, paket ve faturalama değişikliklerini tek yerden kontrol et.',
    basePlan: 'Temel plan',
    currency: 'Para birimi',
    currencyHint: '3 harfli ISO kodu (try, usd, eur)',
    basePrice: 'Temel aylık ücret',
    baseSeats: 'Tabanda dahil koltuk',
    addonPackages: 'Koltuk ek paketleri',
    pkgSize: 'Ek paket başına koltuk',
    pkgPrice: 'Ek paket fiyatı',
    summary: 'Plan özeti',
    monthlyBase: 'Aylık taban',
    perAddon: 'Ek paket başına',
    includes: 'içerir',
    aboutPlan: 'Bu plan hakkında',
    aboutBody: 'Değişiklikler, prorate uygulanmadıkça bir sonraki faturalama döneminde geçerli olur.',
    seatUnit: 'koltuk',
    title: 'Okul Planı Detayları',
    planType: 'Plan Türü',
    maxStudents: 'Maksimum Öğrenci',
    currentStudents: 'Mevcut Öğrenci',
    status: 'Durum',
    active: 'Aktif',
    inactive: 'Pasif',
    billingCycle: 'Faturalandırma Döngüsü',
    monthlyPrice: 'Aylık Ücret',
    features: 'Özellikler',
    close: 'Kapat',
  },

  // Seat Update Modal

  // Seat Requests Modal
  seatRequests: {
    title: 'Koltuk Talepleri',
    noRequests: 'Bekleyen koltuk talebi yok',
    requestedBy: 'Talep eden',
    requestedSeats: 'Talep Edilen Koltuklar',
    currentSeats: 'Mevcut',
    reason: 'Sebep',
    requestDate: 'Talep Tarihi',
    approve: 'Onayla',
    reject: 'Reddet',
    pending: 'Beklemede',
    approved: 'Onaylandı',
    rejected: 'Reddedildi',
    close: 'Kapat',
    approveSuccess: 'Talep başarıyla onaylandı',
    rejectSuccess: 'Talep reddedildi',
    actionError: 'Talep işlenemedi',
  },

  // Plan Change Requests (yönetici modalı)

  // Seat Request Create Modal

  // Plan Change Request (okul talep oluşturma modali)


  // Düz plan seviye etiketleri (bazı modaller plans.tierX bekliyor)

  // Admin Bill Invite Modal

  // Ses Transkripsiyon
  transcription: {
    realtimeNotAvailable: 'Gerçek zamanlı kayıt henüz kullanılamıyor. Lütfen bir dosya yükleyin.',
    meetingBotNotAvailable: 'Toplantı botu desteği yakında geliyor.',
    simple: {
      title: 'Ses kaydı hazır',
      subtitle: 'Şimdi transkript çıkarılır, sonra ICF analizi yapılır.',
      audioFile: 'Ses dosyası',
      ready: 'Hazır',
      defaultsTitle: 'Akıllı varsayılanlar',
      defaultLanguage: 'Dil otomatik algılanacak',
      defaultSpeakers: 'Konuşmacılar ayrılacak',
      defaultGrammar: 'Yazım düzeltilecek',
      defaultAnalysis: 'Sonra ICF analizi yapılacak',
      pathTitle: 'Ne olacak?',
      stepTranscribe: 'Ses transkribe edilir',
      stepSpeakers: 'Konuşmacılar ayrılır',
      stepAnalyze: 'ICF analizi yapılır',
      stepChat: 'Geri bildirim sohbete eklenir',
      advancedTitle: 'Ayarlar',
      safeDefaults: 'Ayarları değiştirmezseniz en güvenli varsayılanlarla devam ederiz.',
      hideSettings: 'Ayarları gizle',
      changeSettings: 'Ayarları değiştir',
      startCombined: 'Transkribe et ve analiz et'
    },
    edit: {
      tapToPlace: '"{word}" sözcüğünü yerleştirmek için bir segmente dokun',
      splitHere: 'Buradan böl',
      move: 'Taşı'
    },
    title: 'Ses Transkripsiyon',
    uploadAudio: 'Ses yükle',
    myTranscripts: 'Transkriptlerim',

    modal: {
      defaultICFInstructions: 'Bu koçluk oturumunu ICF yetkinlikleri açısından analiz et',
      title: 'Transkripsiyon Seçenekleri',
      start: 'Başla',
      language: 'Dil',
      autoDetect: 'Otomatik Algıla',
      turkish: 'Türkçe',
      english: 'İngilizce',
      speakerDiarization: 'Konuşmacıları Ayır',
      speakerDiarizationDesc: 'Koç/Müşteri olarak etiketle',
      grammarCorrection: 'Dilbilgisi Düzeltme',
      grammarCorrectionDesc: 'Yapay zeka ile noktalama/yazım düzeltme',
      postTranscription: 'Transkript Sonrası',
      analysisInstructions: 'Analiz Talimatları (Opsiyonel)',
      analysisPlaceholder: 'Koçluk görüşmesini ICF PCC kriterlerine göre değerlendir...',
      icfProgressToggle: 'Bu oturumu ICF gelişimime dahil et',
      icfProgressDesc: 'Varsayılan olarak açık. İlerleme geçmişini etkilemeden analiz etmek için kapat.',
      fileInfo: 'Süre: {{duration}} • {{size}}',
    },

    progress: {
      title: 'Transkripsiyon',
      validating: 'Ses dosyası doğrulanıyor...',
      uploading: 'Yükleniyor...',
      transcribing: 'Yapay zeka ile transkripsyon yapılıyor...',
      analyzingAudioCues: 'Ses duyguları ve ipuçları analiz ediliyor...',
      mergingDiarization: 'Konuşmacı tanımlama birleştiriliyor...',
      detectingSilences: 'Anlamlı duraklamalar algılanıyor...',
      failed: 'Transkripsiyon başarısız oldu',
      identifyingSpeakers: 'Konuşmacılar belirleniyor...',
      correctingGrammar: 'Dilbilgisi düzeltiliyor...',
      encrypting: 'Şifreleniyor ve kaydediliyor...',
      complete: 'Tamamlandı!',
      estimatedTime: 'Tahmini süre: ~{{minutes}} dakika',
      tip: 'İpucu: Transkriptlerinizi SRT/VTT altyazı formatında indirebilirsiniz!',
      processing: 'Ses dosyanız işleniyor...',
      cancel: 'Transkripsiyonu iptal et',
      cancelling: 'İptal ediliyor...',
      cancelFailed: 'Transkripsiyon iptal edilemedi. Lütfen tekrar deneyin.',
    },

    viewer: {
      title: 'Transkript',
      download: 'İndir',
      srt: 'SRT Altyazı',
      vtt: 'VTT Altyazı',
      txt: 'Düz Metin',
      silence: 'Sessizlik',
      seconds: 'saniye',
      tapToSeek: 'Bu ana atlamak için dokunun',
      rawText: 'Ham Metin',
      correctedText: 'Düzeltilmiş Metin',
      speakers: 'Konuşmacılar',
      silences: 'Sessizlikler',
      duration: 'Süre',
      analyzeSession: 'Görüşmesi Analiz Et',
      analyze: 'Analiz Et',
      playAudio: 'Sesi Oynat',
      noContent: 'Transkript içeriği mevcut değil',
      // Redesigned viewer
      breadcrumbSessions: 'Oturumlar',
      headerTitleReady: 'Transkript hazır',
      headerSubtitle: 'Düzelt, konuşmacıları kontrol et ve istediğin formatta dışa aktar.',
      pillSaved: 'Kaydedildi',
      pillSpeakers: '{{n}} konuşmacı',
      tabRead: 'Oku',
      tabEdit: 'Düzenle',
      controlsTitle: 'Kontroller',
      speakersHeading: 'Konuşmacılar',
      coachLabel: 'Koç',
      clientLabel: 'Müşteri',
      changeLabel: 'Etiketi değiştir',
      swapSpeakers: 'Koç ↔ Müşteri',
      exportHeading: 'Dışa aktar',
      shareHeading: 'Paylaşım',
      historyHeading: 'Geçmiş',
      lastSavedJustNow: 'Son kayıt: az önce',
      editsCount: '{{n}} kelime düzeltildi',
      editPendingCount: '{{n}} düzenleme var',
      cancelEdits: 'Vazgeç',
      saveChanges: 'Değişiklikleri kaydet',
      transcriptUpdated: 'Transkript güncellendi',
      refreshFeedback: 'Geri bildirimi güncelle',
      backToSession: 'Oturuma dön',
      openInChat: 'Sohbette aç',
      savedToLibrary: 'Kütüphaneye kaydedildi',
      secureNoticeTitle: 'Güvenli',
      secureNoticeBody: 'Koçluk verilerin senin kontrolünde.',
      editWordTitle: 'Kelimeyi düzelt',
      wordEditCancel: 'İptal',
      wordEditSave: 'Kaydet',
      // Ses ipucu etiketleri
      laughs: 'güler',
      voiceBreaks: 'ses kırılması',
      emotionPeak: 'duygusal zirve',
      speakingFaster: 'hızlanarak',
      speakingSlower: 'yavaşlayarak',
      hesitation: 'tereddüt',
      pitchShift: 'ses tonu değişimi',
      // Sessizlik bağlam etiketleri
      reflectionPause: 'Yansıma durağı',
      emotionalPause: 'Duygusal duraklama',
      thinkingPause: 'Düşünme durağı',
      // Koçluk içgörüleri
      coachingInsights: 'Koçluk İçgörüleri',
      powerfulQuestion: 'Güçlü soru',
      breakthroughMoment: 'Farkındalık anı',
      rapportLaughter: 'Uyum gülüşü',
      noInsights: 'Koçluk içgörüsü algılanmadı',
      // Prozodik özet
      prosodicSummary: 'Görüşme Ses Analizi',
      speakingRate: 'Konuşma hızı',
      speakingTime: 'Konuşma süresi',
      laughterCount: 'Gülme sayısı',
      emotionalMoments: 'Duygusal anlar',
      voiceBreakCount: 'Ses kırılmaları',
      reflectionPauses: 'Yansıma durakları',
      speakingRatio: 'Konuşma oranı (Koç/Müşteri)',
      wordsPerMin: 'kelime/dk',
      emotionalArc: 'Duygusal yay',
      diarizationMethod: 'Konuşmacı tanıma',
      diarizationConfidence: 'Güvenilirlik',
      providerUsed: 'Sağlayıcı',
    },


    list: {
      empty: 'Henüz transkript yok',
      emptyDesc: 'İlk transkriptinizi oluşturmak için ses dosyası yükleyin veya kaydedin',
      uploadFirst: 'Ses yükle',
      processing: 'İşleniyor...',
      completed: 'Tamamlandı',
      failed: 'Başarısız',
      deleteConfirm: 'Bu transkript silinsin mi?',
      deleteConfirmDesc: 'Transkript ve ses dosyası kalıcı olarak silinecek.',
      deleted: 'Transkript başarıyla silindi',
      pullToRefresh: 'Yenilemek için çekin',
    },

    errors: {
      loadFailed: 'Transkript yüklenemedi',
      quotaExceeded: 'Aylık transkript limiti aşıldı',
      fileTooLarge: 'Dosya çok büyük ({{size}}MB). İzin verilen maksimum: {{max}}MB',
      fileTooLargeGeneric: 'Dosya boyutu çok büyük. Lütfen daha kısa bir kayıt veya daha küçük bir dosya yükleyin.',
      durationTooLong: 'Ses çok uzun. Maksimum: {{duration}}',
      unsupportedFormat: 'Desteklenmeyen ses formatı',
      unsupportedAudio: 'Bu ses formatı desteklenmiyor. Lütfen MP3, WAV, M4A veya desteklenen başka bir format deneyin.',
      audioTooLarge: 'Bu dosya {{limit}} MB yükleme sınırını aşıyor. Bunun yerine yalnızca ses kaydını yükleyin (Zoom, videonun yanına bir .m4a dosyası kaydeder) ya da daha kısa bir kayıt yükleyin.',
      audioTooLong: 'Bu kayıt {{limit}} dakikalık sınırdan uzun. Kaydı kısaltın ya da en fazla {{limit}} dakikalık parçalara bölüp tek tek yükleyin.',
      audioUnsupportedFormat: 'Bu dosya türü desteklenmiyor. Seans kaydınızı şu biçimlerden biriyle yükleyin: {{formats}}.',
      audioUnreadable: 'Bu kayıt okunamadı; dosya bozuk ya da eksik olabilir. Kaydı uygulamanızdan yeniden dışa aktarıp yeni dosyayı yükleyin.',
      uploadFailed: 'Yükleme başarısız. Lütfen tekrar deneyin.',
      uploadInterrupted: 'Yükleme kesildi. Lütfen dosyayı tekrar seçip deneyin.',
      transcriptionFailed: 'Transkripsiyon başarısız',
      downloadFailed: 'Transkript indirilemedi',
      audioLoadFailed: 'Ses yüklenemedi',
    },

    actions: {
      upload: 'Ses Dosyası Yükle',
      record: 'Ses Kaydet',
      viewAll: 'Tüm Transkriptleri Gör',
    },
  },
  // My Documents Screen

  // Transkript Analizi
  analysis: {
    simple: {
      summaryTitle: "Analiz özeti",
      included: "Dahil",
      excluded: "Dahil değil",
      notApplicable: "Uygulanmaz",
      progressLabel: "ICF ilerlemesi",
      engagementResult: "Sonuç: incelemeniz için {{mentee}} adlı mentinin seansına eklenen bir gözlem taslağı",
      credits: "1 analiz kredisi kullanır · {{remaining}} kaldı",
      title: 'Analize hazır',
      subtitle: "Başlamadan önce analiz ayarlarını gözden geçirin.",
      ready: 'Hazır',
      levelAuto: "Otomatik — seansa göre belirlenir",
      resultToChat: 'Sonuç sohbete eklenecek',
      stepMarkers: "{{level}} işaretçileri değerlendirilir",
      hideSettings: 'Ayarları gizle',
      changeSettings: 'Ayarları değiştir',
      start: 'Analizi başlat'
    },
    modal: {
      prepareSessionReview: "Seans incelemesini hazırla",
      queueingReview: 'Oturum yükleniyor ve inceleme sıraya alınıyor. Canlı ilerleme birazdan açılır.',
      prepareReview: "İncelemeyi hazırla",
      engagementSubtitle: "{{mentee}} için · {{level}} standardına göre incelenir",
      reviewStandard: "İnceleme standardı",
      inheritedStandard: "{{level}} — mentorluk sürecinden devralındı",
      reviewStandardHelp: "Seans, ICF {{level}} Asgari Beceri Gerekliliklerine göre değerlendirilir ve {{level}} Seans Gözlem Formu (rev. {{sof_revision}}) oluşturulur.",
      feedbackLanguage: "Geri bildirim dili",
      additionalOptions: "Ek seçenekler",
      title: 'Transkript Analizi',
      start: 'Analiz Et',
      sourceTranscript: 'Kaynak Transkript',
      language: 'Analiz Dili',
      instructions: 'Analiz Talimatları',
      instructionsPlaceholder: 'Analiz için özel talimatlar ekleyin...',
      infoNote: 'Analiz, koçluk oturumu hakkında yapılandırılmış geri bildirim sağlamak için yapay zeka koçluk bilgi tabanımızı kullanacaktır.',
      modeTitle: 'Analiz Türü',
      icfMode: 'ICF Değerlendirmesi',
      icfModeDesc: 'ICF standartlarına göre koçluk yetkinliğini değerlendir',
      customMode: 'Özel Analiz',
      customModeDesc: 'Kendi özel talimatlarınızla analiz edin',
      levelTitle: 'Hedef Seviye',
      levelAuto: 'Otomatik belirle',
      levelAutoDesc: 'Sistemin uygun seviyeyi belirlemesine izin verin',
      levelACC: 'ACC',
      levelPCC: 'PCC',
      levelMCC: 'MCC',
      includeMarkerTable: 'Tam MSR Tablosu Ekle',
      includeMarkerTableDesc: 'Tüm MSR’leri transkript kanıtlarıyla tek tek değerlendirir (daha uzun sürebilir)',
      customPromptPlaceholder: 'Özel analiz talimatlarınızı girin...',
      upgradeRequired: 'Yükselt',
      upgradeRequiredDesc: '{{tierName}} planı ve üzeri için kullanılabilir',
      observationLevelTitle: 'Gözlem seviyesi',
      observationLevelHelp:
        'Görüşme, {{level}} Asgari Beceri Gereklilikleri’ne göre değerlendirilir ve ICF {{level}} Görüşme Gözlem Formu’nu (rev. {{revision}}) üretir.',
      observationLevelHelpAuto:
        'Otomatik seçeneği yalnızca gelişim raporu üretir; ICF Görüşme Gözlem Formu oluşturmaz. Form için bir seviye seçin.',
      observationLevelAuto: 'Otomatik — gelişim raporu, gözlem formu yok',
      engagementSelectTitle: 'Koçluk sürecine ekle',
      engagementSelectHelp:
        'İsteğe bağlı. Görüşmeyi bir mentor koçluk sürecine eklerseniz gözlem formu o danışanın altında dosyalanır.',
      engagementSelectNone: 'Süreç yok',
      engagementSelectLocked:
        'Seviye, süreç tarafından {{level}} olarak sabitlendi. Bu görüşme kendi ICF İlerlemenize dahil edilmez.',
    },
    progress: {
      pdfSaved: 'PDF cihaza kaydedildi.',
      livePreview: 'Canlı Önizleme',
      title: 'Oturumunuz Analiz Ediliyor',
      completeTitle: 'Analiz Tamamlandı!',
      failedTitle: 'Analiz Başarısız',
      complete: 'Analiz tamamlandı!',
      failed: 'Analiz başarısız oldu',
      starting: 'Analiz başlatılıyor...',
      startFailed: 'Analiz başlatılamadı. Lütfen tekrar deneyin.',
      stalledBeforeStart: 'Analiz başlamadı. Lütfen tekrar deneyin.',
      stalled: 'Analiz çok uzun sürdü ve takılmış olabilir. Lütfen tekrar deneyin.',
      statusUnavailable: 'Analiz durumu güncellenmeyi bıraktı. Lütfen tekrar deneyin.',
      missingResult: 'Analiz rapor üretmeden tamamlandı. Lütfen tekrar deneyin.',
      elapsedOnly: 'Geçen süre {{elapsed}}',
      etaWithElapsed: 'Geçen süre {{elapsed}} • Tahmini kalan {{remaining}}',
      reassuranceShort: 'Detaylı ICF analizi hazırlanıyor. Bu işlem birkaç dakika sürebilir.',
      reassuranceLong: 'Hâlâ çalışıyor — uzun transkriptlerde ve üst seviye kalibrasyonda kanıt kontrolü daha fazla zaman alabilir.',
      etaFewMinutes: 'birkaç dakika daha',
      detailReason: 'Sistem yalnızca özet çıkarmıyor; yetkinlik kanıtlarını, gelişim alanlarını ve seviye tutarlılığını kontrol ediyor.',
      etaUnderMinute: '1 dk’dan az',
      etaAboutDuration: 'yaklaşık {{duration}}',
      etaRangeDuration: '{{min}}-{{max}}',
      secondsShort: '{{seconds}} sn',
      minutesShort: '{{minutes}} dk',
      checkpoint: 'Kontrol noktası {{current}}/{{total}}: {{label}}',
      stillWorking: 'Hâlâ çalışıyor. Güncellemeler yavaş gelebilir.',
      cancel: 'Analizi iptal et',
      cancelling: 'İptal ediliyor...',
      cancelFailed: 'Analiz iptal edilemedi. Lütfen tekrar deneyin.',
      preparing: 'Hazırlanıyor...',
      reading: 'Belge okunuyor...',
      context: 'Bağlam toplanıyor...',
      scoring: 'Yetkinlik kanıtları değerlendiriliyor...',
      writing: 'Geliştirici geri bildirim yapılandırılıyor...',
      validating: 'Seviye ve kanıt tutarlılığı kontrol ediliyor...',
      stageDetail: {
        preparing: 'Analiz türü, dil ve oturum ayarları hazırlanıyor.',
        reading: 'Transkriptte koç/müşteri akışı, zaman damgaları ve oturum yapısı kontrol ediliyor.',
        context: 'ICF yetkinlik göstergeleri ve ilgili seviye bağlamı hazırlanıyor.',
        scoring: 'Davranış kanıtları yetkinlik bazında eşleştiriliyor.',
        writing: 'Geri bildirim güçlü yönler, gelişim odağı ve kanıt alıntılarıyla yapılandırılıyor.',
        validating: 'Seviye kararı, kanıtlar ve geri bildirim tutarlılığı tekrar kontrol ediliyor.',
        saving: 'Rapor sohbete ve oturum geçmişinize kaydediliyor.',
      },
      analyzing: 'İçerik analiz ediliyor...',
      generating: 'Öngörüler oluşturuluyor...',
      saving: 'Sonuçlar kaydediliyor...',
      successMessage: 'Koçluk oturumunuz analiz edildi. Detaylı geri bildirimi görüntüleyin veya PDF olarak indirin.',
      viewAnalysis: 'Analizi Görüntüle',
      downloadPdf: 'PDF indir',
      backToTranscript: 'Transkripta Dön',
      errorMessage: 'Bir şeyler yanlış gitti. Lütfen tekrar deneyin.',
      tip: 'Sistem yalnızca özet çıkarmıyor; yetkinlik kanıtlarını, gelişim alanlarını ve seviye tutarlılığını kontrol ediyor.',
      document: 'Belge',
      pdfWebOnly: 'PDF dışa aktarma şu anda yalnızca web\'de kullanılabilir.',
      pleaseWait: 'Bu biraz zaman alabilir...',
    },
    success: 'Analiz tamamlandı! Geri bildiriminiz aşağıda hazır.',
    error: 'Analiz başlatılamadı',
    viewAnalysis: 'Analizi Görüntüle',
    exportPdf: 'PDF indir',
    analysesSection: 'Analizler',
    noAnalyses: 'Henüz analiz yok',
    analysisDate: '{{date}} tarihinde analiz edildi',
  },
  // Kayıt Öncesi Tanıtım Akışı

  // Ana Sayfa Ekranı (Panel)
  home: {
    greetingMorning: 'Günaydın',
    greetingAfternoon: 'İyi günler',
    greetingEvening: 'İyi akşamlar',
    icfJourney: 'ICF Yolculuğunuz',
    currentLevel: 'Mevcut',
    targetLevel: 'Hedef',
    none: 'Yok',
    toGoal: 'hedefe',
    sessionsAnalyzed: 'oturum analiz edildi',
    quickActions: 'Hızlı Eylemler',
    analyzeSession: 'Oturum Analiz Et',
    talkToMentor: 'Yapay Zeka Mentor',
    myProgress: 'İlerlemem',
    myLibrary: 'Kütüphane',
    recentSessions: 'Son Oturumlar',
    seeAll: 'Tümünü Gör',
    untitledSession: 'Koçluk Oturumu',
    emptyTitle: 'Yolculuğunuza Başlayın',
    emptySubtitle: 'Yapay zeka destekli geri bildirim almak için ilk koçluk oturumunuzu yükleyin',
    uploadFirst: 'İlk Oturumu Yükle',
    loadError: 'Panel yüklenemedi',
  },

  // Kütüphane Ekranı
  library: {
    sampleTranscriptTitle: 'PCC demo oturumu transkripti',
    sampleTranscriptMeta: '38 dk · bağlantılı işaretçi kanıtları içeren transkript',
    sampleTranscriptOpen: 'Örnek oturumu keşfet',
    sampleBadge: 'ÖRNEK',
    emptyUploadCta: 'Bir oturum yükle',
    emptyRecordCta: 'Şimdi kaydet',
    analysisFailed: 'Analiz başarısız oldu',
    unsupportedFileType: 'Desteklenmeyen dosya türü. Lütfen bir ses kaydı (MP3, M4A, WAV) veya transkript (PDF, DOCX, TXT) yükle.',
    processing: 'İşleniyor',
    analyzed: 'Analiz edildi',
    notAnalyzed: 'Analiz edilmedi',
    filterAll: 'Tümü',
    filterTranscripts: 'Ses',
    filterDocuments: 'Metin',
    filterShared: 'Paylaşılan',
    typeVoice: 'SES',
    typeText: 'METİN',
    typeShared: 'PAYLAŞILAN',
    documents: 'belge',
    itemCount: '{{count}} belge',
    noItems: 'Henüz belge yok',
    emptyTitle: 'Henüz belge yok',
    noTranscripts: 'Henüz ses kaydı yok',
    noTextDocs: 'Henüz metin belgesi yok',
    noDocuments: 'Henüz belge yok',
    noSharedDocs: 'Henüz paylaşılan belge yok',
    emptySubtitle: 'Başlamak için bir oturum kaydı veya belge yükleyin',
    emptySharedSubtitle: 'Okul üyeleriniz tarafından paylaşılan belgeler burada görünecek',
    transcriptProcessing: 'Transkript hala işleniyor. Lütfen bekleyin.',
    transcriptUnavailable: 'Transkript mevcut değil.',
    noSessionAvailable: 'Bu belge için sohbet oturumu mevcut değil.',
    deleteTitle: 'Belgeyi Sil',
    deleteConfirm: '"{{filename}}" silinsin mi?',
    deleteWithChat: '"{{filename}}" ve ilişkili sohbeti silinsin mi?',
    deleteError: 'Belge silinemedi. Lütfen tekrar deneyin.',
    deleteFailedArtifactTitle: 'Başarısız yükleme temizlensin mi?',
    deleteFailedArtifactCopy: 'Bu başarısız yüklemenin dosyası ve kayıtları temizlenecek. Bu işlem geri alınamaz.',
    deleteFailedArtifactAction: 'Sil ve temizle',
    loadingDocument: 'Belge yükleniyor...',
    // Paylaşım
    share: 'Paylaş',
    shareWith: 'Okulla paylaş',
    sharedBy: '{{name}} tarafından paylaşıldı',
    shareSuccess: 'Belge başarıyla paylaşıldı',
    shareError: 'Belge paylaşılamadı',
    // Tarih biçimlendirme
    today: 'Bugün',
    yesterday: 'Dün',
    daysAgo: '{{days}} gün önce',
    // Dil etiketleri
    langTurkish: 'Türkçe',
    langEnglish: 'İngilizce',
    // Materyaller
    filterMaterials: 'Materyaller',
    typeMaterial: 'MATERYAL',
    uploadMaterial: 'Materyal Yükle',
    voiceRecording: 'Ses Kaydı',
    textDocument: 'Metin Belgesi',
    analyzeDocument: 'Belge Analiz Et',
    uploadChoice: 'Ne yapmak istersiniz?',
    noMaterials: 'Henüz materyal yüklenmedi',
    uploadSuccess: 'Materyal başarıyla yüklendi!',
    uploadFailed: 'Materyal yüklenemedi',
    fileTooLarge: 'Dosya çok büyük. Maksimum boyut 50MB.',
    textDocsNotViewable: 'Metin belgeleri henüz satır içi görüntülenemiyor',
    unknown: 'Bilinmeyen',
    sharingCenterStudentTitle: 'Mentörünle paylaş',
    sharingCenterStudentCopy: 'Bir transkripti seçip mentörüne gönderebilirsin. Kimin erişimi olduğunu aynı yerden yönetirsin.',
    sharingCenterMentorTitle: 'Öğrenci paylaşımlarını takip et',
    sharingCenterMentorCopy: 'Öğrencilerin paylaştığı transkriptleri burada görür, kendi materyallerini grupla paylaşabilirsin.',
    sharedWithMeShort: 'Sana gelen',
    sharedByMeShort: 'Senin paylaştıkların',
    lastSharedTo: 'Son paylaşım',
    openSharedInbox: 'Sana gelenleri aç',
    manageLatestShare: 'Son paylaşımı yönet',
    shareWithMentor: 'Mentörle paylaş',
    manageSharing: 'Paylaşımı yönet',
    openTranscript: 'Transkripti aç',
    downloadPdf: 'PDF indir',
    sharedOutEmpty: 'Paylaşmak için listeden bir oturum seç.',
    sharedOutEmptyReadonly: 'Paylaşılan içerikler burada görünecek.',
    webTitle: 'Oturumlar',
    webSubtitle: 'Koçluk kayıtlarını ve transkriptlerini tek yerden yükle, analiz et ve takip et.',
    webPrimaryUpload: 'Yeni oturum yükle',
    webUploadTitle: 'Oturumunu yükle',
    webUploadBody: 'Ses kaydı ya da transkript seç. Gerekli ayarları sonraki adımda sade şekilde soracağız.',
    webVoiceTitle: 'Ses kaydı',
    webVoiceMeta: 'MP3, M4A, WAV, MP4, MOV ve diğerleri',
    webTextTitle: 'Metin / transkript',
    webTextMeta: 'TXT, DOCX, PDF',
    webFlowUploadTitle: 'Yükle',
    webFlowUploadCopy: 'Oturum kaydını veya transkriptini seç.',
    webFlowAnalyzeTitle: 'Analiz edilir',
    webFlowAnalyzeCopy: 'Yapay zeka koçluk davranışlarını inceler.',
    webFlowChatTitle: 'Sohbette hazır',
    webFlowChatCopy: 'Sonuçları incele ve takip soruları sor.',
    webSearchPlaceholder: 'Oturum ara...',
    webEmptyTitle: 'Henüz oturum yok',
    webEmptyBody: 'İlk oturumu yüklediğinde analiz ve sohbet ekranları otomatik oluşur.',
    webEmptyCta: 'İlk oturumu yükle',
    webSideTitleFirst: 'İlk oturumunu yükle',
    webSideTitleNext: 'Bir sonraki oturumu ekle',
    webSideBody: 'En sade yol: dosyayı seç, varsayılan ayarları bırak, analiz hazır olunca sohbette incele.',
    webSideUpload: 'Oturum yükle',
    webSideTranscript: 'Transkript yükle',
    webPrivacyTitle: 'Gizliliğiniz bizim için önemli.',
    webPrivacyBody: 'Yüklediğin içerikler koçluk analizi için kullanılır ve hesap ayarlarından yönetilebilir.',
  },

  // İlerleme Ekranı (ICF Yolculuğu)
  progress: {
    icfJourney: 'ICF Yolculuğunuz',
    current: 'Mevcut',
    target: 'Hedef',
    none: 'Yok',
    toGoal: 'hedefe',
    sessionsAnalyzed: 'oturum analiz edildi',
    remaining: 'kalan',
    goalReached: 'Hedefe ulaşıldı!',
  },

  // Yükleme Akışı
  upload: {
    title: 'Oturum yükle',
    selectSource: 'Nasıl yüklemek istersiniz?',
    selectSourceDesc: 'Oturum kaynağınızı seçin',
    uploadFile: 'Dosya yükle',
    uploadFileDesc: 'Ses veya transkript dosyası',
    recordNow: 'Şimdi kaydet',
    pasteText: 'Metin yapıştır',
    comingSoon: 'Yakında',
    soon: 'Yakında',
    preparing: 'Yükleme hazırlanıyor...',
    uploading: 'Dosya yükleniyor...',
    transcribing: 'Ses transkribe ediliyor...',
    analyzing: 'Oturum analiz ediliyor...',
    finalizing: 'Tamamlanıyor...',
    complete: 'Tamamlandı!',
    processing: 'Oturumunuz işleniyor...',
    processingTitle: 'İşleniyor',
    processingHint: 'Bu birkaç dakika sürebilir...',
    successTitle: 'Oturum yüklendi',
    successSubtitle: 'Koçluk oturumunuz analiz edildi',
    overallScore: 'Genel puan',
    viewAnalysis: 'Tam analizi görüntüle',
    later: 'Daha sonra görüntüle',
    completeTitle: 'Tamamlandı',
    error: 'Yükleme başarısız',
    pickerError: 'Dosya seçilemedi',
  },

  // Öneri Çipleri

  // Toast Bildirimleri
  toast: {
    purchaseSuccess: 'Hesabınıza {{count}} kredi eklendi!',
    purchaseFailed: 'Kredi satın alma başarısız oldu. Lütfen tekrar deneyin.',
  },

  // Mentörler (Okul Yönetimi)
  mentors: {
    cancelInviteConfirm: '{{name}} ({{email}}) için gönderilen daveti iptal et?',
    nameRequired: 'Lütfen mentorün adını girin',
    invalidEmail: 'Lütfen geçerli bir e-posta adresi girin',
    fullName: 'Ad Soyad',
    fullNamePlaceholder: 'Mentorün adını girin',
    email: 'E-posta Adresi',
    invalidEmailHint: 'Geçerli bir e-posta adresi girin.',
    capabilityTitle: 'Bu mentorun yapabilecekleri',
    cap: {
      review: 'Paylaşılan öğrenci oturumlarını incele',
      feedback: 'Yapılandırılmış geri bildirim bırak',
      cohort: 'Kohort ilerlemesini takip et'
    },
    roleHintTitle: 'Bu rol hakkında',
    roleHintBody: 'Mentorlar yalnızca öğrencilerin kendileriyle açıkça paylaştığı oturumları görebilir.',
    verifyHint: 'Mentor, e-posta yoluyla tek kullanımlık bir davet bağlantısı alır.',
    sendInvitation: 'Davet Gönder',
    resendSuccess: 'Davet yeniden gönderildi',
    resendError: 'Davet yeniden gönderilemedi',
    cancelInviteTitle: 'Daveti İptal Et',
    cancelError: 'Davet iptal edilemedi',
    resendInvitation: 'Daveti yeniden gönder',
    cancelInvitation: 'Daveti iptal et',
    pendingInvitations: 'Bekleyen Davetler',
    title: 'Mentörler',
    invite: 'Mentör Davet Et',
    inviteTitle: 'Mentör Davet Et',
    inviteSubtitle: 'Davet etmek istediğiniz mentörün e-posta adresini girin',
    emailPlaceholder: 'mentor@ornek.com',
    emailLabel: 'E-posta Adresi',
    emailRequired: 'E-posta gerekli',
    emailInvalid: 'Lütfen geçerli bir e-posta girin',
    sendInvite: 'Davet Gönder',
    sending: 'Gönderiliyor...',
    inviteSuccess: 'Davet başarıyla gönderildi',
    inviteError: 'Davet gönderilemedi',
    noMentors: 'Henüz mentör yok',
    inviteFirst: 'Okulunuzu yönetmenize yardımcı olması için mentör davet edin',
    removeTitle: 'Mentörü Kaldır',
    removeConfirm: '{{name}} mentör olarak kaldırılsın mı?',
    removeMentor: 'Mentörü kaldır',
    removeError: 'Mentör kaldırılamadı',
    seatsFull: 'Tüm mentör kontenjanları dolu',
  },

  // Belge Paylaşımı
  share: {
    consentText: 'Müşterimin bu koçluk seansı kaydının denetim/geri bildirim amacıyla paylaşılacağı konusunda bilgilendirildiğini ve onayını verdiğini onaylıyorum.',
    title: 'Belge Paylaş',
    subtitle: '"{{filename}}" belgesini okulunuzla paylaşın',
    shareWith: 'Paylaş',
    entireSchool: 'Tüm Okul',
    entireSchoolDesc: 'Tüm öğrenciler ve mentörler görebilir',
    specificStudents: 'Belirli Öğrenciler',
    specificStudentsDesc: 'Sadece seçilen öğrenciler görebilir',
    selectStudents: 'Öğrenci Seç',
    searchStudents: 'Öğrenci ara...',
    noStudentsFound: 'Öğrenci bulunamadı',
    selectedCount: '{{count}} alıcı',
    share: 'Paylaş',
    sharing: 'Paylaşılıyor...',
    cancel: 'İptal',
    success: 'Belge başarıyla paylaşıldı',
    error: 'Belge paylaşılamadı',
    stepOf: 'Adım {{current}} / {{total}}',
    consentTitle: 'Müvekkil Onayı',
    iConfirm: 'Müvekkil onayını onaylıyorum',
    addNote: 'Not ekle (isteğe bağlı)',
    notePlaceholder: 'Bir mesaj yaz...',
    send: 'Paylaş',
    selectAtLeastOne: 'Lütfen en az bir alıcı seçin',
    noRecipients: 'Uygun alıcı yok',
    allShared: 'Herkesle paylaşıldı',
    allSchoolMembersHaveAccess: 'Tüm okul üyelerinin zaten erişimi var',
    // Yeni paylaşım anahtarları
    allMembers: 'Tüm Üyeler',
    allStudents: 'Tüm Öğrenciler',
    manageRecipients: 'Alıcıları Yönet',
    addMore: 'Alıcı Ekle',
    addCount: '{{count}} Ekle',
    removeRecipientTitle: 'Alıcıyı Kaldır',
    removeRecipientConfirm: 'Bu kişinin belgeye erişimi kalmayacak.',
    noRecipientsYet: 'Henüz alıcı yok',
    addRecipientsHint: 'Bu belgeyi paylaşmak için alıcı ekleyin',
    selectRecipients: 'Alıcıları Seç',
    roleStudent: 'Öğrenci',
    roleMentor: 'Mentör',
    roleAdmin: 'Yönetici',
  },

  // Bildirimler
  notifications: {
    title: 'Bildirimler',
    empty: 'Henüz bildirim yok',
    emptySubtitle: 'Sizinle belgeler paylaşıldığında bildirimleri burada göreceksiniz',
    markAllRead: 'Tümünü okundu işaretle',
    newDocument: 'Yeni belge paylaşıldı',
    documentShared: '{{name}} sizinle bir belge paylaştı',
    viewDocument: 'Belgeyi Görüntüle',
    justNow: 'Şimdi',
    minutesAgo: '{{count}} dk önce',
    hoursAgo: '{{count}} sa önce',
    daysAgo: '{{count}} gün önce',
    loadError: 'Bildirimler yüklenemedi',
    fromSender: '{{name}} tarafından',
  },

  // Deneme / Ücretsiz Önizleme
  trial: {
    launchOffer: 'Lansman fırsatı: İlk 3 ayda %20 indirim — ödemede LAUNCH20 kodunu kullanın',
    analysisUsed: {
      message: 'Deneme sürümünüz bir analiz içerir. Planınız {{date}} tarihinde başladığında daha fazla analiz açılır.',
      messageNoDate: 'Deneme sürümünüz bir analiz içerir. Planınız başladığında daha fazla analiz açılır.',
    },
    upload: {
      headerBadge: 'Dakikalar içinde ICF geri bildirimi',
      title: 'Bir koçluk oturumunu gelişim planına dönüştürün',
      description: 'Bir koçluk transkripti yükleyin ve 8 ICF yetkinliğiyle tam bir analiz ile ACC/PCC/MCC seviyenizi öğrenin.',
      uploading: 'Yükleniyor...',
      analyzing: 'Transkriptiniz analiz ediliyor...',
      analyzingDescription: 'Genellikle 60–90 saniye sürer',
      complete: 'Analiz tamamlandı!',
      error: 'Bir hata oluştu',
      selectFile: 'Transkript Yükle',
      tryAgain: 'Tekrar Deneyin',
      redirecting: 'Sonuçlarınız açılıyor...',
      skipToPricing: 'Planları görüntüle',
      helpToggle: 'Transkript nedir? ▼',
      helpContent: 'Siz ve müşteriniz arasındaki koçluk görüşmesinin kaydı. Örneğin:\n• Zoom/Teams toplantı transkripti\n• Sohbet veya e-posta yazışması\n• Bir oturumdan yazdığınız notlar',
      errorTooLarge: 'Dosya çok büyük. Daha kısa bir transkript deneyin.',
      errorInvalid: 'Bu dosya türü desteklenmiyor. PDF, Word veya metin dosyası kullanın.',
      errorDuplicate: 'Bu transkript zaten analiz edildi. Farklı bir tane deneyin.',
      errorNetwork: 'Bağlantı kesildi. İnternetinizi kontrol edip tekrar deneyin.',
      errorGeneric: 'Bir sorun oluştu. Lütfen tekrar deneyin.',
      whatYouGet: 'Neler alacaksınız',
      feature1: 'Tam 8 yetkinlikli ICF analizi',
      feature2: 'ACC / PCC / MCC seviyeniz',
      feature3: 'Sonuçlarınız hakkında 20 yapay zeka mentor konuşması',
    },
    banner: {
      expiresIn: 'Deneme süresi bitiyor',
      messagesUsed: '{{count}}/20 mesaj',
      subscribeCTA: 'Yükselt',
      expired: 'Süresi doldu',
      label: 'Ücretsiz deneme',
      legacyLabel: 'Ücretsiz deneme · Kart gerekmez',
      cardBackedLabel: 'Ücretsiz deneme · Kart kayıtlı',
      legacyNotice: 'Ücretsiz denemeniz mevcut bitiş tarihine kadar devam eder. Otomatik yenilenmez ve ücret alınmaz.',
      cardBackedNotice: 'Önceden iptal etmezseniz deneme sona erdiğinde kayıtlı ödeme yönteminizden ücret alınır.',
      noMessages: 'mesaj kalmadı',
      expiringSoon: 'yakında sona eriyor',
      lastMessage: 'Bu son ücretsiz mesajınız',
      messagesOf: '{{used}} / {{total}} kullanıldı',
      valueBadge: 'Dakikalar içinde ICF geri bildirimi',
      welcomeTitle: 'Sıradaki koçluk oturumunuzu gelişim planına dönüştürün',
      welcomeDescription: 'Bir transkript yükleyin, ACC/PCC/MCC yetkinlik profilinizi görün ve yapay zeka mentorunuza neyi geliştirmeniz gerektiğini sorun.',
      urgencyDescription: 'Oturum hâlâ tazeyken bugünkü yansıtmanızı somut sonraki adımlara dönüştürün.',
      trialTerms: 'Ücretsiz deneme. Sınırlı kullanım.',
      startTrial: 'Ücretsiz Denemeyi Başlat',
      startingTrial: 'Deneme başlatılıyor...',
      savingPath: 'Odak kaydediliyor...',
      startError: 'Denemeniz başlatılamadı. Lütfen tekrar deneyin.',
      openApp: 'Mentor Coaching AI\'ı Aç',
      uploadFirstCta: 'Önce transkript yükle',
      practiceCta: 'Yapay zeka müşteriyle pratik yap',
      pathQuestion: 'Denemeniz ilk olarak neye uyum sağlasın?',
      pathDescription: 'Bu seçimi kaydediyor ve daha sonra analiz, yapay zeka mentor sohbeti ve aktivasyon hatırlatmalarında kullanıyoruz.',
      accessCodeHelper: 'Kodunuz; okul, mentor koç veya deneme bağlantınızı otomatik tanır ve deneyimi buna göre hazırlar.',
      sampleFormHelper: 'Örnek form, gerçek analizde hangi bilgilerin kullanılacağını gösterir. Zorunlu alanları, isteğe bağlı odakları ve analiz dilini önceden görmenizi sağlar.',
      firstUploadHelper: 'Varsayılan ayarlar çoğu kullanıcı için yeterlidir. Dilerseniz hedef seviyenizi veya özel analiz odağınızı ekleyebilirsiniz.',
      liveMentorPrepTitle: 'Mentor koçluk görüşmesine daha hazırlıklı gelin',
      liveMentorPrepDescription: 'MCAi ön analiziyle mentor koçluk görüşmesine daha odaklı sorular, kanıt alıntıları ve net bir gelişim odağıyla gelin.',
      pathSaveError: 'Bu odağı kaydedemedik. Lütfen tekrar deneyin.',
      paths: {
        session_analysis: {
          title: 'Müşteri oturumunu analiz et',
          description: 'Oturum hâlâ tazeyken güncel bir transkript kullanın.',
          headline: 'Gerçek bir müşteri oturumunu somut koçluk geri bildirimine dönüştürün',
          body: 'Denemeniz transkript analizi, ICF yetkinlik sinyalleri ve bir sonraki oturum iyileştirmelerine öncelik verecek.',
          uploadTitle: 'En çok geri bildirim istediğiniz oturumla başlayın',
          uploadDescription: 'En çok geri bildirim istediğiniz oturumu yükleyin. Mentor Coaching AI kayıtlı odağınızı ilk analiz ve takip sohbetinde kullanacak.',
        },
        credential_prep: {
          title: 'ACC/PCC/MCC için hazırlan',
          description: 'Koçluk kanıtlarınızın nerede hazır olduğunu ve nerede gelişmesi gerektiğini görün.',
          headline: 'Denemeyi koçluğunuzun akreditasyona ne kadar hazır olduğunu görmek için kullanın',
          body: 'Denemeniz ICF kanıtlarına, seviye göstergelerine ve unvan hazırlığı açısından önemli yetkinlik boşluklarına odaklanacak; mentor koçluk görüşmesine daha odaklı sorularla gelmenize yardımcı olacak.',
          uploadTitle: 'Mevcut koçluk seviyenizi temsil eden bir oturum yükleyin',
          uploadDescription: 'Mevcut koçluk seviyenizi temsil eden bir oturum yükleyin. Uygulama akreditasyon odağınızı sonraki analiz ve mentor sohbette koruyacak.',
        },
        mentor_review: {
          title: 'Mentor koç olarak incele',
          description: 'Kanıtları, kalıpları ve süpervizyon temalarını daha hızlı bulun.',
          headline: 'Mentor inceleme çalışmasını daha keskin bir kanıt temeline dönüştürün',
          body: 'Denemeniz görüşme kanıtlarına, gelişim temalarına ve mentor koçluk görüşmesinde ele alabileceğiniz sorulara odaklanacak.',
          uploadTitle: 'İncelemeniz gereken bir oturum yükleyin',
          uploadDescription: 'İncelemeniz gereken bir oturum yükleyin. Mentor Coaching AI mentor inceleme bağlamını sonraki uygulama rehberliğinde kullanacak.',
        },
        practice_first: {
          title: 'Yüklemeden önce pratik yap',
          description: 'Simüle bir müşteriyle başlayın, sonra gerçek çalışmanızı analiz edin.',
          headline: 'Pratikle başlayın, sonra gerçek bir oturumu denemeye taşıyın',
          body: 'Denemeniz ilk adımları hafifletecek: önce yapay zeka müşteriyle pratik yapın, hazır olduğunuzda gerçek bir oturum kullanın.',
          uploadTitle: 'Önce pratik yapın veya hazır olduğunuzda yükleyin',
          uploadDescription: 'Şimdi yükleyebilir veya yapay zeka müşteriyle başlayabilirsiniz. Kayıtlı pratik odağınız sonraki rehberliğe taşınacak.',
        },
      },
      uploadTitle: 'Gerçek bir koçluk oturumuyla başlayın',
      uploadDescription: 'Ücretsiz denemeniz sırasında bir transkript yükleyin.',
      uploadSession: 'Oturum yükle',
      activeKicker: 'Ücretsiz deneme',
      activeTitle: 'Denemeniz aktif',
      activeStatus: '{{chatCount}} sohbet kullanıldı \u00B7 {{remaining}} kalan \u00B7 {{hoursLeft}} saat kaldı',
      hoursLeft: '{{count}} sa kaldı',
      continueSession: 'Deneme oturumuna devam et',
      expiredTitle: 'Deneme süreniz sona erdi',
      expiredDescription: 'Oturum analizi ve yapay zeka mentorunuzla sohbet etmeye devam etmek için yükseltin.',
      viewPlans: 'Planları gör',
    },
    chatLimit: {
      badge: 'Ücretsiz Deneme',
      title: 'Deneme mesajlarınızın tamamını kullandınız',
      description: 'Kişiselleştirilmiş yapay zeka geri bildirimiyle koçluk becerilerinizi geliştirmeye devam etmek için sınırsız konuşmaların kilidini açın.',
      withPro: 'Abonelikle birlikte',
      feature1: 'Sınırsız koçluk konuşması',
      feature2: 'Sınırsız transkript analizi',
      feature3: 'Zaman içinde ilerlemenizi takip edin',
      subscribeCTA: 'Koçluğa Devam Et',
      inputPlaceholder: 'Deneme limiti doldu — devam etmek için abone olun',
      guarantee: 'İstediğiniz zaman iptal edin. Anında erişim.',
      dismiss: 'Şimdi değil',
    },
    expired: {
      lockBadge: 'Önizleme Sona Erdi',
      title: 'Analiz sonuçlarınız kilitlendi',
      description: 'Sonuçlarınızı kalıcı olarak açmak ve sınırsız analizlerle gelişmeye devam etmek için abone olun.',
      yourLevel: 'Seviyeniz:',
      unlockTitle: 'Abonelikle açın',
      unlock1: 'Bu analiz — kalıcı olarak sizin',
      unlock2: 'Sınırsız yeni analiz',
      unlock3: 'Sınırsız yapay zeka koçluk konuşması',
      unlock4: 'Oturumlar arası ilerlemenizi takip edin',
      subscribeCTA: 'Sonuçlarımı Aç',
      guarantee: 'İstediğiniz zaman iptal edin. Sonuçlar kalıcıdır.',
      headerBadge: 'Deneme süresi doldu',
      modalTitle: 'Analizinizi kaybetmeyin',
      modalDescription: 'Koçluk analiziniz ve yapay zeka konuşmalarınız sizi bekliyor. Onları kalıcı olarak saklamak ve sınırsız erişim için abone olun.',
      losing: 'Abone olmadan',
      losingDetail: 'Analiz sonuçları kilitli. Sohbet geçmişi erişilemez.',
      keeping: 'Abonelikle',
      keepingDetail: 'Tüm sonuçlar kalıcı olarak açık. Sınırsız analiz ve konuşma.',
      dismiss: 'Belki sonra',
    },
  },

  mentorTraining: {
    cohortSettings: 'Kohort ayarları',
    featureOffTitle: 'Mentor Koç Eğitimi bu kohorta kapalı',
    featureOffBody: 'Bu özelliği kohort ayarlarından açtığınızda öğrenciler kenar çubuğunda Mentor Koç Eğitimi sekmesini görür ve burada yayınladığınız alıştırmalara erişebilir.',
    enableFeature: 'Özelliği aç',
    title: 'Mentor Koç Eğitimi',
    subtitle:
      'Analiz edilmiş bir koçluk seansını mentor koç gözüyle değerlendirin. MCAi aynı seansı bağımsız puanlar; yazılı geri bildiriminiz ICF Mentor Koçluk Yetkinliklerine göre eleştirilir.',
    cohort: 'Kohort',
    back: 'Listeye dön',
    transcript: 'Transkript',
    gradeAsMentor: 'Mentor koç gibi puanla',
    yourSubmission: 'Senin değerlendirmen',
    overallLevel: 'Genel seviye değerlendirmesi',
    writtenFeedback: 'Yazılı mentor geri bildirimi',
    writtenHint:
      'Bu müşteri koça mentor seansında ne söylerdiniz? Kanıt göstererek yazın.',
    strength: 'Güçlü yön',
    growth: 'Gelişim alanı',
    strengthPlaceholder: 'Bir gözlem ve transkriptten bir alıntı…',
    growthPlaceholder: 'Bir alan ve nasıl deneyimleyebileceklerine dair öneri…',
    evidencePlaceholder: 'Transkriptten bir alıntı yapıştırın (isteğe bağlı)…',
    submit: 'Gönder ve uyumu gör',
    noTranscript:
      'Bu alıştırmada gömülü transkript yok. Eğitmeninize danışın.',
    submissions: 'gönderim',
    archive: 'Arşivle',
    publishedOn: 'Yayınlandı',
    notPublished: 'Henüz yayınlanmadı',
    studentGrading: 'Öğrencinin değerlendirmesi',
    studentFeedback: 'Öğrencinin yazılı geri bildirimi',
    noMembersYet: 'Bu kohortta henüz üye yok.',
    newDrill: 'Yeni alıştırma',
    noData: 'Veri yok',
    footnote:
      'Mentor Koç Yeterliliği (MCQ) — yeni ICF mentor koç sertifikasyonu — 1 Ocak 2027’de yürürlüğe giriyor.',
    level: { acc: 'ACC', pcc: 'PCC', mcc: 'MCC', unknown: '—' },
    status: {
      submitted: 'Tamamlandı',
      inProgress: 'Devam ediyor',
      notStarted: 'Başlanmadı',
    },
    view: { student: 'Öğrenci görünümü', instructor: 'Eğitmen görünümü' },
    empty: {
      studentTitle: 'Henüz size atanmış bir alıştırma yok',
      studentBody:
        'Eğitmeniniz bir transkripti alıştırma olarak yayınladığında burada görünür.',
      instructorTitle: 'Bu kohort için henüz alıştırma yok',
      instructorBody:
        'Analiz edilmiş bir transkripti açın ve "Alıştırma olarak yayınla" diyerek bu kohorta atayın.',
      noCohortsTitle: 'Önce bir kohort oluşturun',
      noCohortsBody:
        'Okul yönetiminden yeni bir kohort açın ve öğrencilerinizi ekleyin.',
    },
    stats: {
      submitted: 'Tamamlanan',
      inProgress: 'Devam eden',
      notStarted: 'Başlanmamış',
      avgScore: 'Ortalama uyum',
    },
    table: {
      student: 'Öğrenci',
      status: 'Durum',
      score: 'Uyum',
      alignment: 'Hizalama',
    },
    results: {
      title: 'Değerlendirme uyumu',
      summary: 'MCAi pipeline’ı ile karşılaştırma',
      exactMatches: 'tam isabet',
      you: 'Sen',
      mcai: 'MCAi',
      evidence: 'MCAi’nin alıntıları',
      critiqueTitle: 'Yazılı geri bildirim eleştirisi',
      alignment: 'Hizalama',
      strengthCritique: 'Güçlü yön notu',
      growthCritique: 'Gelişim alanı notu',
      suggestedRewrite: 'Önerilen yeniden yazım',
      tips: 'MCC seviyesine yaklaşmak için ipuçları',
      processing: 'İşleniyor…',
      fallback:
        'Eleştiri servisi geçici olarak ulaşılamaz oldu — geri bildiriminiz kaydedildi, kendi gözden geçirmenizi yapabilirsiniz.',
    },
    publish: {
      title: 'Yeni alıştırma yayınla',
      cohort: 'Kohort',
      sourceDoc: 'Kaynak transkript (analiz edilmiş)',
      titleLabel: 'Alıştırma başlığı',
      titlePlaceholder: 'ör. PCC seviyesinde aktif dinleme oturumu',
      module: 'Modül (opsiyonel)',
      modulePlaceholder: 'ör. Hafta 3',
      targetLevel: 'Hedef seviye',
      instructions: 'Eğitmen notu (opsiyonel)',
      instructionsPlaceholder:
        'Öğrencilere odaklanmalarını istediğiniz yetkinlik veya konu…',
      cancel: 'Vazgeç',
      confirm: 'Kohorta yayınla',
      noCohorts: 'Önce bir kohort oluşturun.',
      noDocs:
        'Yayınlanabilecek analiz edilmiş transkriptiniz yok. Önce bir oturumu yükleyip analiz edin.',
    },
    validation: {
      allCompetencies: 'Lütfen tüm yetkinlikler için bir seviye seçin.',
      feedbackRequired: 'Lütfen güçlü yön ve gelişim alanı için geri bildirim yazın.',
    },
  },
  mentorEngagements: {
    workspace: {
      "sessionActions": "Oturum işlemleri",
      "tabs": {
            "overview": "Genel bakış",
            "sessions": "Oturumlar",
            "documents": "İnceleme ve belgeler"
      },
      "reviewing": "İncelenen: {{mentee}} · {{level}} standardı (ICF {{level}} formları rev. {{revision}})",
      "editEngagement": "Süreci düzenle",
      "priorities": "Gelişim öncelikleri",
      "editPriorities": "Öncelikleri düzenle",
      "priorityNote": "Öncelik notu",
      "addPriority": "Öncelik ekle",
      "remove": "Kaldır",
      "noPriorities": "Henüz gelişim önceliği belirlenmedi.",
      "mentorSet": "Mentor tarafından belirlendi",
      "sinceReview": "Son incelenen oturumdan bu yana",
      "noComparison": "Karşılaştırma için henüz yeterli sayıda incelenmiş oturum yok",
      "comparisonSessions": "Oturum {{previous}} → Oturum {{latest}}",
      "noChanges": "Karşılaştırılan ifadelerde değerlendirme değişikliği yok.",
      "competencies": "Yetkinliklere genel bakış",
      "demonstrated": "{{required}} ifadeden {{count}} tanesi gösterildi",
      "confirmed": "Sizin tarafınızdan onaylandı",
      "aiSuggested": "Yapay zekâ önerisi",
      "summary": "Süreç özeti",
      "summaryCounts": "{{hours}} saat · {{sessions}} oturum",
      "share": "Durumu okulla paylaş",
      "shareExplanation": "Paylaşıldığında okul çalışanları bu formları okuyabilir.",
      "metadataOnly": "Yalnızca süreç durumu görüntülenebilir. Mentor form içeriğini paylaşmadı.",
      "practiceDetails": "Yansıtma ve pratik",
      "reflection": "Mentinin yansıtması",
      "practiceActions": "Pratik adımları",
      "action": "Pratik adımı",
      "addAction": "Pratik adımı ekle",
      "optionalCompetency": "Yetkinlik (isteğe bağlı)",
      "none": "Yok",
      "done": "Tamamlandı",
      "missing": "Eksik belgeler",
      "documentationComplete": "Belgeler tamamlandı.",
      "sessionNumber": "Oturum {{number}}",
      "sofExport": "Oturum {{number}} · SOF PDF",
      "drafts": "{{count}} taslak inceleme bekliyor",
      "viewStatus": "Durumu görüntüle",
      "next": {
            "add_first_session": "İlk oturumu ekle",
            "review_draft_sof": "Taslak gözlemi incele",
            "finalize_sof": "Gözlem formunu kesinleştir",
            "set_priorities": "Gelişim önceliklerini belirle",
            "record_practice": "Pratiği kaydet",
            "generate_crf_narrative": "CRF anlatısını oluştur",
            "finalize_crf": "CRF formunu kesinleştir",
            "complete_rule_checks": "Kural kontrollerini tamamla",
            "export_documents": "Belgeleri dışa aktar"
      },
      "states": {
            "consistently_demonstrated": "Tutarlı biçimde gösteriliyor",
            "developing": "Gelişiyor",
            "insufficient_evidence": "Yeterli kanıt yok",
            "needs_mentor_review": "İncelemeniz gerekiyor",
            "verified": "Doğrulandı",
            "not_observed": "Henüz gözlem yok"
      },
      "missingItems": {
            "unsigned_sof": "Gözlem formu imza bekliyor",
            "missing_session_date": "Oturum tarihi eksik",
            "missing_duration": "Oturum süresi eksik",
            "crf_not_finalized": "CRF kesinleştirilmedi",
            "c1_not_verified": "C1 doğrulaması bekleniyor"
      },
      "ratings": {
        "does_not_meet": "Standardı karşılamıyor",
            "observed": "Gözlemlendi",
            "not_observed": "Gözlemlenmedi",
            "meets": "Standardı karşılıyor",
            "below": "Standardın altında",
            "exceeds": "Standardı aşıyor",
            "na": "Uygulanamaz",
            "not_applicable": "Uygulanamaz"
      }
},
    review: {
      action: "İncele",
      title: "Oturum {{number}} · {{date}}",
      uploaded: "Yüklenen kayıt",
      manual: "Manuel mentor oturumu",
      draft: "Taslak",
      final: "Kesinleştirildi",
      signed: "İmzalayan: {{name}} · {{date}}",
      summary: "{{total}} ifadeden {{mentorConfirmed}} tanesini onayladınız · {{aiSuggested}} yapay zekâ önerisi · {{unrated}} değerlendirilmemiş",
      confirmed: "Sizin tarafınızdan onaylandı",
      aiSuggested: "Yapay zekâ önerisi",
      unrated: "Değerlendirilmemiş",
      useAi: "Yapay zekâ değerlendirmesini kullan",
      rationale: "Yapay zekâ gerekçesi",
      counterEvidence: "Karşı kanıt",
      supportingEvidence: "Destekleyici kanıt",
      coach: "Koç",
      client: "Müşteri",
      turn: "Konuşma sırası {{number}}",
      noEvidence: "Alıntı bulunmuyor.",
      comment: "Mentor yorumları",
      c1: "C1 · Etik ve koçluk rolü",
      c1Note: "Kayıtlı değerler yapay zekâ varsayılanları olabilir. Onay yalnızca bu incelemedeki seçimler için gösterilir; form bu değerleri kimin belirlediğini saklamaz.",
      storedValue: "Kayıtlı değer · onay bilgisi bilinmiyor",
      original: "Önceki değer",
      observed: "Gözlemlendi",
      notObserved: "Gözlemlenmedi",
      strengths: "Güçlü yönler",
      development: "Gelişim alanları",
      competency: "Yetkinlik",
      statement: "Geri bildirim ifadesi",
      addFeedback: "Geri bildirim ekle",
      removeFeedback: "Geri bildirimi kaldır",
      save: "Taslağı kaydet",
      finalize: "Kesinleştir",
      reopen: "Yeniden aç",
      pdf: "PDF indir",
      unsaved: "Kesinleştirmeden veya indirmeden önce değişikliklerinizi kaydedin.",
      saveError: "İnceleme kaydedilemedi. Değişiklikleriniz korundu; lütfen tekrar deneyin.",
      loadError: "Oturum gözlem formu yüklenemedi.",
      reopenError: "Form yeniden açılamadı.",
      archived: "Arşivlenmiş süreçler salt okunurdur.",
      overridden: "Bunu siz değiştirdiniz",
      progress: "{{total}} ifadeden {{confirmed}} tanesi onaylandı",
      finalizeWarning: "{{unrated}} değerlendirilmemiş · {{rejected}} kanıtı reddedilmiş ifade var. Yine de kesinleştirebilirsiniz.",
      state: {
        unrated: "Değerlendirilmemiş",
        aiSuggested: "Yapay zekâ önerisi",
        confirmed: "Onaylandı",
        overridden: "Sizin tarafınızdan değiştirildi",
        evidenceRejected: "Kanıt reddedildi",
        aiSaid: "Yapay zekâ önerisi: {{label}}",
      },
      rating: {
        helper: "Bir değerlendirme seçin",
        aiSuggestedPct: "Yapay zekâ önerisi · %{{percent}}",
        lowConfidence: "Düşük güven — önce buraya bakın",
        pcc64: "Oturumda enerji değişimi olmaması da Gözlemlendi sayılır.",
        naDefinition: "Uygulanamaz: bu davranış bu oturumla ilgili değildi.",
        overrideReason: "Neden değiştirdiniz? (isteğe bağlı)",
        confirmedCaption: "Sizin tarafınızdan onaylandı",
      },
      actions: {
        confirmNext: "Onayla ve ilerle",
        rateNext: "Değerlendir ve ilerle",
        saveNext: "Kaydet ve ilerle",
        prev: "Önceki",
        next: "Sonraki",
        jump: "Transkripte git",
      },
      rail: {
        statements: "İfadeler",
        reviewed: "{{done}}/{{total}}",
        stepper: "İfade {{index}} / {{total}}",
        wrapup: "Tamamlama",
        wrapupHint: "C1 nitelikleri, güçlü yönler ve gelişim alanları",
        lowConfidence: "Düşük güven",
      },
      evidence: {
        title: "Kanıt",
        kept: "{{total}} alıntıdan {{kept}} tanesi tutuldu",
        why: "Yapay zekâ bunu neden böyle değerlendirdi",
        supports: "destekliyor",
        contradicts: "çelişiyor",
        showMore: "{{count}} tane daha göster",
        showLess: "Daha az göster",
        noTimestamp: "Zaman damgası yok",
        unrecorded: "Oturumda zaman damgası kaydedilmedi.",
        none: "Yapay zekâ bu ifade için kanıt bulamadı. Kendi notlarınıza göre değerlendirin.",
        allRejected: "Tüm destekleyici kanıtları reddettiniz — değerlendirmeyi yeniden gözden geçirin.",
        speakerMismatch: "Bu satırda konuşan koç değil",
        feedbackDisabled: "İlgililik geri bildirimi için analizi yeniden çalıştırın.",
        confidence: "%{{percent}} güven",
        precision: "Alıntıların %{{percent}} kadarı şimdiye dek tutuldu",
      },
      relevance: {
        relevant: "İlgili",
        notRelevant: "İlgili değil",
        reasonPrompt: "Neden değil?",
        rejected: "Reddedildi · {{reason}}",
        reopen: "Yeniden açmak için dokunun",
        reason: {
          wrong_statement: "Yanlış ifade",
          misquoted: "Yanlış alıntılanmış",
          not_the_coach: "Konuşan koç değil",
          too_weak: "Çok zayıf",
          other: "Diğer",
        },
      },
      transcript: {
        title: "Transkript",
        around: "{{turn}}. konuşma sırası çevresi",
        earlier: "Öncekileri yükle",
        later: "Sonrakileri yükle",
        search: "Yüklenen satırlarda ara",
        noMatches: "Yüklenen satırlarda eşleşme yok.",
        copyTimestamp: "Zaman damgasını yoruma ekle",
        copied: "Zaman damgası yorumunuza eklendi.",
        unavailable: "Bu oturum için transkript mevcut değil.",
        close: "Transkripti kapat",
      },
      keyboard: {
        hint: "↑ ↓ gez · 1–5 değerlendir · Enter onayla · E kanıt · T transkript",
      },
    },
    common: {
      close: "{{title}} penceresini kapat",
    },
    title: 'Mentiler',
    subtitle: 'Oturumları inceleyin, öncelikleri belirleyin ve unvan belgelerini hazırlayın.',
    newEngagement: 'Yeni menti',
    empty: 'Henüz menti yok',
    emptyBody: 'Oturumları incelemeye başlamak için bir menti ekleyin.',
    loadError: 'Süreçler yüklenemedi.',
    back: 'Tüm mentiler',
    mockBanner: 'Demo verisi — bu derlemede mentor form API’si taklit ediliyor.',
    level: 'Seviye',
    status: {
      active: 'Aktif',
      completed: 'Tamamlandı',
      archived: 'Arşivlendi',
    },
    list: {
      sessions: '{{count}} görüşme',
      sofsFinal: '{{count}} form kesinleşti',
      crfDraft: 'YİF taslak',
      crfFinal: 'YİF kesin',
      rulesOk: 'ICF kuralları sağlandı',
      rulesIncomplete: 'ICF kuralları eksik',
    },
    create: {
      title: 'Yeni menti',
      menteeName: 'Menti adı',
      menteeNamePlaceholder: 'Formlarda görünecek tam ad',
      menteeEmail: 'Menti e-postası (isteğe bağlı)',
      menteeEmailPlaceholder: 'ad@ornek.com',
      targetLevel: 'Unvan seviyesi',
      language: 'Form dili',
      startedAt: 'Başlangıç tarihi',
      submit: 'Menti ekle',
      cancel: 'Vazgeç',
      nameRequired: 'Menti adını girin.',
      error: 'Süreç oluşturulamadı.',
    },
    detail: {
      invalidHours: "0 veya 1,5 gibi negatif olmayan bir saat değeri girin.",
      contact: 'Danışan ve süreç',
      hours: 'Mentor koçluk saatleri',
      individualHours: 'Birebir saat',
      groupHours: 'Grup saati',
      totalHours: 'Toplam saat',
      startedAt: 'İlk görüşme',
      endedAt: 'Son görüşme',
      previousMentor: 'Önceki mentor koç',
      printedName: 'Adınız (imza için)',
      notes: 'Notlar',
      save: 'Değişiklikleri kaydet',
      saved: 'Değişiklikler kaydedildi.',
      saveError: 'Değişiklikler kaydedilemedi.',
      loadError: 'Bu süreç yüklenemedi.',
    },
    rules: {
      title: 'ICF gereklilikleri',
      subtitle: 'ICF mentor koçluk hacim kurallarına göre kontrol edilir. Uyarılar işlemi engellemez.',
      totalHours: 'En az 10 saat mentor koçluk',
      individualHours: 'En az 3 saat birebir',
      observedSessions: 'En az 3 gözlenen görüşme',
      engagementSpan: 'İlk ve son mentor koçluk görüşmesi arasında en az üç ay (ICF: 12 tam hafta)',
      sessionMetadata: 'Dahil edilen her görüşmede tarih ve süre var',
      c1Verified: 'İnceleme formunda Yetkinlik 1 doğrulandı',
      pass: 'Sağlandı',
      fail: 'Henüz değil',
    },
    sessions: {
      unsupportedFile: "Bir ses kaydı (MP3, M4A, WAV, MP4, OGG, WebM, FLAC veya AAC) ya da PDF, TXT veya DOCX transkript seçin.",
      uploadComplete: "Görüşme analiz edildi. Gözlem formu incelemeye hazır.",
      editSof: "Gözlemi düzenle",
      title: 'Gözlenen görüşmeler',
      number: '#',
      date: 'Tarih',
      modality: 'Biçim',
      duration: 'Süre',
      source: 'Kaynak',
      sofStatus: 'Gözlem formu',
      includeInCrf: 'YİF’te',
      actions: 'İşlemler',
      empty: 'Henüz görüşme yok. Bir kayıt yükleyin veya canlı gözlediğiniz bir görüşmeyi ekleyin.',
      uploadSession: 'Görüşme yükle',
      addManual: 'Manuel görüşme ekle',
      downloadSof: 'Gözlem formunu indir (PDF)',
      finalize: 'Kesinleştir',
      reopen: 'Yeniden aç',
      remove: 'Kaldır',
      removeConfirmTitle: 'Görüşmeyi kaldır',
      removeConfirmBody: 'Bu işlem görüşmeyi ve gözlem formunu süreçten kaldırır.',
      notStarted: 'Başlamadı',
      minutes: '{{count}} dk',
      uploadError: 'Analiz başlatılamadı.',
      addPromptTitle: 'İlk oturumunu ekle',
      addPromptBody: 'Bir menti oturumunun kaydını ya da transkriptini yükle; gözlem formu ondan otomatik hazırlanır. Kayıt yoksa oturumu elle de girebilirsin.',
      addPromptUpload: 'Kayıt ya da transkript yükle',
      addPromptManual: 'Elle gir',
      uploadStarted: 'Analiz başlatıldı. Görüşme, analiz tamamlandığında bu tabloda görünecek.',
      needsLevelAnalysis: '{{level}} analizi gerekli',
      levelMismatch: "Bu görüşmenin analizi {{analysisLevel}} düzeyinde değerlendirildi, ancak bu sürecin hedef düzeyi {{targetLevel}}. Gözlem formunu oluşturmak için görüşmeyi {{targetLevel}} düzeyinde analiz edin.",
      levelMismatchUnknown: "Bu görüşmenin analizi farklı bir düzeyde değerlendirildi, ancak bu sürecin hedef düzeyi {{targetLevel}}. Gözlem formunu oluşturmak için görüşmeyi {{targetLevel}} düzeyinde analiz edin.",
    },
    modality: {
      in_person: 'Yüz yüze',
      virtual: 'Çevrim içi',
      recorded: 'Kayıttan',
    },
    source: {
      mcai: 'Analiz edildi',
      manual: 'Manuel',
    },
    formStatus: {
      draft: 'Taslak',
      final: 'Kesin',
    },
    manual: {
      invalidDate: "Geçerli bir görüşme tarihi girin (YYYY-MM-DD).",
      invalidDuration: "Dakika olarak pozitif bir tam sayı girin.",
      editTitle: "Görüşme gözlemini düzenle",
      title: 'Manuel görüşme ekle',
      subtitle: 'Canlı veya uygulama dışında gözlediğiniz görüşmeler için. Her ifadeyi resmi ölçekte değerlendirin.',
      sessionDate: 'Görüşme tarihi',
      modality: 'Biçim',
      duration: 'Süre (dakika)',
      c1Title: 'Yetkinlik 1 nitelikleri',
      c1Note: 'Herhangi biri Gözlemlenmedi işaretlenirse, diğer yetkinliklerden bağımsız olarak kesin vetodur.',
      comment: 'Yorum (isteğe bağlı)',
      commentPlaceholder: 'Bu ifade için kanıt veya not',
      progress: '{{total}} ifadeden {{rated}} tanesi değerlendirildi',
      save: 'Görüşmeyi kaydet',
      cancel: 'Vazgeç',
      error: 'Manuel görüşme kaydedilemedi.',
      unrated: 'Değerlendirilmedi',
    },
    crf: {
      useDraft: "Oluşturulan taslağı kullan (mevcut geri bildirimi değiştir)",
      title: 'Yeterlilik İnceleme Formu',
      subtitle: 'Dahil edilen tüm gözlem formlarının birleşimi. Herhangi birinde Karşılıyor/Aşıyor (veya Gözlemlendi) yeterlidir.',
      noSessions: 'İnceleme formunu hesaplamak için en az bir gözlenen görüşme ekleyin.',
      gateSummary: '{{code}} · {{total}} ifadeden {{required}} gerekli · {{demonstrated}} gösterildi · {{short}} eksik',
      gateMet: '{{code}} · {{total}} ifadeden {{required}} gerekli · {{demonstrated}} gösterildi · sağlandı',
      statementGrid: 'İfadeler',
      demonstratedIn: 'Şu görüşmelerde gösterildi: {{sessions}}',
      notDemonstrated: 'Henüz gösterilmedi',
      naEverywhere: 'Gözlem fırsatı oluşmadı',
      c1Title: 'Yetkinlik 1 doğrulaması',
      c1Verified: 'Bu danışan için Yetkinlik 1’i doğruluyorum',
      c1Notes: 'Notlar (gizlilik, sınırlar, çıkar çatışmaları)',
      feedbackTitle: 'Kümülatif geri bildirim',
      feedbackSubtitle: 'Görüşmeler boyunca kanıtlanmış üç güçlü yön ve üç gelişim alanı.',
      strengths: 'Güçlü yönler',
      development: 'Gelişim alanları',
      slotCompetency: 'Yetkinlik',
      slotStatement: 'Geri bildirim verilecek ifade',
      slotComments: 'Yorumlar',
      slotEmpty: 'Boş alan',
      generateDraft: 'Taslak oluştur',
      regenerate: 'Yeniden oluştur',
      generating: 'Görüşmeler arası geri bildirim taslağı hazırlanıyor…',
      narrativeQueued: 'Kümülatif geri bildirim taslağı oluşturuluyor — birkaç saniye sürebilir.',
      narrativeError: 'Taslak oluşturulamadı.',
      verdict: 'Genel karar',
      verdictDemonstrated: 'Her yetkinlik alanında yeterlilik göstermiştir',
      verdictNotYet: 'Her yetkinlik alanında henüz yeterlilik göstermemiştir',
      verdictComputed: 'Yukarıdaki eşiklerden hesaplandı',
      verdictOverride: 'Hesaplanan kararı geçersiz kıl',
      verdictOverrideWarning:
        'Hesaplanan kararı geçersiz kılıyorsunuz. Yukarıdaki eşik tablosu bu sonucu desteklemiyor.',
      save: 'İnceleme formunu kaydet',
      saved: 'İnceleme formu kaydedildi.',
      saveError: 'İnceleme formu kaydedilemedi.',
      finalize: 'YİF’i kesinleştir',
      reopen: 'YİF’i yeniden aç',
      downloadPdf: 'YİF’i indir (PDF)',
      emailToMentee: 'Danışana e-posta gönder',
      locked: 'Bu kayıt kesinleşti ve salt okunur.',
      c2NoteAccMcc: 'Bu seviyede Yetkinlik 2’nin davranışsal ifadesi yoktur.',
      c2NotePcc: 'Yetkinlik 2, PCC işaretçileri {{markers}} üzerinden temsil edilir — yalnızca görünümdür, iki kez sayılmaz.',
    },
    finalize: {
      mcsActive: "Bu unvan düzeyine uygun, geçerli bir MCS uzmanlığına sahibim.",
      noConflict: "Koçluk alan kişiyle akrabalığım veya bilinen bir çıkar çatışmam yok.",
      requirementsUnderstood: "Mentor koçluk gerekliliklerini okudum ve anladım.",
      feedbackReviewed: "Koçluğu şahsen gözlemleyip değerlendirdim; geri bildirimi ve kişinin yansımalarını kendisiyle eş zamanlı olarak gözden geçirdim.",
      sharingPermission: "Bu formu ICF ile paylaşma iznim var.",
      preReflection: "İnceleme öncesi danışan yansıması",
      postReflection: "İnceleme sonrası danışan yansıması",
      completionRequired: "İmzalamadan önce iki yansıma özetini doldurun ve tüm beyanları onaylayın.",
      attestation: "Bu değerlendirmeyi ve gerekli geri bildirimi koçluk alan kişiyle şahsen gözden geçirdiğimi ve yazdığım adımla bu formu imzalamayı amaçladığımı onaylıyorum.",
      title: 'Kesinleştir ve imzala',
      body: 'Kesinleştirmek kaydı kilitler. Daha sonra yeniden açabilirsiniz; bu işlem kayıt altına alınır.',
      printedName: 'Ad soyad',
      printedNamePlaceholder: 'Tam adınızı yazın',
      date: 'Tarih',
      warningsTitle: 'Şu ICF gereklilikleri henüz sağlanmadı:',
      confirm: 'Kesinleştir',
      cancel: 'Vazgeç',
      nameRequired: 'İmzalamak için adınızı yazın.',
      error: 'Kayıt kesinleştirilemedi.',
      reopenConfirmTitle: 'Kaydı yeniden aç',
      reopenConfirmBody: 'Kayıt yeniden düzenlenebilir hale gelir ve bu işlem denetim kaydına yazılır.',
    },
    email: {
      title: 'Danışana e-posta gönder',
      recipient: 'Alıcı',
      noRecipient: 'Önce sürece bir danışan e-postası ekleyin.',
      documents: 'Belgeler',
      crf: 'Yeterlilik İnceleme Formu',
      sofFor: 'Gözlem formu — {{number}}. görüşme',
      send: 'Gönder',
      cancel: 'Vazgeç',
      sent: 'Belgeler {{email}} adresine gönderildi.',
      error: 'Belgeler gönderilemedi.',
      selectOne: 'En az bir belge seçin.',
    },
    toast: {
      legacyPdf: "Bu eski imzalı formu dışa aktarmadan önce yeniden açıp incelemeniz ve tekrar imzalamanız gerekiyor.",
      downloadError: 'PDF indirilemedi.',
    },
    privateMentee: 'Gizli danışan',
    retry: 'Tekrar dene',
    statusFlow: {
      title: 'Süreç durumu',
      markCompleted: 'Tamamlandı olarak işaretle',
      archive: 'Arşivle',
      reactivate: 'Yeniden etkinleştir',
      confirmCompleteTitle: 'Bu süreç tamamlandı olarak işaretlensin mi?',
      confirmCompleteBody: 'Süreç Tamamlananlar listesine taşınır. Formlar erişilebilir kalır ve daha sonra yeniden etkinleştirebilirsiniz.',
      confirmArchiveTitle: 'Bu süreç arşivlensin mi?',
      confirmArchiveBody: 'Arşivlenen süreçler salt okunurdur. İstediğiniz zaman yeniden etkinleştirebilirsiniz.',
      confirmReactivateTitle: 'Bu süreç yeniden etkinleştirilsin mi?',
      confirmReactivateBody: 'Süreç Aktif listesine geri döner ve yeniden düzenlenebilir hale gelir.',
      changed: 'Durum güncellendi.',
      error: 'Süreç durumu güncellenemedi.',
      archivedNotice: 'Bu süreç arşivlenmiş ve salt okunur. Değişiklik yapmak için yeniden etkinleştirin.',
      completedNotice: 'Bu süreç tamamlandı olarak işaretlendi.',
    },
    filters: {
      label: 'Göster',
      all: 'Tümü',
      active: 'Aktif',
      completed: 'Tamamlanan',
      archived: 'Arşivlenen',
      emptyFiltered: 'Bu filtreye uyan süreç yok.',
    },
    sessionMeta: {
      title: 'Seans bilgilerini düzenle',
      subtitle: 'Seans Gözlem Formuna kaydedilen tarih, yöntem ve süre.',
      editAction: 'Bilgileri düzenle',
      save: 'Bilgileri kaydet',
      cancel: 'Vazgeç',
      saved: 'Seans bilgileri kaydedildi.',
      error: 'Seans bilgileri kaydedilemedi.',
    },
    overrides: {
      hint: 'Hesaplanan sonucu değiştirmek için bir ifadeye dokunun. Değişiklikler anında kaydedilir ve eşikler yeniden hesaplanır.',
      badge: 'Mentor değişikliği',
      reset: 'Hesaplanan değere dön',
      saved: 'Değişiklik kaydedildi.',
      error: 'Değişiklik kaydedilemedi.',
    },
    validation: {
      invalidEmail: 'Geçerli bir e-posta adresi girin.',
      invalidDate: 'Tarihler YYYY-AA-GG biçiminde olmalıdır.',
      menteeNameRequired: 'Danışan adı zorunludur.',
    },
    overviewLoadError: 'Süreç özeti yüklenemedi.',
  },
  jobs: {
    errors: {
      analysis_failed: 'Analiz tamamlanamadı. Sizden ücret alınmadı. Lütfen tekrar deneyin.',
      transcription_failed: 'Transkripsiyon tamamlanamadı. Lütfen tekrar deneyin.',
      worker_lost: 'Bu işlem beklenmedik şekilde durdu. Sizden ücret alınmadı. Lütfen tekrar deneyin.',
      timed_out: 'Bu işlem çok uzun sürdüğü için durduruldu. Sizden ücret alınmadı. Lütfen tekrar deneyin.',
      not_started: 'Bu işlem zamanında başlamadı. Sizden ücret alınmadı. Lütfen tekrar deneyin.',
      cancelled: 'İptal edildi.',
      no_credits: 'Krediniz kalmadı. Lütfen kredi satın alın.',
      provider_unavailable: 'Bizim tarafımızda geçici bir sorun var. Sizden ücret alınmadı. Lütfen birkaç dakika sonra tekrar deneyin.',
      dispatch_failed: 'Bu işlem başlatılamadı. Sizden ücret alınmadı. Lütfen tekrar deneyin.',
      parent_failed: 'Transkripsiyon başarısız olduğu için analiz çalışmadı. Sizden ücret alınmadı.',
      task_failed: 'İşlem başarısız oldu.',
      invalid_audio: 'Bu ses dosyası işlenemedi. Biçimini ve süresini kontrol edip tekrar deneyin.',
      trial_analysis_used: 'Deneme sürümünüz bir analiz içerir. Planınız başladığında daha fazla analiz açılır.',
    },
    progress: {
      waitingInLine: 'Hâlâ sırada bekliyor. Yalnızca bir kez ücretlendirileceksiniz.',
      waitingInLineTranscription: 'Hâlâ sırada bekliyor. Yüklemeniz güvende.',
      lostTrack: 'Bu işlemin durumunu takip edemiyoruz. Hâlâ çalışıyor olabilir.',
      keepWaiting: 'Beklemeye devam et',
      checkAgain: 'Tekrar kontrol et',
      checking: 'Kontrol ediliyor...',
      tryAgain: 'Tekrar dene',
    },
  },
  errorBoundary: {
    title: 'Bir şeyler ters gitti',
    screenBody: 'Bu ekranda beklenmeyen bir hata oluştu. Verilerin güvende. Tekrar dene ya da ana sayfaya dön.',
    appBody: 'Uygulamada beklenmeyen bir hata oluştu. Verilerin güvende. Devam etmek için sayfayı yenile.',
    tryAgain: 'Tekrar dene',
    reload: 'Yenile',
    goToDashboard: 'Ana sayfaya dön',
  },
  sampleReportPolicy: {
    observedChip: 'Gözlemlendi',
    c1Caption: 'Etik ön koşul · seviyelendirilmez',
    ethicsConcernChip: 'Etik kaygı',
    c1EthicsConcernCaption: 'Etik ön koşul · incelemeye işaretlendi · seviyelendirilmez',
    c2Caption: 'ICF sınavında değerlendirilir · seviyelendirilmez',
    c1ObservedNote: 'Gözlemlendi. Bu görüşmede etik uygulamalara ve koçluk duruşuna uygun davranışlar gözlemlenmiş, etik ilkelere aykırı bir davranış gözlemlenmemiştir. Etik uygulama bir beceri düzeyi değil, karşılanması gereken bir ön koşuldur; bu nedenle bu yetkinlik seviyelendirilmez ve genel seviye kararını etkilemez.',
    c2ExamOnlyNote: 'Bu yeterlilik alanında davranışsal ifade bulunmamaktadır. Koçluk zihin yapısını sürdürmek — açık, meraklı, esnek ve müşteri merkezli kalmak — koçun mesleki yolculuğu boyunca gelişir ve tek bir kayıtlı görüşme üzerinden değerlendirilemez. Bu nedenle bu yetkinlik seviyelendirilmez ve genel seviye kararını etkilemez.',
  },
  paymentFailedBanner: {
    title: 'Son ödemeniz başarısız oldu — ödeme yönteminizi güncelleyin',
    body: 'Ödemeyi yeniden denerken erişiminiz devam ediyor. Aboneliğinizi korumak için kartınızı güncelleyin.',
    cta: 'Ödeme yöntemini güncelle',
    dismiss: 'Kapat',
    portalError: 'Fatura portalı açılamadı. Lütfen tekrar deneyin.',
  },
  entitlementLocks: {
    seePlans: 'Planları gör',
    chatTitle: 'Sohbet için aktif bir abonelik gerekir',
    chatBody: 'Kredileriniz yeni analizler ve geçmiş raporlarınız için geçerli olmaya devam ediyor. Takip soruları sormak için abone olun.',
    chatPlaceholder: 'Sohbet için aktif bir abonelik gerekir',
    chatReassessBody: 'Kredilerinizle bu oturumu 1 kredi karşılığında yeniden değerlendirebilirsiniz: PCC markerlarının kontrolünü ya da oturumun yeniden analizini isteyin. Diğer sorular için abonelik gerekir.',
    chatReassessPlaceholder: 'Bu oturumu yeniden değerlendirin (1 kredi)',
    reassessSuggestionMarkers: 'PCC markerlarını kontrol et',
    reassessSuggestionReanalyze: 'Bu oturumu yeniden analiz et',
    mentorTitle: 'Mentorluk süreçleri için Mentor Coach planı gerekir',
    mentorBody: 'Geçmiş raporlarınız ve kredileriniz erişilebilir kalır. Danışanları incelemek ve ICF formlarını doldurmak için Mentor Coach planına abone olun.',
    mcsTitle: 'MCS hazırlığı için Mentor Coach planı gerekir',
    mcsBody: 'ICF Mentor Koç Uzmanlığına hazırlanmak için Mentor Coach planına abone olun.',
  },
  emailChange: {
    confirming: 'Yeni e-posta adresiniz onaylanıyor…',
    successTitle: 'E-posta adresiniz güncellendi',
    successBody: 'Güvenliğiniz için tüm cihazlarda oturumunuzu kapattık. Yeni e-posta adresinizle tekrar giriş yapın.',
    needsLoginTitle: 'Onaylamak için giriş yapın',
    needsLoginBody: 'Bu cihazda mevcut e-posta adresinizle giriş yapın, ardından onay bağlantısını tekrar açın.',
    invalidTitle: 'Bu bağlantı geçersiz veya süresi dolmuş',
    invalidBody: 'E-posta değişikliğini profilinizden yeniden isteyin. Bağlantı 2 saat geçerlidir ve yalnızca isteği yapan hesapta çalışır.',
    failedTitle: 'E-postanızı onaylayamadık',
    failedBody: 'Bizim tarafımızda bir sorun oluştu. Lütfen biraz sonra bağlantıyı tekrar açın.',
    signIn: 'Giriş yap',
    backToApp: 'Uygulamaya dön',
  },
  chatLibrary: {
    errors: {
      sendLimitReached: 'Şimdilik kullanım limitine ulaştın. Daha sonra tekrar dene ya da planını kontrol et.',
      sendNeedsSubscription: 'Mevcut planın bunu kapsamıyor. Devam etmek için aboneliğini kontrol et.',
      trialChatLimitReached: 'Deneme sürümüne dahil olan {{limit}} sohbet mesajının hepsini kullandın. Sohbete devam etmek için bir plan seç.',
      trialChatLimitReachedPlanStarts: 'Deneme sürümüne dahil olan {{limit}} sohbet mesajının hepsini kullandın. Planın başladığında sohbet yeniden açılır.',
      documentHasNoTranscript: 'Bu belgede analiz edilecek bir transkript yok. Bunun yerine oturum transkriptini veya kaydını yükle. Sizden ücret alınmadı.',
      followupCreditRequired: 'Bir oturumu hedef seviyede yeniden değerlendirmek 1 analiz kredisi kullanır ve kullanılabilir kredin yok. Devam etmek için planını veya kredilerini kontrol et.',
      sendVerifyEmail: 'Yapay zekâ asistanını kullanmadan önce lütfen e-posta adresini doğrula.',
      sendTooLong: 'Bu mesaj çok uzun. Lütfen kısaltıp tekrar dene.',
      fileTooLarge: 'Bu dosya çok büyük.',
      fileUnsupported: 'Bu dosya türü desteklenmiyor. PDF, DOCX, TXT, RTF ya da görsel kullan.',
      fileNoText: 'Bu dosyadan metin okuyamadık. Farklı bir biçim dene.',
      referenceTooManyFiles: 'Bu sohbette izin verilen en fazla referans dosyası var. Yenisini eklemeden önce birini kaldır.',
      referenceSessionFull: 'Bu sohbette daha fazla referans metni için yer kalmadı. Yenisini eklemeden önce bir referans dosyasını kaldır.',
      noAnalysisToExport: 'Bu sohbette henüz dışa aktarılacak bir analiz yok.',
      removeRecipientFailed: 'Alıcı kaldırılamadı. Lütfen tekrar dene.',
      addRecipientsFailed: 'Alıcılar eklenemedi. Lütfen tekrar dene.',
    },
    library: {
      transcribed: 'Transkript hazır',
      uploadPrompt: 'Yüklemek için aşağıdan bir kayıt ya da transkript seç.',
      loadErrorTitle: 'Kütüphanen yüklenemedi.',
      loadErrorBody: 'Bağlantını kontrol edip tekrar dene. Belgelerin güvende.',
      sharedLoadError: 'Paylaşılan belgeler yüklenemedi.',
      refreshError: 'Liste yenilenemedi. En son yüklenen belgeleri görüyorsun.',
      loadMore: 'Daha fazla yükle ({{shown}} / {{total}} gösteriliyor)',
      loadMoreError: 'Diğer belgeler yüklenemedi.',
      recipientsLoadError: 'Alıcılar yüklenemedi.',
    },
  },
  report: {
    sessionFallback: 'Oturum #{{id}}',
    back: 'Geri',
    eyebrow: 'Oturum raporu',
    overallLevel: 'Genel seviye',
    confidence: 'Güven: {{label}}',
    analyzedOn: 'Analiz tarihi: {{date}}',
    reviewRecommended: 'Yakından bakılması önerilir: kanıtlar iki seviye arasında.',
    excludedNote: 'Bu oturum ICF ilerlemenize dahil edilmiyor. Rapor burada erişilebilir kalır.',
    summaryTitle: 'Özet',
    whyNotHigher: 'Bir üst seviyeye ne taşır',
    nextStepsTitle: 'Sırada ne üzerinde çalışmalı',
    competenciesTitle: 'Yetkinlikler',
    competenciesHint: 'Her yetkinlik kendi seviyesini alır. Genel seviye C3–C8 genelinde ICF karar kurallarını izler; bu yüzden tek bir yetkinlik genel seviyenin üstünde veya altında olabilir.',
    strengthsLabel: 'Güçlü yönler',
    developmentLabel: 'Geliştirilecek',
    patternLabel: 'Dikkat edilecek örüntü',
    showEvidence: 'Kanıtları göster ({{count}})',
    hideEvidence: 'Kanıtları gizle',
    expand: '{{competency}} bölümünü aç',
    collapse: '{{competency}} bölümünü kapat',
    noEvidence: 'Bu yetkinlik için alıntı kaydedilmedi.',
    planTitle: 'Gelişim planı',
    practiceTitle: 'Bir sonraki oturumunda pratik et',
    successIndicator: 'İşe yaradığını şuradan anlarsın: {{text}}',
    mentorQuestionsTitle: 'Mentor oturumuna götür',
    downloadsTitle: 'İndirmeler',
    kindReport: 'Rapor',
    kindChat: 'Sohbet',
    levelShortReadyForPcc: 'PCC hazırlık',
    state: {
      processingTitle: 'Raporunuz hazırlanıyor',
      processingBody: 'Analiz genellikle birkaç dakika sürer. Bu sayfa kendiliğinden güncellenir.',
      noReportTitle: 'Bu oturum için henüz rapor yok',
      noReportBody: 'Analizi yeni başlattıysanız hâlâ sürüyor olabilir. Bir dakika sonra tekrar kontrol edin veya oturumlarınızı açın.',
      failedTitle: 'Analiz tamamlanamadı',
      failedBody: 'Bu rapor hazırlanırken bir sorun oluştu. Tekrar kontrol edin veya analizi oturumlarınızdan yeniden başlatın.',
      legacyTitle: 'Bu rapor sohbette',
      legacyBody: 'Yapılandırılmış rapor görünümünden önce oluşturulan raporlar sohbette gösterilir.',
      lockedTitle: 'Raporlar için aktif bir plan veya kredi gerekir',
      lockedBody: 'Raporlarınızı yeniden açmak için bir plan seçin veya kredi satın alın.',
      loadError: 'Bu rapor yüklenemedi.',
      notFound: 'Bu rapor bulunamadı.',
      checkAgain: 'Tekrar kontrol et',
      openChat: 'Sohbette aç',
      goToSessions: 'Oturumlara git',
      seePlans: 'Planları gör',
    },
    card: {
      title: 'Oturum raporunuz',
      body: 'Genel seviye, her yetkinlik için kanıtlar ve sonraki adımlarınız.',
      open: 'Raporun tamamını aç',
    },
    sample: {
      meta: '{{minutes}} dk oturum · kurgusal katılımcılar: {{coach}} ve {{client}}',
    },
  },
  onboardingProgress: {
    tour: 'Bölüm 1 / 2 · Tanıtım · adım {{current}} / {{total}}',
    intake: 'Bölüm 2 / 2 · Profilin · adım {{current}} / {{total}}',
  },
  planPricing: {
    loading: 'Fiyatlar yükleniyor…',
    error: 'Fiyatlar yüklenemedi.',
    retry: 'Tekrar dene',
    sampleHint: 'Genel seviye, her ICF yetkinliği için kanıt ve bir pratik planı: her analizin size ne verdiğini görün.',
  },
  mentorPlan: {
    eyebrow: 'Mentorluk planın',
    checklistStep: 'Kontrol listesi adımı: {{title}}',
    setupDoneTitle: 'Çalışma alanın hazır',
    setupDoneBody: 'Haftalık pratiğini her yeni mentiyle sürdür.',
  },
  mentorChecklist: {
    title: 'Mentor çalışma alanını kur',
    subtitle: 'Her adım, uygulamada yaptığında işaretlenir.',
    progress: '{{completed}}/{{total}} tamamlandı',
    next: 'Sıradaki',
    done: 'Tamamlandı',
    doItNow: 'Şimdi yap',
    successLabel: 'Tamamlanma ölçütü',
    previewNote: 'Her adım, yaptıkça Mentiler sayfanda ve panonda işaretlenir.',
    revealTitle: 'Kurulum kontrol listen',
    completeTitle: 'Mentor çalışma alanın hazır',
    completeBody: 'Tüm kurulum adımları tamamlandı. Hazır olduğunda bir sonraki mentini ekle.',
    completeCta: 'Yeni menti ekle',
    lockedBody: 'ICF SOF ve CRF formlarıyla Mentiler, Mentor Coach paketinde.',
    lockedCta: 'Mentor Coach paketini gör',
    loadError: 'Kurulum kontrol listen yüklenemedi.',
    retry: 'Tekrar dene',
    steps: {
      create_engagement: {
        title: 'İlk mentini ekle',
        why: 'Menti çalışması, mentinin oturumlarını, unvan hedefini ve formlarını bir arada tutar.',
        done: 'İlk menti çalışması oluşturuldu',
      },
      add_session: {
        title: 'Bir oturum ekle',
        why: 'Gözlem formu bir oturumdan hazırlanır: bir kayıt, bir transkript ya da kendi notların.',
        done: 'İlk oturum eklendi',
      },
      review_sof: {
        title: 'Gözlem taslağını (SOF) incele',
        why: 'Yapay zekânın önerdiği puanları onayla ya da değiştir ve kaydet. Değerlendiren sensin.',
        done: 'İlk gözlem formu kaydedildi',
      },
      finalize_crf: {
        title: 'Yetkinlik değerlendirmesini (CRF) kesinleştir',
        why: 'CRF, mentorluk sürecini ICF ifadelerine göre özetler ve senin imzanı taşır.',
        done: 'İlk CRF kesinleştirildi',
      },
      send_forms: {
        title: 'Formları mentine gönder',
        why: 'Mentin imzalı SOF ve CRF PDF dosyalarını e-postayla alır.',
        done: 'Formlar bir mentiye gönderildi',
      },
      link_cohort: {
        title: 'Bir menti çalışmasını okulunla paylaş',
        why: 'Paylaşmak, menti çalışmasını okul grubuna bağlar; okul ekibi süreci izleyebilir.',
        done: 'Bir menti çalışması okulla paylaşıldı',
      },
    },
  },
} as const;
